{
    "accounting": {
        "accountID": "MAS Account ID",
        "attribute": "Attribute",
        "currentMonth": "Current Month Invoice",
        "editUDF": "Edit User Defined Fields (UDF)",
        "editUDFHeader": "Edit User Defined Fields (UDF) Header",
        "headerText": "Header Text",
        "invoiceType": "Invoice Type",
        "mapToAttribute": "Map to Attribute",
        "monthlyInvoiceHistory": "Monthly Invoice History",
        "print": "Print on Invoice",
        "salesOrder": "Sales Order",
        "selectMonth":"Select Month",
        "attributeFieldsNotEditable": "User Defined Fields mapped to Device Attributes are not editable",
        "udfUpdated": "User Defined Fields (UDF) have been updated",
        "udfHeaderUpdated": "User Defined Header Fields (UDF) have been updated"


    },
    "actions": {
        "addFavorite": "Add to Favorites",
        "addSetpoint": "Add Alarm Setpoint",
        "addAttachment": "Add Attachment",
        "addAttribute": "Add Attribute",
        "addDiagnosticEvent": "Add Diagnostic Event",
        "addCriterion": "Add Criterion",
        "addAttributeCriterion": "Add Attribute Criterion",
        "addTagValueCriterion": "Add Tag Value Criterion",
        "addAlarmCriterion": "Add Alarm Criterion",
        "addGroup": "Add Group",
        "addMemo": "Add Memo",
        "addRecipient":"Add Recipient",
        "addRunTicket": "Add Run Ticket",
        "applyAttribute": "Apply Attribute",
        "applyRule": "Apply Rule",
        "applyTemplate": "Apply Template",
        "changeRegister": "Change Register",
        "changeTagType": "Change Tag Type",
        "changeUom": "Change Unit of Measure",
        "chartview": "Chart View",
        "createFormula": "Create Formula",
        "createNew": "Create New",
        "createRule": "Create Rule",
        "createUom": "Create Unit of Measure",
        "duplicate": "Duplicate",
        "duration": "Duration Options...",
        "delete": "Delete",
        "disable": "Disable",
        "disableNotifications": "Disable Notifications",
        "download": "Download",
        "edit": "Edit",
        "editAlarmSetpoint": "Edit Alarm Setpoint",
        "editRecipient": "Edit Recipient",
        "editUser": "Edit User",
        "enable": "Enable",
        "enableNotifications": "Enable Notifications",
        "export": "Export",
        "excel": "Excel",
        "favorite": "Favorite",
        "gridview": "Grid View",
        "manageTags": "Manage Tags",
        "mapIt": "Map It",
        "maximize": "Maximize",
        "moreActions": "More Actions",

        "appPreferences": "App Preferences",
        "appPreferencesDesc": "Default Views and Display Settings.",
        "menuVisibility": "Menu Visibility",
        "menuVisibilityDesc": "Hide pages you don't use often.",
        "myProfile": "My Profile",
        "myProfileDesc": "User Info, API, and Alarm Notifications.",
        "enableOfflineMode": "Enable Offline Mode",
        "disableOffineMode": "Disable Offline Mode",
        "contactSupportDesc": "24/7 support from Tulsa, OK.",
        "hardwareOrderDec": "Place a hardware order now.",
        "signOut": "Sign out",
        "lastRefresh": "Last Refresh",
        "lastSync":"Last Sync",




        "onScreen": "On-Screen",
        "pdf": "PDF",
        "preview": "Preview",
        "refresh": "Refresh",
        "rename": "Rename",
        "restore": "Restore",
        "run": "Run",
        "setpointThreshold": "Setpoint Thresholds",
        "groupByAlarmState": "Group by Alarm State",
        "demandScan": "Demand Scan",
        "writeDown": "Write Down",
        "cancelCommand": "Cancel Command",
        "submitChanges": "Submit Changes",
        "setAsDefault": "Set as Default",
        "manageComm": "Manage Comm",
        "modifyPermissions": "Modify Permissions",
        "discardChanges": "Discard Changes",
        "filterDevices": "Filter Devices",
        "filterHistory": "Filter History Items",
        "filterRunTickets": "Filter Run Tickets",
        "filterTags": "Filter Tags",
        "filterTankBatteries": "Filter Tank Batteries",
        "filterWells": "Filter Wells",
        "selectDynacards": "Select Dynacards",
        "saveGraphImage": "Save Graph Image",
        "saveQuickGraph": "Save Quick Graph",
        "view": "View",
        "runReport": "Run Report",
        "downloadReport": "Download Report",
        "word": "Word",
        "manageImages": "Manage Image Library",
        "addWaterLossEvent": "Add Water Loss Event",
        "addEvent": "Add Event",
        "linkToSetpoint": "Link to Alarm Setpoint",
        "viewUsageHistory": "View Usage History",
        "newTier": "Add Tier",
        "editTier": "Edit Tier",
        "deleteTier": "Delete Tier",
        "chooseSchedule": "Choose an Alarm Schedule",
        "editScheduledNotification": "Edit Scheduled Notification",
        "deleteScheduleNotification": "Remove Scheduled Notification",
        "editSecurityPermissions": "Edit Security Permissions",
        "newSecurityPermissions": "New Security Permissions",
        "sendLoginEmail": "Send Login Email",
        "goToWellDetails": "Go to Well Details",
        "createNewCommPort": "Create New Comm Port",
        "updateCommManagementTables": "Update Comm Management Tables",
        "notifyMe": "Notify Me",
        "createCommPort": "Create New Comm Port",
        "newScheduledReportTask": "Add Scheduled Report Task",
        "myScheduledReports": "My Scheduled Reports",
        "modifyPollingSchedule": "Modify Polling Schedule",
        "newDataFileImport": "New Import",
        "addDisableSchedule":"Add Disable Schedule",
        "editDisableSchedule":"Edit Disable Schedule",
        "disableObjects": "Disable Objects",
        "bulkDeviceSetup": "Bulk Device Setup",
        "disableAllAlarms": "Disable All Alarms",
        "enableAllAlarms": "Enable All Alarms",
        "changeMasterIdentifier": "Change Master Identifier",
        "settings": "Settings",
        "changeCustomer": "Change Customer",
        "contactSupport": "Contact Support",
        "searchHelp":"Search Help Files",
        "getRemoteSupport": "Get Remote Support Code",
        "recentUpdates":"View Updates",
        "submitProductIdea": "Submit a Product Idea",
        "version": "Version {{version}}",
        "hardwareOrderForm": "Hardware Order Form",
        "termsAndConditions": "Terms & Conditions",
        "privacyPolicy": "Privacy Policy",
        "manageMapFiles": "Manage Map Files"
    },
    "activeAlarmViewer": {
        "actions": {
            "acknowledge": "Acknowledge",
            "acknowledgeNotificationText": "The alarm setpoint has been acknowledged"
        },
        "gridColumnHeaderText": {
            "action": "Action",
            "alarmStatus": "Alarm Status",
            "alarmTime": "Alarm Time",
            "alarmValue": "Alarm Value",
            "currentValue": "Current Value",
            "objectName": "Object Name",
            "groupPath": "Group",
            "tagName": "Tag Name"
        },
        "tabText": "Active Alarms"
    },
    "adminReports": {
        "userID": "User ID",
        "userLogin": "User Login",
        "firstName": "First Name",
        "lastName": "Last Name",
        "phoneNumber": "Phone Number",
        "email": "Email",
        "companyName": "Company Name",
        "jobFunction": "Job Function",
        "jobTitle": "Job Title",
        "organization": "Organization",
        "userStatus": "User Status",
        "latestActivity": "Latest Activity",
        "scadaLynx": "Last SCADALynx Activity",
        "eLynxDesktop": "Last eLynx Desktop Activity",
        "eLynxMobile": "Last eLynx Mobile Activity",
        "publicApi": "Last Public API Activity"
    },

    "alarm": "Alarm",
    "alarmDashboard": {
        "alarmEndingReason": "Alarm Ending Reason",
        "alarmNotifications": "Alarm Setpoint Activity",
        "alarmTimestamp": "Alarm Timestamp",
        "alarmReport": {
            "gotoReport": "Go to Alarm Notification Report?",
            "text": "Would you like to leave the Alarm Dashboard and go to the Alarm Notifications Report?"
        },
        "assignedTags": "Assigned Tags",
        "clearTimestamp": "Clear Timestamp",
        "notifications": "Notifications",
        "top5Setpoints": "Top 5 Alarm Setpoints",
        "top5Objects": "Top 5 Alarm Objects",
        "top5Recipients": "Top 5 Alarm Recipients",
        "alarmSetpoints": "Alarm Setpoints",
        "alarmObjects": "Alarm Objects",
        "alarmRecipients": "Alarm Recipients",
        "noData": "No alarm notification data to display",
        "moreInfo": "More Info",
        "notificationTypes": "Notification Types",
        "notificationsByTypes": "Notifications by Types",
        "objectName": "Object Name",
        "recipient": "Recipient",
        "text": "Text",
        "email": "Email",
        "voiceCallout": "Voice Callout",
        "title": "{{duration}} Notifications",
        "setpoints": "Setpoints",
        "object": "Object"

    },
    "alarmNotificationReports": {
        "acknowledged": "Acknowledged",
        "acknowledgedBy": "Acknowledged By",
        "acknowledgedTimestamp": "Acknowledged Timestamp",
        "alarmEndingReason": "Alarm Ending Reason",
        "device": "Device",
        "tag": "Tags",
        "setpointMessage": "Alarm Setpoint Message",
        "alarmTimestamp": "Alarm Notification Timestamp",
        "cleartimestamp": "Clear Notification Timestamp",
        "clearMessage": "Clear Message",
        "setpoint": "Alarm Setpoint",
        "recipients": "Recipients",
        "hourscurrentlyinalarm": "Hours Currently In Alarm",
        "instructionTitle": "The Alarm Notification Report provides details concerning alarm notifications in the specified organization.",
        "runReportHint": "Select the desired time frame, then click the Run Report Button to view the results.",
        "reportname": "Alarm Notification Report",
        "step1": "1. Specify the start and stop dates for the report",
        "step2": "2. Specify how you'd like the report results to be delivered to you",
        "step3": "3. Click the 'Run Report' button",
        "additionalInformation": "* You can wait for the report to run and the results to be displayed, on-screen, or you can execute the report and be notified when the results are ready.",
        "dateMessage": "Start Date and End Date should be with in a range of 5 days.",
        "nodataMessage": "No data has been found for the period that has been selected."
    },
    "alarmSetpointList": {
        "acknowledgeNotificationText": "The alarm setpoint has been acknowledged",
        "acknowledgementText": "Acknowledged via {{source}} by {{alarmAcknowledgedBy}} on {{timestamp}}",
        "valueText": "Value is {{currentValueText}} at {{timestamp}}",
        "lastAlarmText": "Last alarm: {{lastAlarmTimestamp}}",
        
        "valueAlarmStateText": "Alarm ({{currentValueText}} {{currentUnit}})",
        "valueAcknowledgedStateText": "Alarm / Acknowledged ({{currentValueText}} {{currentUnit}})",
        "valueNormalStateText": "Normal ({{currentValueText}} {{currentUnit}})",

        "timeAlarmStateText": "Alarm ({{currentTimeText}})",
        "timeAcknowledgedStateText": "Alarm / Acknowledged ({{currentTimeText}})",
        "timeNormalStateText": "Normal ({{currentTimeText}})",

        "currentState": "Current State: ",
        "disabledNotificationText": "A disabled schedule was successfully created for the Alarm Setpoint",
        "disabledUntilText": "Disabled until {{timestamp}}",
        "enabledNotificationText": "The Alarm Setpoint has been re-enabled",
        "stateCategory": {
            "acknowledged": "Acknowledged Alarm Setpoints",
            "disabled": "Disabled Alarm Setpoints",
            "inAlarm": "Alarm Setpoints in Alarm",
            "notInAlarm": "Alarm Setpoints Not in Alarm",
            "unknown": "Unknown Category"
        },
        "itemMenu": {
            "acknowledgeSetpoint": "Acknowledge",
            "enableSetpoint": "Enable Alarm Setpoint",
            "disableSetpoint": "Disable Alarm Setpoint",
            "editDisableSchedule": "Edit Disable Schedule",
            "edit":"Edit this Alarm Setpoint",
            "rename": "Rename Alarm Setpoint",
            "unlink": "Unlink Tag from Alarm Setpoint",
            "test": "Test Alarm Setpoint Notifications"
        },
        "options": {
            "filterText": "Filter Text",
            "groupByAlarmState": "Group by Alarm State"
        },

        "disableAllAlarmsConfirmation": {
            "title": "NOTICE: Changes Affect All Alarms",
            "confirmationText1": "This operation will disable all alarms on this device.",
            "confirmationText2": "Disabling all alarms on this device will also acknowledge any alarms that are currently active and in an unacknowledged state.",
            "confirmationText3": "Are you sure you want to continue?",
            "yesButtonText": "Yes, Continue",
            "noButtonText": "No, Go Back"
        },
        "disableAllAlarmsAcknowledge": "Disabled schedules were successfully created for all Alarm Setpoints",
        "enableAllAlarmsConfirmation": {
            "title": "NOTICE: Changes Affect All Alarms",
            "confirmationText1": "This operation will enable all alarms on this device, including any that were disabled by other users.",
            "confirmationText2": "Are you sure you want to continue?",
            "yesButtonText": "Yes, Continue",
            "noButtonText": "No, Go Back"
        },
        "enableAllAlarmsAcknowledge": "The Alarm Setponts have been re-enabled."
    },
    "alarmSetpointReport": {
        "setpointName": "Alarm Setpoint Name",
        "setpointOperator": "Alarm Setpoint Operator",
        "setpointValue": "Alarm Setpoint Value",
        "notifyonAlarm": "Notify On Alarm",
        "notifyonNormal": "Notify On Normal",
        "device": "Device",
        "tag": "Tag",
        "schemeDefinition": "Scheme Definition",
        "notificationListName": "NotificationList Name",
        "notificationListRecipientList": " NotificationList Recipient List",
        "directrecipientlist": "Direct Recipient List",
        "userFirstName": "User First Name",
        "userLastName": "User Last Name",
        "excludeinactiveorhiddenDevice": "Exclude Inactive/hidden devices",
        "includeinactiveorhiddenDevice": "Include Inactive/hidden devices",
        "nodata": {
            "title": "No data",
            "text": "There is no alarm setpoint data for the current organization"
        }

    },
    "apiManagement": {
        "apiAccessConfigured": "Your account has been configured for API access.",
        "APIAccessGranted": "Your API access has been created.",
        "apiAccessNotConfigured": "Your account has not yet been configured for API access.  If you would like access to eLynx API, please use the button below to request access.<br/><br/>Your request will be sent to an Administrator for approval.  Once approved, you will receive an email with information on accessing data using the eLynx API.",
        "copy": "Copy",
        "regenerate": "Regenerate",
        "renew": "Renew",
        "revoke": "Revoke",
        "primaryKey": "Primary Key",
        "primaryKeyCopied": "Primary Key copied to clipboard",
        "primaryExpiresOn": "Key expires on: {{ts}}",
        "primaryExpiredOn": "Primary Key/Secondary Key expired on: {{ts}}",
        "regeneratePrimaryKeySent": "Your request to regenerate your primary API key has been sent.",
        "regeneratePrimaryKeyUpdated": "Your API primary key has been regenerated.",
        "regenerateSecondaryKeySent": "Your request to regenerate your secondary API key has been sent.",
        "regenerateSecondaryKeyUpdated": "Your API secondary key has been regenerated.",
        "removeAPIAccess": "Remove API Access",
        "removeAPIAccessSuccess": "Your API access has been removed.",
        "removePrimaryKeySuccess": "Your API primary key has been removed.",
        "removeSecondaryKeySuccess": "Your API secondary key has been removed",
        "renewPrimaryKeySuccess": "Your API primary key has been renewed.",
        "renewSecondaryKeySuccess": "Your API secondary key has been renewed.",
        "requestAPIAccess": "Request API Access",
        "requestAPIKeyMessageSent": "Your request for API Access has been sent to eLynx Support.",
        "secondaryKey": "Secondary Key",
        "secondaryKeyCopied": "Secondary Key copied to clipboard",
        "secondaryExpiresOn": "Key expires on: {{ts}}",
        "secondaryExpiredOn": "Key expired on: {{ts}}"
    },
    "appHeader": {
        "offline": "Offline",
        "search": "Search entire site...",
        "toggleMenu": "Toggle menu",
        "tools": {
            "notifications": "Notifications",
            "messages": "Messages",
            "profile": "Profile",
            "settings": "Settings",
            "help": "Help",
            "maximizeview": "Maximize View"
        }
    },
    "appSettings": {
        "chooseTheme": "Choose a theme",
        "dark": "Dark",
        "light": "Light",
        "settings": "Settings"
    },
    "attachmentDialog": {
        "addTitle": "Add New Attachment",
        "chooseType": {
            "label": "Choose the type of attachment",
            "file": "Choose a file",
            "photo": "Choose or take a photo"
        },
        "description": "Description",
        "editTitle": "Edit Attachment",
        "file": "File",
        "illegalCharacters": "<strong>Note:</strong> File names must not contain the following characters: '#', '%', '&', '*', ':', '<', '>', '?', '\\', '/', ','.",
        "maxAttachmentSizeExceeded": "The selected file exceeds the maximum attachment size of {{maxSizeBytes}} bytes. Please select a smaller file and try again.",
        "maxAttachmentSizeExceededTitle": "Attachment Too Large"
    },
    "attributeSchema": {
        "addOption": "Add Value",
        "allowGroupBy": "This Attribute may be used in Summary Listing for 'Group By'",
        "applyInfoText": "Select an existing Attribute and define the value that will be applied to this {{objectType}}.",
        "attributeOptions": "The following options are what users will have to pick from:",
        "attributeProperties": "Attribute Properties",
        "decimalPlaces": "Decimal Places",
        "delete": "Delete this Attribute",
        "edit": "Edit this Attribute",
        "create": "Create Attribute",
        "createNew": "Create New Attribute",
        "invalidRange": "The number entered must be greater than or equal to {{min}} and less than or equal to {{max}}.",
        "save": "Update Attribute",

        "nameRequired": "An Attribute name is required",
        "nameLength": "The Attribute name cannot be more than 50 characters",

        "valueRequired": "Value is required",
        "noAvailable": "No available Attributes to apply to this {{objectType}} object. Click the 'Create New Attribute' button to add another Attribute or click the 'Cancel' button to close.",
        "nodata": {
            "title": "No Attributes",
            "text": "There are no attributes for the selected organization or that match the filter."
        },
        "novalues": {
            "title": "No Attribute Options",
            "text": "There are no values for the attribute."
        },
        "objectTypeInfo": "Select the object types the attribute may be tied to",
        "steps": {
            "properties": {
                "title": "Properties"
            },
            "usage": {
                "title": "Usage"
            },
            "summary": {
                "title": "Summary"
            }
        },
        "type": "Attribute Value Type",
        "typePrompt": "Select a value option",
        "wholeNumberPlaces": "Whole Number Places",
        "nameUnique": "The attribute name must be unique name.",
        "valueUnique": "The Attribute Option cannot be the same as another Option. Uppercase and lowercase characters are considered to be the same.",
        "viewApplied": "View Applied {{name}}",
        "groupBy": "Group By Allowed",
        "addedCount": "Added:  {{count}}",
        "deletedCount": "Deleted:  {{count}}",
        "updatedCount": "Updated:  {{count}}",
        "noUsage": "This attribute has not been applied to any objects",
        "saveSuccess": "Attribute Schema '{{name}}' and '{{count}}' attribute changes have been saved.",
        "saveSchemaOnlySuccess": "Attribute Schema '{{name}}' has been saved.",
        "objectTypeRequired": "One or more object types must be selected.",
        "filterByValue": "Filter attribute value",
        "remove": {
            "title": "All Objects Removed",
            "text": "This attribute has been removed from all objects. You can now choose to delete it."
        },
        "linked": {
            "title": "Warning: '{{name}}' Attribute Linked to Objects",
            "text": "You must unlink this Attribute from all objects before it can be deleted. Would you like to edit now?",
            "editButton": "Yes, Edit Attribute"
        },
        "deleted": "Attribute '{{name}}' has been deleted.",
        "maxWholeDigits": "This value is limited to {{value}} whole digits",
        "removeAttr": "Remove this attribute"

        

    },
    "auditReporting": {
        "auditAction": {
            "none" : "None",
            "insert": "Insert",
            "update": "Update",
            "delete": "Delete"
        },
        "action": "Action",
        "additionalInfo": "Additional Info",
        "advancedSearch": "Advanced Search",
        "oldValue": "Old Value",
        "newValue": "New Value",
        "parentObjectType": "Parent Object Type",
        "parentObjectName": "Parent Object Name",
        "runReportHint": "Select the desired time frame and max rows, then click the Run Report Button to view and filter the results.",
        "searchText": "Search Text",
        "maxRows": "Max Data Rows",
        "user": "User",
        "maxUserName": "User cannot be greater than 256 characters",
        "objectName": "Object Name",
        "maxObjectName": "User cannot be greater than 64 characters",
        "maxValueText": "The value text cannot be greater than 1024 characters",
        "noData": "There is no data that match the selected filter criteria."
    },
    "badCommsReport": {
        "date": "Date",
        "deviceDisplayName": "Device Display Name",
        "yesterdayCount": "Yesterday Count",
        "dayBeforeYesterday": "Day Before Yesterday",
        "sevenDayAvg": "7 Day Avg",
        "thirtyDayAvg": "30 Day Avg",
        "commAddress": "Comm Address",
        "commIdentifier": "Comm Identifier",
        "reportName": "Bad Comms Report",
        "nodata": {
            "title": "No data",
            "text": "No data has been found for the period that has been selected."
        }
    },
    "buttons": {
        "addFavorite": "Add to Favorites",
        "add": "Add",
        "apply": "Apply",
        "attach": "Attach",
        "back": "Back",
        "basic": "Basic",
        "cancel": "Cancel",
        "clearAll": "Clear All",
        "clearAllVisible": "Clear All Visible",
        "close": "Close",
        "confirm": "Confirm",
        "continue": "Continue",
        "delete": "Delete",
        "dismiss": "Dismiss",
        "display": "Display",
        "download": "Download",
        "edit": "Edit",
        "hide": "Hide",
        "export": "Export",
        "next": "Next",
        "mainMenu": "Main Menu",
        "remove": "Remove",
        "replace": "Replace",
        "retry": "Retry",
        "save": "Save",
        "signIn": "Sign In",
        "okay": "Okay",
        "yes": "Yes",
        "no": "No",
        "select": "Select",
        "selectAll": "Select All",
        "selectAllVisible": "Select All Visible",
        "send": "Send",
        "submit": "Submit",
        "reset": "Reset",
        "update": "Update",
        "view": "View",
        "unhide": "Unhide",
        "upload": "Upload",
        "yesContinue": "Yes, Continue",
        "yesCopy": "Yes, Copy",
        "yesDelete": "Yes, Delete",
        "yesDisable": "Yes, Disable",
        "noCancel": "No, Cancel",
        "yesLink": "Yes, Link",
        "newRecipient": "Add Recipient",
        "editRecipient":"Edit Recipient",
        "newNotificationList": "Add Notification List",
        "editNotificationList": "Edit Notification List",
        "deleteNotificationList": "Delete Notification List",
        "editAlarmScheme":"Edit Alarm Scheme",
        "addAlarmScheme": "Add Alarm Scheme",
        "deleteAlarmScheme": "Delete Alarm Scheme",
        "addAlarmSchedule": "Add Alarm Schedule",
        "editAlarmSchedule": "Edit Alarm Schedule",
        "addLookupList": "Add Lookup List",
        "editLookupList": "Edit Lookup List",
        "saveAsNew": "Save As New",
        "saveChanges": "Save Changes",
        "preview": "Preview",
        "advanced": "Advanced",
        "resetToDefault": "Reset to Default"
    },
    "cameraDialog": {
        "attachmentPreview": "Attachment Preview",
        "attachPhoto": "Attach a Photo"
    },
    "cancelConfirmation": {
        "title": "Are you sure you want to cancel?",
        "yesButtonText": "Yes, Cancel",
        "noButtonText": "No, Go Back",
        "confirmationText": "You are about to exit without saving your changes. Are you sure you want to continue and exit without saving?"
    },
    "category": {
        "allTags": "All Tags",
        "categories": "Categories",
        "summaryListingTags": "Summary Listing Tags",
        "placeholder": "Category",
        "title": "Filter Categories"
    },
    "changeRegister": {
        "valueLessThan": "Value cannot be less than {{value}}",
        "valueGreaterThan": "Value cannot be greater than {{value}}"
    },
    "changeTagType": {
        "tagTypeSelectionText": "Please select a tag type from the following options.",
        "changeTagTypeWarning": "Changing the tag type will change how / if this tag appears in Summary Listing, Reports, Graphs, and other locations throughout the application, are you sure you want to proceed?",
        "tatsInUse": "Currently in use",
        "commonTags": "Common Tags",
        "hourlyTags": "Hourly Tags",
        "dailyTags": "Daily Tags",
        "inUseInfo": "Tags already in use on the current {{objectType}} are shown in red.",
        "noFilterMatch": "There are no tag types that match the text entered in the filter.",
        "usage":"Usage count {{count}}",
        "tagTypeName": "Tag Type Name",
        "saved": "The tag type has been updated.",
        "filter": {
            "current": "Currently in use",
            "common": "Common Tags",
            "hourly": "Hourly Tags",
            "daily": "Daily Tags",
            "label": "Show"
        }
    },
    "colors": {
        "AliceBlue": "Alice Blue",
        "AntiqueWhite": "Antique White",
        "Aqua": "Aqua",
        "Aquamarine": "Aquamarine",
        "Azure": "Azure",
        "Beige": "Beige",
        "Bisque": "Bisque",
        "Black": "Black",
        "BlanchedAlmond": "Blanched Almond",
        "Blue": "Blue",
        "BlueViolet": "Blue Violet",
        "Brown": "Brown",
        "BurlyWood": "Burly Wood",
        "CadetBlue": "Cadet Blue",
        "Chartreuse": "Chartreuse",
        "Chocolate": "Chocolate",
        "Coral": "Coral",
        "CornflowerBlue": "Cornflower Blue",
        "Cornsilk": "Cornsilk",
        "Crimson": "Crimson",
        "Cyan": "Cyan",
        "DarkBlue": "Dark Blue",
        "DarkCyan": "Dark Cyan",
        "DarkGoldenrod": "Dark Goldenrod",
        "DarkGray": "Dark Gray",
        "DarkGreen": "Dark Green",
        "DarkKhaki": "Dark Khaki",
        "DarkMagenta": "Dark Magenta",
        "DarkOliveGreen": "Dark Olive Green",
        "DarkOrange": "Dark Orange",
        "DarkOrchid": "Dark Orchid",
        "DarkRed": "Dark Red",
        "DarkSalmon": "Dark Salmon",
        "DarkSeaGreen": "Dark Sea Green",
        "DarkSlateBlue": "Dark Slate Blue",
        "DarkSlateGray": "Dark Slate Gray",
        "DarkTurquoise": "Dark Turquoise",
        "DarkViolet": "Dark Violet",
        "DeepPink": "Deep Pink",
        "DeepSkyBlue": "Deep Sky Blue",
        "DimGray": "Dim Gray",
        "DodgerBlue": "Dodger Blue",
        "Firebrick": "Firebrick",
        "FloralWhite": "Floral White",
        "ForestGreen": "Forest Green",
        "Fuchsia": "Fuchsia",
        "Gainsboro": "Gainsboro",
        "GhostWhite": "Ghost White",
        "Gold": "Gold",
        "Goldenrod": "Goldenrod",
        "Gray": "Gray",
        "Green": "Green",
        "GreenYellow": "Green Yellow",
        "Honeydew": "Honeydew",
        "HotPink": "Hot Pink",
        "IndianRed": "Indian Red",
        "Indigo": "Indigo",
        "Ivory": "Ivory",
        "Khaki": "Khaki",
        "Lavender": "Lavender",
        "LavenderBlush": "Lavender Blush",
        "LawnGreen": "Lawn Green",
        "LemonChiffon": "Lemon Chiffon",
        "LightBlue": "Light Blue",
        "LightCoral": "Light Coral",
        "LightCyan": "Light Cyan",
        "LightGoldenrodYellow": "Light Goldenrod Yellow",
        "LightGray": "Light Gray",
        "LightGreen": "Light Green",
        "LightPink": "Light Pink",
        "LightSalmon": "Light Salmon",
        "LightSeaGreen": "Light Sea Green",
        "LightSkyBlue": "Light Sky Blue",
        "LightSlateGray": "Light Slate Gray",
        "LightSteelBlue": "Light Steel Blue",
        "LightYellow": "Light Yellow",
        "Lime": "Lime",
        "LimeGreen": "Lime Green",
        "Linen": "Linen",
        "Magenta": "Magenta",
        "Maroon": "Maroon",
        "MediumAquamarine": "Medium Aquamarine",
        "MediumBlue": "Medium Blue",
        "MediumOrchid": "Medium Orchid",
        "MediumPurple": "Medium Purple",
        "MediumSeaGreen": "Medium Sea Green",
        "MediumSlateBlue": "Medium Slate Blue",
        "MediumSpringGreen": "Medium Spring Green",
        "MediumTurquoise": "Medium Turquoise",
        "MediumVioletRed": "Medium Violet Red",
        "MidnightBlue": "Midnight Blue",
        "MintCream": "Mint Cream",
        "MistyRose": "Misty Rose",
        "Moccasin": "Moccasin",
        "NavajoWhite": "Navajo White",
        "Navy": "Navy",
        "OldLace": "Old Lace",
        "Olive": "Olive",
        "OliveDrab": "Olive Drab",
        "Orange": "Orange",
        "OrangeRed": "Orange Red",
        "Orchid": "Orchid",
        "PaleGoldenrod": "Pale Goldenrod",
        "PaleGreen": "Pale Green",
        "PaleTurquoise": "Pale Turquoise",
        "PaleVioletRed": "Pale Violet Red",
        "PapayaWhip": "Papaya Whip",
        "PeachPuff": "Peach Puff",
        "Peru": "Peru",
        "Pink": "Pink",
        "Plum": "Plum",
        "PowderBlue": "Powder Blue",
        "Purple": "Purple",
        "Red": "Red",
        "RosyBrown": "Rosy Brown",
        "RoyalBlue": "Royal Blue",
        "SaddleBrown": "Saddle Brown",
        "Salmon": "Salmon",
        "SandyBrown": "Sandy Brown",
        "SeaGreen": "Sea Green",
        "SeaShell": "Sea Shell",
        "Sienna": "Sienna",
        "Silver": "Silver",
        "SkyBlue": "Sky Blue",
        "SlateBlue": "Slate Blue",
        "SlateGray": "Slate Gray",
        "Snow": "Snow",
        "SpringGreen": "Spring Green",
        "SteelBlue": "Steel Blue",
        "Tan": "Tan",
        "Teal": "Teal",
        "Thistle": "Thistle",
        "Tomato": "Tomato",
        "Turquoise": "Turquoise",
        "Violet": "Violet",
        "Wheat": "Wheat",
        "White": "White",
        "WhiteSmoke": "White Smoke",
        "Yellow": "Yellow",
        "YellowGreen": "Yellow Green",
        "Empty": "Empty"
    },    
    "configurationList": {
        "default": "default",
        "defaultCamelCase": "Default"
    },
    "currentGroup": "Current Group",
    "changePassword": {
        "cancelChange": "You are about to leave Change Password. Are you sure you want to continue and exit without changing your password?",
        "changed": "Your password has been changed",
        "confirmPassword": "Confirm your new password",
        "confirmPasswordError": "This must match your new password",
        "createNewPrompt": "Let's create your new password.",
        "createNewPassword": "Create New Password",
        "createPasswordMessage": "You must create a password in order to continue. Passwords are case sensitive.",
        "currentPassword": "Current Password",
        "demoNotAllowed": "The password cannot be changed for the demo@elynxtech.com account.",
        "emailRequired": "A valid email address is required.",
        "info": "Want to change your password?",
        "newPassword": "New Password",
        "newPasswordError": "The new password must conform to the rules outlined below",
        "passwordExpiredMessage": "Your password has expired.  You must choose a new password in order to continue.",
        "prompt": "First enter your current password.",
        "promptEmail": "First enter your email address.",
        "rule1": "Have at least 8 characters and 3 of the 4 following password elements:",
        "rule2": "Have at least one uppercase character (A-Z).",
        "rule3": "Have at least one lowercase character (a-z).",
        "rule4": "Have at least one numerical character (e.g. 0-9).",
        "rule5": "Have at least one special character (e.g. ! @ # $ &).",
        "ruleTitle": "Your password must:",
        "title": "Change Password",
        "tokenExpired": "This password link has already been used. If you have already set your password, please go to https://app.elynxtech.com and enter in your login information. If you need to set a new password, please use the Forgot Password link from the login page."
    },
    "commManagement": {
        "autoRecoveryEnabled": "Auto Recovery Enabled",
        "cancelEditCommObject":"You're about to cancel editing a comm object without saving your changes. Are you sure you want continue and cancel without saving?",
        "cancelEditProtocolObject":"You're about to cancel editing a protocol object without saving your changes. Are you sure you want continue and cancel without saving?",
        "commObjectEnabled": "Comm Object Enabled",
        "commObjects": "Comm Objects",
        "connectionOption": "Connection Option",
        "currentMonthUsage": "Current Month Usage",
        "description": "Description",
        "devices": "eLynx Devices",
        "direct": "Direct",
        "ip": "IP",
        "maxConnections": "Max Simultaneous Connections",
        "maxConnectionsInfo": "Max simultaneous connections can be between 1 and 60.",
        "name": "Name",
        "notSelected": "Not Selected",
        "noCommObjects": "No Comm Objects",
        "noDevices": "No Devices",
        "noProtocolObjects": "No Protocol Objects",
        "noWells": "No Wells",
        "numberOfAttempts": "Number of Attempts",
        "numberOfAttemptsInfo": "Number of attempts can be between 0 and 32000",
        "port": "Port",
        "portInfo": "Port Range: 0 to 65535",
        
        "primary": "Primary",
        "primaryCommObject": "Primary Comm Object",
        "primaryOnly": "Primary Only",
        
        "priority": "Priority",
        "properties": "Properties",
        "protocol": "Protocol",
        "protocolAddress": "Protocol Address",
        "protocolObjectEnabled": "Protocol Object Enabled",
        "protocolObjects": "Protocol Objects",
        "pollingStats": {
            "thisHourGoodPolls": "This Hour Good Polls (%)",
            "lastHourGoodPolls": "Last Hour Good Polls (%)",
            "yesterdayGoodPolls": "Yesterday Good Polls (%)",
            "todayGoodPolls": "Today Good Polls (%)",
            "totalGoodPolls": "Total Good Polls (%)",
            "secondsSinceComplete": "Seconds Since Complete",
            "unableToRetrieve": "Polling Statistics could not be retrieved at this time."
        },
        "secondary": "Secondary",
        "secondaryCommObject": "Secondary Comm Object",
        "secondaryOnly": "Secondary Only",

        "shared": "Shared",
        "showSecondaryComm": "Show Secondary Comm",

        "simID": "SIM ID (ICCID)",

        "switchToSecondary": "Switch to Secondary on Failure",
        "type": "Type",
        "wells": "Wells",

        "invalidIPOnly": "The IP Address you entered is not valid",
        "invalidIP": "The IP Address you entered is not in the list of available addresses for your account, please contact eLynx Support for assistance.",

        "ipRequired": "Please enter a valid IP Address.",
        "ipNotAvailable": "The IP Address you entered is not in the list of available addresses for your account, please contact eLynx Support for assistance.",
        "ipInUse": "The IP Address you entered already has the specified port in use. Please enter a new IP address or change the specified port.",
        "portRequired": "Please enter a valid Port number.",
        "portInUse": "The Port you entered is already in use for the specified IP address. Please enter a new Port or change the specified IP Address.",
        "portOutOfRange": "The Port you entered is invalid. It must be between 0 and 65535.",

        "nameInUse": "This communications object name already exists.  Please enter a different name.",
        "nameEmpty": "The name cannot be blank",
        "descriptionEmpty": "The description cannot be blank",
        "nameInvalidChar": "The '\\, ~, .' characters are not allowed.",
        
        "maxConnectionsInvalid": "Enter a number between 1 and 60",
        "numberOfAttemptsInvalid": "Enter a number between 0 and 32000",

        "rebuildDialog": {
            "title": "Update Comm Management Tables",
            "dialogText": "With this tool, you can clear out and rebuild the Comm Management Tables used to populate the list of displayed objects. Select the Polling Server and enter the ObjectID of the Root Folder you want to use for this customer, then click Update.",
            "invalidFolder": "Invalid folder ID or Name",
            "updated": "Comm Tables have been updated.",
            "pollingServer": "Polling Server",
            "rootFolder": "Root Folder",
            "folderIsRequired": "A Folder ID or Name is required",
            "pollingServerIsRequired": "A Polling Server is required"
        }
    },
    "createCommPortDialog": {
        "newPort": "New Port",
        "steps": {
            "operation": {
                "title": "Operation",
                "selectOperation": "Select an Operation",
                "copy": "Copy",
                "copyHelperText": "This option allows you to select an existing Communication Device and make a copy of it. For \"Direct\" devices you will be required to change the IP and/or Port and the name of the object before it can be saved. For a \"Shared\" device you will be required to change the name of the port before you can save it.",
                "create": "Create",
                "createHelperText": "This option allows you to create a new Communication Device by manually entering all the required information."
            },
            "select": {
                "title": "Select",
                "selectType": "Select the Type of Comm Port",
                "direct": "Direct",
                "directHelperText": "This is the most common Port Type, each direct devices connects to a single IP Address and Port combination. This should be used for Cellular connections and traditional Serial radio networks where communications are limited to one device at a time.",
                "shared": "Shared",
                "sharedHelperText": "This type of port works best for IP Network radio systems where each device has it's own IP address and Port and is reached from a master gateway radio. When using this type of port you can adjust the maximum number of simultaneous requests that will be sent to control the bandwidth used during polling and data collection. Each device that uses a \"Shared\" port will have to have an IP address and Port entered into the devices properties.",
                "filterByName": "Filter by Name",
                "selectCommObject": "Select a Comm Object",
                "tableHeadings": {
                    "commObject": "Comm Object",
                    "ipAddress": "IP Address",
                    "port": "Port",
                    "type": "Type"
                }
            },
            "properties": {
                "title": "Properties",
                "maxConnectionsHelp": "Use this value to adjust the maximum number of simultaneous requests that will be sent at one time to control bandwidth utilized for polling operations."
            },
            "summary": {
                "title": "Summary",
                "portType": "Port Type",
                "ipAddress": "IP Address",
                "name": "Name",
                "maxConnections": "Max Simultaneous Connections",
                "port": "Port",
                "direct": "Direct",
                "shared": "Shared"
            }
        }
    },
    "configuration": {
        "types": {
            "dashboard": "Dashboard",
            "map": "Map",
            "graph": "Graph",
            "graphSection": "Graph Section",
            "report": "Report",
            "reportSection": "Report Section",
            "pageConfiguration": "View",
            "pageConfigurationSection": "View Section",
            "hmiConfiguration": "View",
            "hmiConfigurationPage": "View Page",
            "reportTask": "Report Task",
            "dataFileImport": "Data File Import",
            "rule": "Rule",
            "ruleInstance": "Applied Rule",
            "template": "Template",
            "objectTagValues": "View",
            "tagGroup":"Tag Group"
        },
        "accessLevels": {
            "private": "Private",
            "sharedReadOnly": "Anyone can view (Shared Read-Only)",
            "shared": "Anyone can edit (Shared)"
        },
        "accessLevelDialog": {
            "title": "Set {{configurationType}} Permissions",
            "buttonLabel": "Set Permissions"
        },
        "accessLevelModifyConfirmation": {
            "title": "NOTICE: Changes Affect Other Users",
            "text": "Would you like to Continue Modifying Permissions?",
            "yesButtonText": "Yes, Continue Modifying",
            "noButtonText": "No, Go Back"
        },
        "accessLevelModifySuccessMessage": "{{configurationType}} permissions have been changed from \"{{oldAccess}}\" to \"{{newAccess}}\"",
        "newSection": "New Section",
        "saveAsDialog": {
            "title": "Save as New",
            "instructions": "Enter a name for your new {{configurationType}}",
            "buttonLabel": "Save as New",
            "inputLabel": "{{configurationType}} name",
            "maxNameLength": "Name cannot be greater than 64 characters",
            "nameRequired": "Name is required"
        },
        "saveSuccessMessage": "{{configurationType}} \"{{configurationName}}\" has been saved",
        "editOrDuplicateConfirmation": {
            "title": "NOTICE: Changes Affect Other Users",
            "confirmationText": "Would you like to Duplicate the {{configurationType}} to make changes privately or Continue Editing?",
            "yesButtonText": "Duplicate",
            "noButtonText": "Continue Editing"
        },
        "deleteConfirmation": {
            "title": "Are you sure you want to delete {{configurationType}} \"{{configurationName}}\"?",
            "titleMulti": "Are you sure you want to deleted the selected configurations?",
            "confirmationText": "Note: This action cannot be undone.",
            "yesButtonText": "Yes, Delete",
            "noButtonText": "No, Go Back"
        },
        "deleteSuccessMessage": "{{configurationType}} \"{{configurationName}}\" has been deleted.",
        "deleteMultipleSuccessMessage": "The {{configurationType}} configurations have been deleted.",
        "hideSuccessMessage": "The hidden state for the {{configurationType}} has been updated.",
        "hideConfirmation": {
            "title": "Are you sure you want to hide the configuration(s)?",
            "confirmationText": "Note: You can unhide the configuration(s) at a later time.",
            "yesButtonText": "Yes, Hide",
            "noButtonText": "No, Cancel"
        },
        "unhideConfirmation": {
            "title": "Are you sure you want to unhide the configuration(s)?",
            "confirmationText": "Note: You can hide the configuration(s) at a later time.",
            "yesButtonText": "Yes, Unhide"
        },
        "inUseNoDelete": "This configuration is in use by another user as their default configuration. Therefore; you cannot delete it",
        "inUseNoHide": "This configuration is in use by another user as their default configuration. Therefore; you cannot hide it",
        "inUseNoMultiDelete": "The following configurations are in use as a default configuration. Therefore; you cannot delete them.,",
        "inUseNoMultiHide": "The following configurations are in use as a default configuration. Therefore; you cannot hide them.",

        "renameConfirmation": {
            "title": "NOTICE: Changes Affect Other Users",
            "text": "Would you like to Continue Renaming?",
            "yesButtonText": "Yes, Continue Renaming",
            "noButtonText": "No, Go Back"
        },
        "renameDialog": {
            "title": "Rename",
            "instructions": "Enter a new name for your {{configurationType}}",
            "buttonLabel": "Rename",
            "inputLabel": "{{configurationType}} name",
            "maxNameLength": "Name cannot be greater than 64 characters",
            "nameRequired": "Name is required"
        },
        "renameSuccessMessage": "{{configurationType}} \"{{oldName}}\" has been renamed to \"{{newName}}\".",
        "setAsDefaultDialog": {
            "title": "Set as Default",
            "subtitle": "Set <b>{{configurationName}}</b> as default {{configurationType}}",
            "heading1": "For {{objectTypeName}} {{targetName}}",
            "heading2": "For all {{objectTypeName}} in group {{groupName}}",
            "option1": "Set as My Default",
            "option2": "Set as default for all users that don't already have a default",
            "option3": "Set as default for all users, including me",
            "option4": "Set as default for all users that don't already have a default",
            "cancelConfirmation": "You're about to leave Set as Default without applying your changes. Are you sure you want to continue and cancel?"
        },
        "saveAsDefaultSuccess1": "The Default {{objectTypeName}} has been set for you and all other users.",
        "saveAsDefaultSuccess2": "The Default {{objectTypeName}} has been set for you and all users without a current default.",
        "saveAsDefaultSuccess3": "The Default {{objectTypeName}} has been set for all users.",
        "saveAsDefaultSuccess4": "The Default {{objectTypeName}} has been set for all users without a current default.",
        "saveAsDefaultSuccess5": "Your Default {{objectTypeName}} has been set",
        "removeDefaultsConfirmation" : {
            "title": "Remove Defaults Confirmation",
            "text": "You have deselected options that affect defaults for other users. As a result, those defaults will be removed. Would you like to continue?",
            "yesButtonText": "Yes, Continue",
            "noButtonText": "No, Go Back"
        },
        "filter": "Filter by {{singularObjectTypeName}} Name",
        "viewSelected": "View Selected {{pluralObjectTypeName}}",
        "oldFormatConfirmation": {
            "title": "NOTICE: You're attempting to edit a {{configurationType}} that's stored in an old format",
            "confirmationText": "If you edit and save the {{configurationType}}, it will be converted to the new format and may no longer be viewable in older application versions. Would you like to Duplicate the {{configurationType}} and preserve the original or Continue Editing?",
            "yesButtonText": "Duplicate",
            "noButtonText": "Continue Editing"
        },
        "nodata": {
            "title": "No data",
            "text": "There are no {{configurationType}} configurations."
        }

    },
    "countries": {
        "ad": {
            "code": "AD",
            "name": "Andorra",
            "telephonePrefix": "376"
        },
        "ae": {
            "code": "AE",
            "name": "United Arab Emirates",
            "telephonePrefix": "971"
        },
        "af": {
            "code": "AF",
            "name": "Afghanistan",
            "telephonePrefix": "93"
        },
        "ag": {
            "code": "AG",
            "name": "Antigua and Barbuda",
            "telephonePrefix": "1"
        },
        "ai": {
            "code": "AI",
            "name": "Anguilla",
            "telephonePrefix": "1"
        },
        "al": {
            "code": "AL",
            "name": "Albania",
            "telephonePrefix": "355"
        },
        "am": {
            "code": "AM",
            "name": "Armenia",
            "telephonePrefix": "374"
        },
        "an": {
            "code": "AN",
            "name": "Netherlands Antilles",
            "telephonePrefix": "599"
        },
        "ao": {
            "code": "AO",
            "name": "Angola",
            "telephonePrefix": "244"
        },
        "aq": {
            "code": "AQ",
            "name": "Antarctica",
            "telephonePrefix": "672"
        },
        "ar": {
            "code": "AR",
            "name": "Argentina",
            "telephonePrefix": "54"
        },
        "as": {
            "code": "AS",
            "name": "American Samoa",
            "telephonePrefix": "1"
        },
        "at": {
            "code": "AT",
            "name": "Austria",
            "telephonePrefix": "43"
        },
        "au": {
            "code": "AU",
            "name": "Australia",
            "telephonePrefix": "61"
        },
        "aw": {
            "code": "AW",
            "name": "Aruba",
            "telephonePrefix": "297"
        },
        "az": {
            "code": "AZ",
            "name": "Azerbaijan",
            "telephonePrefix": "994"
        },
        "ba": {
            "code": "BA",
            "name": "Bosnia and Herzegovina",
            "telephonePrefix": "387"
        },
        "bb": {
            "code": "BB",
            "name": "Barbados",
            "telephonePrefix": "1"
        },
        "bd": {
            "code": "BD",
            "name": "Bangladesh",
            "telephonePrefix": "880"
        },
        "be": {
            "code": "BE",
            "name": "Belgium",
            "telephonePrefix": "32"
        },
        "bf": {
            "code": "BF",
            "name": "Burkina Faso",
            "telephonePrefix": "226"
        },
        "bg": {
            "code": "BG",
            "name": "Bulgaria",
            "telephonePrefix": "359"
        },
        "bh": {
            "code": "BH",
            "name": "Bahrain",
            "telephonePrefix": "973"
        },
        "bi": {
            "code": "BI",
            "name": "Burundi",
            "telephonePrefix": "257"
        },
        "bj": {
            "code": "BJ",
            "name": "Benin",
            "telephonePrefix": "229"
        },
        "bl": {
            "code": "BL",
            "name": "Saint Barthelemy",
            "telephonePrefix": "590"
        },
        "bm": {
            "code": "BM",
            "name": "Bermuda",
            "telephonePrefix": "1"
        },
        "bn": {
            "code": "BN",
            "name": "Brunei",
            "telephonePrefix": "673"
        },
        "bo": {
            "code": "BO",
            "name": "Bolivia",
            "telephonePrefix": "591"
        },
        "br": {
            "code": "BR",
            "name": "Brazil",
            "telephonePrefix": "55"
        },
        "bs": {
            "code": "BS",
            "name": "Bahamas",
            "telephonePrefix": "1"
        },
        "bt": {
            "code": "BT",
            "name": "Bhutan",
            "telephonePrefix": "975"
        },
        "bw": {
            "code": "BW",
            "name": "Botswana",
            "telephonePrefix": "267"
        },
        "by": {
            "code": "BY",
            "name": "Belarus",
            "telephonePrefix": "375"
        },
        "bz": {
            "code": "BZ",
            "name": "Belize",
            "telephonePrefix": "501"
        },
        "ca": {
            "code": "CA",
            "name": "Canada",
            "telephonePrefix": "1"
        },
        "cc": {
            "code": "CC",
            "name": "Cocos Islands",
            "telephonePrefix": "61"
        },
        "cd": {
            "code": "CD",
            "name": "Democratic Republic of the Congo",
            "telephonePrefix": "243"
        },
        "cf": {
            "code": "CF",
            "name": "Central African Republic",
            "telephonePrefix": "236"
        },
        "cg": {
            "code": "CG",
            "name": "Republic of the Congo",
            "telephonePrefix": "242"
        },
        "ch": {
            "code": "CH",
            "name": "Switzerland",
            "telephonePrefix": "41"
        },
        "ci": {
            "code": "CI",
            "name": "Ivory Coast",
            "telephonePrefix": "225"
        },
        "ck": {
            "code": "CK",
            "name": "Cook Islands",
            "telephonePrefix": "682"
        },
        "cl": {
            "code": "CL",
            "name": "Chile",
            "telephonePrefix": "56"
        },
        "cm": {
            "code": "CM",
            "name": "Cameroon",
            "telephonePrefix": "237"
        },
        "cn": {
            "code": "CN",
            "name": "China",
            "telephonePrefix": "86"
        },
        "co": {
            "code": "CO",
            "name": "Colombia",
            "telephonePrefix": "57"
        },
        "cr": {
            "code": "CR",
            "name": "Costa Rica",
            "telephonePrefix": "506"
        },
        "cu": {
            "code": "CU",
            "name": "Cuba",
            "telephonePrefix": "53"
        },
        "cv": {
            "code": "CV",
            "name": "Cape Verde",
            "telephonePrefix": "238"
        },
        "cw": {
            "code": "CW",
            "name": "Curacao",
            "telephonePrefix": "599"
        },
        "cx": {
            "code": "CX",
            "name": "Christmas Island",
            "telephonePrefix": "61"
        },
        "cy": {
            "code": "CY",
            "name": "Cyprus",
            "telephonePrefix": "357"
        },
        "cz": {
            "code": "CZ",
            "name": "Czech Republic",
            "telephonePrefix": "420"
        },
        "de": {
            "code": "DE",
            "name": "Germany",
            "telephonePrefix": "49"
        },
        "dj": {
            "code": "DJ",
            "name": "Djibouti",
            "telephonePrefix": "253"
        },
        "dk": {
            "code": "DK",
            "name": "Denmark",
            "telephonePrefix": "45"
        },
        "dm": {
            "code": "DM",
            "name": "Dominica",
            "telephonePrefix": "1"
        },
        "do": {
            "code": "DO",
            "name": "Dominican Republic",
            "telephonePrefix": "1"
        },
        "dz": {
            "code": "DZ",
            "name": "Algeria",
            "telephonePrefix": "213"
        },
        "ec": {
            "code": "EC",
            "name": "Ecuador",
            "telephonePrefix": "593"
        },
        "ee": {
            "code": "EE",
            "name": "Estonia",
            "telephonePrefix": "372"
        },
        "eg": {
            "code": "EG",
            "name": "Egypt",
            "telephonePrefix": "20"
        },
        "eh": {
            "code": "EH",
            "name": "Western Sahara",
            "telephonePrefix": ""
        },
        "er": {
            "code": "ER",
            "name": "Eritrea",
            "telephonePrefix": "291"
        },
        "es": {
            "code": "ES",
            "name": "Spain",
            "telephonePrefix": "34"
        },
        "et": {
            "code": "ET",
            "name": "Ethiopia",
            "telephonePrefix": "251"
        },
        "fi": {
            "code": "FI",
            "name": "Finland",
            "telephonePrefix": "358"
        },
        "fj": {
            "code": "FJ",
            "name": "Fiji",
            "telephonePrefix": "679"
        },
        "fk": {
            "code": "FK",
            "name": "Falkland Islands",
            "telephonePrefix": "500"
        },
        "fm": {
            "code": "FM",
            "name": "Micronesia",
            "telephonePrefix": "691"
        },
        "fo": {
            "code": "FO",
            "name": "Faroe Islands",
            "telephonePrefix": "298"
        },
        "fr": {
            "code": "FR",
            "name": "France",
            "telephonePrefix": "33"
        },
        "ga": {
            "code": "GA",
            "name": "Gabon",
            "telephonePrefix": "241"
        },
        "gb": {
            "code": "GB",
            "name": "United Kingdom",
            "telephonePrefix": "44"
        },
        "gd": {
            "code": "GD",
            "name": "Grenada",
            "telephonePrefix": "1"
        },
        "ge": {
            "code": "GE",
            "name": "Georgia",
            "telephonePrefix": "995"
        },
        "gg": {
            "code": "GG",
            "name": "Guernsey",
            "telephonePrefix": "44"
        },
        "gh": {
            "code": "GH",
            "name": "Ghana",
            "telephonePrefix": "233"
        },
        "gi": {
            "code": "GI",
            "name": "Gibraltar",
            "telephonePrefix": "350"
        },
        "gl": {
            "code": "GL",
            "name": "Greenland",
            "telephonePrefix": "299"
        },
        "gm": {
            "code": "GM",
            "name": "Gambia",
            "telephonePrefix": "220"
        },
        "gn": {
            "code": "GN",
            "name": "Guinea",
            "telephonePrefix": "224"
        },
        "gq": {
            "code": "GQ",
            "name": "Equatorial Guinea",
            "telephonePrefix": "240"
        },
        "gr": {
            "code": "GR",
            "name": "Greece",
            "telephonePrefix": "30"
        },
        "gt": {
            "code": "GT",
            "name": "Guatemala",
            "telephonePrefix": "502"
        },
        "gu": {
            "code": "GU",
            "name": "Guam",
            "telephonePrefix": "1"
        },
        "gw": {
            "code": "GW",
            "name": "Guinea-Bissau",
            "telephonePrefix": "245"
        },
        "gy": {
            "code": "GY",
            "name": "Guyana",
            "telephonePrefix": "592"
        },
        "hk": {
            "code": "HK",
            "name": "Hong Kong",
            "telephonePrefix": "852"
        },
        "hn": {
            "code": "HN",
            "name": "Honduras",
            "telephonePrefix": "504"
        },
        "hr": {
            "code": "HR",
            "name": "Croatia",
            "telephonePrefix": "385"
        },
        "ht": {
            "code": "HT",
            "name": "Haiti",
            "telephonePrefix": "509"
        },
        "hu": {
            "code": "HU",
            "name": "Hungary",
            "telephonePrefix": "36"
        },
        "id": {
            "code": "ID",
            "name": "Indonesia",
            "telephonePrefix": "62"
        },
        "ie": {
            "code": "IE",
            "name": "Ireland",
            "telephonePrefix": "353"
        },
        "il": {
            "code": "IL",
            "name": "Israel",
            "telephonePrefix": "972"
        },
        "im": {
            "code": "IM",
            "name": "Isle of Man",
            "telephonePrefix": "44"
        },
        "in": {
            "code": "IN",
            "name": "India",
            "telephonePrefix": "91"
        },
        "io": {
            "code": "IO",
            "name": "British Indian Ocean Territory",
            "telephonePrefix": ""
        },
        "iq": {
            "code": "IQ",
            "name": "Iraq",
            "telephonePrefix": "964"
        },
        "ir": {
            "code": "IR",
            "name": "Iran",
            "telephonePrefix": "98"
        },
        "is": {
            "code": "IS",
            "name": "Iceland",
            "telephonePrefix": "354"
        },
        "it": {
            "code": "IT",
            "name": "Italy",
            "telephonePrefix": "39"
        },
        "je": {
            "code": "JE",
            "name": "Jersey",
            "telephonePrefix": ""
        },
        "jm": {
            "code": "JM",
            "name": "Jamaica",
            "telephonePrefix": "1"
        },
        "jo": {
            "code": "JO",
            "name": "Jordan",
            "telephonePrefix": "962"
        },
        "jp": {
            "code": "JP",
            "name": "Japan",
            "telephonePrefix": "81"
        },
        "ke": {
            "code": "KE",
            "name": "Kenya",
            "telephonePrefix": "254"
        },
        "kg": {
            "code": "KG",
            "name": "Kyrgyzstan",
            "telephonePrefix": "996"
        },
        "kh": {
            "code": "KH",
            "name": "Cambodia",
            "telephonePrefix": "855"
        },
        "ki": {
            "code": "KI",
            "name": "Kiribati",
            "telephonePrefix": "686"
        },
        "km": {
            "code": "KM",
            "name": "Comoros",
            "telephonePrefix": "269"
        },
        "kn": {
            "code": "KN",
            "name": "Saint Kitts and Nevis",
            "telephonePrefix": "1"
        },
        "kp": {
            "code": "KP",
            "name": "North Korea",
            "telephonePrefix": "850"
        },
        "kr": {
            "code": "KR",
            "name": "South Korea",
            "telephonePrefix": "82"
        },
        "kw": {
            "code": "KW",
            "name": "Kuwait",
            "telephonePrefix": "965"
        },
        "ky": {
            "code": "KY",
            "name": "Cayman Islands",
            "telephonePrefix": "1"
        },
        "kz": {
            "code": "KZ",
            "name": "Kazakhstan",
            "telephonePrefix": "7"
        },
        "la": {
            "code": "LA",
            "name": "Laos",
            "telephonePrefix": "856"
        },
        "lb": {
            "code": "LB",
            "name": "Lebanon",
            "telephonePrefix": "961"
        },
        "lc": {
            "code": "LC",
            "name": "Saint Lucia",
            "telephonePrefix": "1"
        },
        "li": {
            "code": "LI",
            "name": "Liechtenstein",
            "telephonePrefix": "423"
        },
        "lk": {
            "code": "LK",
            "name": "Sri Lanka",
            "telephonePrefix": "94"
        },
        "lr": {
            "code": "LR",
            "name": "Liberia",
            "telephonePrefix": "231"
        },
        "ls": {
            "code": "LS",
            "name": "Lesotho",
            "telephonePrefix": "266"
        },
        "lt": {
            "code": "LT",
            "name": "Lithuania",
            "telephonePrefix": "370"
        },
        "lu": {
            "code": "LU",
            "name": "Luxembourg",
            "telephonePrefix": "352"
        },
        "lv": {
            "code": "LV",
            "name": "Latvia",
            "telephonePrefix": "371"
        },
        "ly": {
            "code": "LY",
            "name": "Libya",
            "telephonePrefix": "218"
        },
        "ma": {
            "code": "MA",
            "name": "Morocco",
            "telephonePrefix": "212"
        },
        "mc": {
            "code": "MC",
            "name": "Monaco",
            "telephonePrefix": "377"
        },
        "md": {
            "code": "MD",
            "name": "Moldova",
            "telephonePrefix": "373"
        },
        "me": {
            "code": "ME",
            "name": "Montenegro",
            "telephonePrefix": "382"
        },
        "mf": {
            "code": "MF",
            "name": "Saint Martin",
            "telephonePrefix": "590"
        },
        "mg": {
            "code": "MG",
            "name": "Madagascar",
            "telephonePrefix": "261"
        },
        "mh": {
            "code": "MH",
            "name": "Marshall Islands",
            "telephonePrefix": "692"
        },
        "mk": {
            "code": "MK",
            "name": "Macedonia",
            "telephonePrefix": "389"
        },
        "ml": {
            "code": "ML",
            "name": "Mali",
            "telephonePrefix": "223"
        },
        "mm": {
            "code": "MM",
            "name": "Myanmar",
            "telephonePrefix": "95"
        },
        "mn": {
            "code": "MN",
            "name": "Mongolia",
            "telephonePrefix": "976"
        },
        "mo": {
            "code": "MO",
            "name": "Macao",
            "telephonePrefix": "853"
        },
        "mp": {
            "code": "MP",
            "name": "Northern Mariana Islands",
            "telephonePrefix": "1"
        },
        "mr": {
            "code": "MR",
            "name": "Mauritania",
            "telephonePrefix": "222"
        },
        "ms": {
            "code": "MS",
            "name": "Montserrat",
            "telephonePrefix": "1"
        },
        "mt": {
            "code": "MT",
            "name": "Malta",
            "telephonePrefix": "356"
        },
        "mu": {
            "code": "MU",
            "name": "Mauritius",
            "telephonePrefix": "230"
        },
        "mv": {
            "code": "MV",
            "name": "Maldives",
            "telephonePrefix": "960"
        },
        "mw": {
            "code": "MW",
            "name": "Malawi",
            "telephonePrefix": "265"
        },
        "mx": {
            "code": "MX",
            "name": "Mexico",
            "telephonePrefix": "52"
        },
        "my": {
            "code": "MY",
            "name": "Malaysia",
            "telephonePrefix": "60"
        },
        "mz": {
            "code": "MZ",
            "name": "Mozambique",
            "telephonePrefix": "258"
        },
        "na": {
            "code": "NA",
            "name": "Namibia",
            "telephonePrefix": "264"
        },
        "nc": {
            "code": "NC",
            "name": "New Caledonia",
            "telephonePrefix": "687"
        },
        "ne": {
            "code": "NE",
            "name": "Niger",
            "telephonePrefix": "227"
        },
        "ng": {
            "code": "NG",
            "name": "Nigeria",
            "telephonePrefix": "234"
        },
        "ni": {
            "code": "NI",
            "name": "Nicaragua",
            "telephonePrefix": "505"
        },
        "nl": {
            "code": "NL",
            "name": "Netherlands",
            "telephonePrefix": "31"
        },
        "no": {
            "code": "NO",
            "name": "Norway",
            "telephonePrefix": "47"
        },
        "np": {
            "code": "NP",
            "name": "Nepal",
            "telephonePrefix": "977"
        },
        "nr": {
            "code": "NR",
            "name": "Nauru",
            "telephonePrefix": "674"
        },
        "nu": {
            "code": "NU",
            "name": "Niue",
            "telephonePrefix": "683"
        },
        "nz": {
            "code": "NZ",
            "name": "New Zealand",
            "telephonePrefix": "64"
        },
        "om": {
            "code": "OM",
            "name": "Oman",
            "telephonePrefix": "968"
        },
        "pa": {
            "code": "PA",
            "name": "Panama",
            "telephonePrefix": "507"
        },
        "pe": {
            "code": "PE",
            "name": "Peru",
            "telephonePrefix": "51"
        },
        "pf": {
            "code": "PF",
            "name": "French Polynesia",
            "telephonePrefix": "689"
        },
        "pg": {
            "code": "PG",
            "name": "Papua New Guinea",
            "telephonePrefix": "675"
        },
        "ph": {
            "code": "PH",
            "name": "Philippines",
            "telephonePrefix": "63"
        },
        "pk": {
            "code": "PK",
            "name": "Pakistan",
            "telephonePrefix": "92"
        },
        "pl": {
            "code": "PL",
            "name": "Poland",
            "telephonePrefix": "48"
        },
        "pm": {
            "code": "PM",
            "name": "Saint Pierre and Miquelon",
            "telephonePrefix": "508"
        },
        "pn": {
            "code": "PN",
            "name": "Pitcairn",
            "telephonePrefix": "870"
        },
        "pr": {
            "code": "PR",
            "name": "Puerto Rico",
            "telephonePrefix": "1"
        },
        "ps": {
            "code": "PS",
            "name": "Palestinian",
            "telephonePrefix": "970"
        },
        "pt": {
            "code": "PT",
            "name": "Portugal",
            "telephonePrefix": "351"
        },
        "pw": {
            "code": "PW",
            "name": "Palau",
            "telephonePrefix": "680"
        },
        "py": {
            "code": "PY",
            "name": "Paraguay",
            "telephonePrefix": "595"
        },
        "qa": {
            "code": "QA",
            "name": "Qatar",
            "telephonePrefix": "974"
        },
        "re": {
            "code": "RE",
            "name": "Reunion",
            "telephonePrefix": "262"
        },
        "ro": {
            "code": "RO",
            "name": "Romania",
            "telephonePrefix": "40"
        },
        "rs": {
            "code": "RS",
            "name": "Serbia",
            "telephonePrefix": "381"
        },
        "ru": {
            "code": "RU",
            "name": "Russia",
            "telephonePrefix": "7"
        },
        "rw": {
            "code": "RW",
            "name": "Rwanda",
            "telephonePrefix": "250"
        },
        "sa": {
            "code": "SA",
            "name": "Saudi Arabia",
            "telephonePrefix": "966"
        },
        "sb": {
            "code": "SB",
            "name": "Solomon Islands",
            "telephonePrefix": "677"
        },
        "sc": {
            "code": "SC",
            "name": "Seychelles",
            "telephonePrefix": "248"
        },
        "sd": {
            "code": "SD",
            "name": "Sudan",
            "telephonePrefix": "249"
        },
        "se": {
            "code": "SE",
            "name": "Sweden",
            "telephonePrefix": "46"
        },
        "sg": {
            "code": "SG",
            "name": "Singapore",
            "telephonePrefix": "65"
        },
        "sh": {
            "code": "SH",
            "name": "Saint Helena",
            "telephonePrefix": "290"
        },
        "si": {
            "code": "SI",
            "name": "Slovenia",
            "telephonePrefix": "386"
        },
        "sj": {
            "code": "SJ",
            "name": "Svalbard and Jan Mayen",
            "telephonePrefix": "47"
        },
        "sk": {
            "code": "SK",
            "name": "Slovakia",
            "telephonePrefix": "421"
        },
        "sl": {
            "code": "SL",
            "name": "Sierra Leone",
            "telephonePrefix": "232"
        },
        "sm": {
            "code": "SM",
            "name": "San Marino",
            "telephonePrefix": "378"
        },
        "sn": {
            "code": "SN",
            "name": "Senegal",
            "telephonePrefix": "221"
        },
        "so": {
            "code": "SO",
            "name": "Somalia",
            "telephonePrefix": "252"
        },
        "sr": {
            "code": "SR",
            "name": "Suriname",
            "telephonePrefix": "597"
        },
        "ss": {
            "code": "SS",
            "name": "South Sudan",
            "telephonePrefix": "211"
        },
        "st": {
            "code": "ST",
            "name": "Sao Tome and Principe",
            "telephonePrefix": "239"
        },
        "sv": {
            "code": "SV",
            "name": "El Salvador",
            "telephonePrefix": "503"
        },
        "sx": {
            "code": "SX",
            "name": "Sint Maarten",
            "telephonePrefix": "1"
        },
        "sy": {
            "code": "SY",
            "name": "Syria",
            "telephonePrefix": "963"
        },
        "sz": {
            "code": "SZ",
            "name": "Swaziland",
            "telephonePrefix": "268"
        },
        "tc": {
            "code": "TC",
            "name": "Turks and Caicos Islands",
            "telephonePrefix": "1"
        },
        "td": {
            "code": "TD",
            "name": "Chad",
            "telephonePrefix": "235"
        },
        "tg": {
            "code": "TG",
            "name": "Togo",
            "telephonePrefix": "228"
        },
        "th": {
            "code": "TH",
            "name": "Thailand",
            "telephonePrefix": "66"
        },
        "tj": {
            "code": "TJ",
            "name": "Tajikistan",
            "telephonePrefix": "992"
        },
        "tk": {
            "code": "TK",
            "name": "Tokelau",
            "telephonePrefix": "690"
        },
        "tl": {
            "code": "TL",
            "name": "East Timor",
            "telephonePrefix": "670"
        },
        "tm": {
            "code": "TM",
            "name": "Turkmenistan",
            "telephonePrefix": "993"
        },
        "tn": {
            "code": "TN",
            "name": "Tunisia",
            "telephonePrefix": "216"
        },
        "to": {
            "code": "TO",
            "name": "Tonga",
            "telephonePrefix": "676"
        },
        "tr": {
            "code": "TR",
            "name": "Turkey",
            "telephonePrefix": "90"
        },
        "tt": {
            "code": "TT",
            "name": "Trinidad and Tobago",
            "telephonePrefix": "1"
        },
        "tv": {
            "code": "TV",
            "name": "Tuvalu",
            "telephonePrefix": "688"
        },
        "tw": {
            "code": "TW",
            "name": "Taiwan",
            "telephonePrefix": "886"
        },
        "tz": {
            "code": "TZ",
            "name": "Tanzania",
            "telephonePrefix": "255"
        },
        "ua": {
            "code": "UA",
            "name": "Ukraine",
            "telephonePrefix": "380"
        },
        "ug": {
            "code": "UG",
            "name": "Uganda",
            "telephonePrefix": "256"
        },
        "us": {
            "code": "US",
            "name": "United States",
            "telephonePrefix": "1"
        },
        "uy": {
            "code": "UY",
            "name": "Uruguay",
            "telephonePrefix": "598"
        },
        "uz": {
            "code": "UZ",
            "name": "Uzbekistan",
            "telephonePrefix": "998"
        },
        "va": {
            "code": "VA",
            "name": "Vatican",
            "telephonePrefix": "39"
        },
        "vc": {
            "code": "VC",
            "name": "Saint Vincent and the Grenadines",
            "telephonePrefix": "1"
        },
        "ve": {
            "code": "VE",
            "name": "Venezuela",
            "telephonePrefix": "58"
        },
        "vg": {
            "code": "VG",
            "name": "British Virgin Islands",
            "telephonePrefix": "1"
        },
        "vi": {
            "code": "VI",
            "name": "U.S. Virgin Islands",
            "telephonePrefix": "1"
        },
        "vn": {
            "code": "VN",
            "name": "Vietnam",
            "telephonePrefix": "84"
        },
        "vu": {
            "code": "VU",
            "name": "Vanuatu",
            "telephonePrefix": "678"
        },
        "wf": {
            "code": "WF",
            "name": "Wallis and Futuna",
            "telephonePrefix": "681"
        },
        "ws": {
            "code": "WS",
            "name": "Samoa",
            "telephonePrefix": "685"
        },
        "xk": {
            "code": "XK",
            "name": "Kosovo",
            "telephonePrefix": "383"
        },
        "ye": {
            "code": "YE",
            "name": "Yemen",
            "telephonePrefix": "967"
        },
        "yt": {
            "code": "YT",
            "name": "Mayotte",
            "telephonePrefix": "262"
        },
        "za": {
            "code": "ZA",
            "name": "South Africa",
            "telephonePrefix": "27"
        },
        "zm": {
            "code": "ZM",
            "name": "Zambia",
            "telephonePrefix": "260"
        },
        "zw": {
            "code": "ZW",
            "name": "Zimbabwe",
            "telephonePrefix": "263"
        }
    },
    "createDevice": {
        "addTag": "Add Tag",
        "cancelAddText": "You're about to leave Create Device without saving your changes. Are you sure you want to continue and exit without saving?",
        "created": "Device Created",
        "success": "'{{name}}' was successfully created, data should appear within 15 minutes. Note: Power Cycling the device will allow data to show up within a minute.",
        "title": "Create Device",
        "tagsToAdd": "Tags",
        "goToDevice": "Go to Device",
        "deviceNameRequired": "Device Name is required",
        "deviceNameUnique": "Device Name must be unique",
        "deviceTemplate": "Device Template",
        "hydroStaticAnalysis": "Hydrostatic Analysis",
        "hydroStaticAnalysisHelpText": "Expected Pressure at location under normal conditions.",
        "imei": "IMEI",
        "imeiRequired": "Required - Enter 15 digit IMEI number",
        "imei15Digits": "IMEI must be 15 digits",
        "maxPSI": "Max Sensor PSI",
        "maxPSIRequired": "Required - The max pressure for the installed sensor",
        "templateActions": {
            "existingDevice": "Copy from Existing Device",
            "fromTemplate": "Create from Template",
            "waterLossDetection": "Create Water Leak Detection Device",
            "sat4di": "Create Sat4DI Device",
            "alarmCryout": "Create Alarm Cry-out Modem Device"
        },
        "table": {
            "header": {
                "name": "Name",
                "tagName": "Tag Name",
                "summaryTab": "Summary Listing Tab",
                "discrete": "Discrete Input",
                "wiring": "Wiring"
            }
        },
        "validation": {
            "device": {
                "title": "Information",
                "message": "The device \"{{name}}\" has {{count}} issues. If these were unexpected, please review the device and correct the issues. Otherwise, you may proceed."
            },

            "template": {
                "title": "Warning",
                "message": "The template \"{{name}}\" has {{count}} issues. Please correct the issues or use another template."
            }

        }
    },
    "createTag": {
        "cancelAddText": "You're about to leave Add Tag without saving your changes. Are you sure you want to continue and exit without saving?",
        "nameRequired":"Name is required",
        "alarmLynx": "AlarmLynx",
        "compressorLynx": "CompressorLynx",
        "discreteInput": "Discrete Input",
        "wiring": "Wiring",
        "normalOpen": "Normally Open",
        "normalClose": "Normally Closed",
        "summaryTab": "Summary Listing Tab",
        "discreteInputRequired": "Discrete Input is required",
        "wiringRequired": "Wiring is required",
        "required": "Required",
        "title": "Add Tag to '{{objectName}}'"

    },
    "customDuration": {
        "duration": "Duration",
        "configured": "Configured Timeframe",
        "custom1": "Custom",
        "1Day": "Last 24 hours",
        "3Days": "Last 3 days",
        "7Days": "Last 7 days",
        "30Days": "Last 30 days",
        "last100": "Last 100",
        "last250": "Last 250",
        "custom": "Custom Duration",
        "maxRowCount": "You can specify a timeframe for the data values presented on this page. The most recent {{count}} data values within the timeframe will be displayed",
        "title": "Duration Options",
        "startBeforeEndError": "The start date must be before the end date",
        "validStartDate": "A valid start date is required",
        "validEndDate": "A valid end date is required"
    },
    "customForms": {
        "noOpenData": "There are no open forms for {{name}}",
        "noCloseData": "There are no closed forms for {{name}}",
        "attachments": "Attachments",
        "chooseObject": "Choose an object",
        "objectRequired": "You must choose an object to complete this form",
        "showLegend": "Show Legend",
        "signature": {
            "title": "Are you ready to save this form?",
            "text": "You're about to save the data within this form.  Please confirm data entered and sign by clicking below.",
            "signAndSave": "Yes, sign & save",
            "noGoBack": "No, Go Back"
        },
        "welcome": "Welcome to eLynx Forms!",
        "welcomeText1": "You don’t currently have any forms configured.  Click ",
        "welcomeText2": " to learn more about how to start using eLynx Forms."
    },
    "customer": {
        "selectCustomer": "Select a Customer"
    },
    "dashboard": {
        "added": "Dashboard template '{{name}}' was added.",
        "column": "COLUMN",
        "components": "Components",
        "componentHierarchy": "Component Hierarchy",
        "deleted": "The Dashboard template has been deleted.",
        "info": {
            "componentPanel": "Begin by dragging and dropping a component on to the layout.",
            "componentHierarchy": "Expand the component hierarchy by clicking on the component name to view the properties set for the component.",
            "componentList": "Click on the component name to view the properties for the component.",
            "row": "Rows and Columns can be rearranged by dragging to a new position.  They can also be removed by clicking the X."
        },
        "legend": "Layout Legend",
        "list": {
            "placeholder": "Choose a Configuration",
            "shared": "Shared Dashboard Configurations",
            "sharedReadOnly": "Shared Read-Only Dashboard Configurations",
            "private": "Private Dashboard Configurations"
        },
        "nodata": {
            "title": "No Dashboard",
            "text": "Choose a Dashboard from the Options panel, or create a new Dashboard."
        },
        "property": {
            "invalidValue": "The value must be 'auto', or a number ending with '%' or 'px'",
            "units": "auto | % | px"

        },
        "updated": "'{{name}}' was successfully updated.",
        "row": "ROW",
        "section": "SECTION",
        "selected": "Selected",
        "allTankBatteries": {
            "title" : "Only One 'All Tank Batteries' Component",
            "message": "A component for all tank batteries in a group already exists."


        }
    },
    "dataFileImport": {
        "actions": {
            "edit": "Edit",
            "rename": "Rename",
            "run": "Run",
            "delete": "Delete",
            "new": "New Import"
        },
        "columns": "Columns:",
        "dataLayout": "Data Layout",
        "dateColumn": "Date Column:",
        "dateColumnPrompt": "Column for date or combined date/time",
        "dateColumnTypes": {
            "one": "1 Column",
            "two": "2 Column"
        },
        "dateTimeInfo": "Date/Time Information",
        "exceptions": {
            "duplicateColumnNames": {
                "message": "Duplicate column names are not valid. Please fix the column names or choose a different file.",
                "title": "Duplicate Column Names Are Not Allowed."
            },
            "lessThanTwoColumns": {
                "message": "Invalid CSV File. There must be at least two columns in the file. Please fix the columns or choose a different file.",
                "title": "At Least Two Columns Are Required."
            },
            "nameInUse": {
                "message": "A Data File Import Configuration with the specified name already exists. Please choose a different name.",
                "title": "Duplicate Names Are Not Allowed"
            },
            "importRunValidation": {
                "title": "Validation Error with first row.",
                "correctionMessage": "{{message}}<br /><br />Correct the Import File or contact your site administrator for help with the Import Configuration.",
                "hasModifyCorrectionMessage": "{{message}}<br /><br />Correct the Import File or create a New Import Configuration."
            }
        },

        "fileContains": "File Contains",
        "fileContainsTypes": {
            "dataForSingleDevice": "Data for Single Device",
            "dataForMultipleDevices": "Data for Multiple Devices",
            "dataForSingleWell": "Data for Single Well",
            "dataForMultipleWells": "Data for Multiple Wells",
            "dataForSingleTank": "Data for Single Tank",
            "dataForMultipleTanks": "Data for Multiple Tanks"
        },
        "fileHasHeader": "File has header row",
        "filterBy": "Filter by name",
        "identifierColumn": "Identifier Column:",
        "identifierColumnLabel": "Identifier Column",
        "ignoreColumn": "Ignore this column",
        "ignoreIdentifier": "Ignore this identifier",
        "importObject": "Import Object",
        "importObjectType": "Import Object Type:",
        "importType": "Import Type:  {{name}}",
        "importTypeLabel": "Import Type",
        "importTypes": {
            "all": "All ",
            "single": "Single Object",
            "multiple": "Multiple Objects"
        },
        "logEntryTypeEnum": {
            "allTagsProcessed": "All Tags Successfully Processed",
            "identifierNotMatched": "Identifer Not matched to Organization Object",
            "invalidData": "Invalid Data",
            "invalidDateTime": "Invalid Date Time",
            "missingDateTime": "Missing Date Time",
            "missingTag": "Tag Not Found for Object",
            "noReadPermissions": "No Read Permissions",
            "notActive": "Object Not Active",
            "missingIdentifier": "Missing Identifier",
            "processingError": "Processing Error"
        },
        "maxFileSizeExceeded": "The selected file exceeds the maximum size of 10 mb. Please select a smaller file and try again.",
        "maxFileSizeExceededTitle": "File Too Large",
        "matchAttribute": "Match to Attribute",
        "nodata": {
            "noItemsAvailable": "There are no items available to map",
            "title": "",
            "instruction": "You can add Data File Imports using the 'Add Data File Import' button in the toolbar.",
            "text": "There are no {{importType}} imports for the '{{org}}' organization or that match the text in the filter.",
            "textall": "There are no imports for the '{{org}}' organization or that match the text in the filter."

        },
        "objectMap": "Object Map [{{count}}]",
        "objectMapInstruction": "Select the device identifier column to begin mapping import rows to objects in the system.",
        "objectMapItem": "Identifier '{{identifier}}' is mapped to the '{{name}}' {{objectType}}",
        "objects": "Objects",
        "options": "Options",
        "processImportLog": {
            "title": "Data File Import Log"
        },
        "renameSuccessText": "Data File Import Configuration '{{old}}' has been renamed to {{new}}.",
        "runImport": "Run Import",
        "runImportConfirmation": {
            "message": "You have no access permissons to the following mapped {{objectTypeName}}(s)<br /><br /> {{message}}<br /><br />",
            "title": "Continue Running Data File Import For File '{{name}}'? {{objectTypeName}}(s) that you have no access permissions to will be skipped.",
            "yesButton": "Yes, Run Import",
            "noButton": "No, Do Not Run Import"
        },

        "saveSuccessText": "Data File Import Configuration '{{name}}' has been saved.",
        "selectObjectHelper": "No valid match - Please select {{objectType}}",
        "steps": {
            "fileInformation": "File Information",
            "objects": "Select Objects",
            "data": "Select Data"
        },
        "tagMapItem": "Column '{{column}}' is mapped to the '{{name}}' tag with event type '{{eventType}}'",
        "tagMap": "Tag Map [{{count}}]",
        "tags": "Tags [{{count}}]",
        "tagType": "Tag Type",
        "timeColumn": "Time Column:",
        "timeColumnPrompt": "Time Column",
        "timezone": "Timezone:",
        "timezoneLabel": "Timezone",
        "uniqueNameText": "The Import name is already in use. Please specify a unique name.",
        "validcsv": "Only valid .CSV files are supported"

    },
    "dataTypeNames": {
        "alarmScheme": "Alarm Scheme",
        "alarmSetpoint": "Alarm Setpoint",
        "attachment": "Attachment",
        "event": "Event",
        "group": "Group",
        "historyItem": "History Item",
        "memo": "Memo",
        "runTicket": "Run Ticket",
        "forms": "Form",
        "map": "Map",
        "mapSection": "Map Section",
        "relationship": "Relationship",
        "recipient":"Recipient",
        "notificationList": "NotificationList",
        "commObject": "Communications Object",
        "protocolObject": "Protocol Object",
        "scheduledReport": "Scheduled Report",
        "dataFileImport": "Data File Import"

    },
    "datetime": {
        "acquisition": "Acquisition Timestamp",
        "modified": "Modified Timestamp",
        "timestamp": "Timestamp",
        "seconds": "seconds",
        "minutes": "minutes",
        "hours": "hours",
        "startTime": "Start Time",
        "endTime": "End Time",
        "startDate": "Start Date",
        "endDate": "End Date",
        "invalidStartTime": "Start time cannot be greater than the end time",
        "invalidEndTime": "End time cannot be less than the start time"
    },
    "defaultConfiguration": {
        "setAsDefaultView": "Set as Default View",
        "description": "Set {{configurationName}} as the default view for the {{groupName}}",
        "myDefault": "Set as My Default View",
        "groupDefault": "Set as Group Default View",
        "usersWithoutDefault": "Apply default view for users without a current default",
        "allUsers": "Override default view settings for all users. (Note: Selecting this option will overwrite all user settings for the {{groupName}} group.)",
        "success1": "The Default View has been set for you and all other users.",
        "success2": "The Default View has been set for you and all users without a current default.",
        "success3": "The Default View has been set for all users.",
        "success4": "The Default View has been set for all users without a current default.",
        "success5": "Your Default View has been set"
    },
    "defaults": {
        "availableColumns": "Available Columns",
        "cancelDefaultsConfirmationDialogText": "You are about to exit without saving {{objectType}} default changes. Are you sure you want to continue and exit without saving?",
        "refreshDefaultsConfirmationDialogText": "You are about refresh without saving {{objectType}} default changes. Are you sure you want to continue and refresh without saving?",
        "defaultsSaved": "The defaults for the object were saved.",
        "defaultTagsFor": "Default Tags for",
        "filterText": "Filter Text",
        "graph": "Graph",
        "mapping": "Mapping",
        "viewSelected": "View Selected"
    },
    "deleteConfirmation": {
        "title": "Are you sure you want to delete this {{itemName}}?",
        "title1": "Are you sure you want to delete {{itemName}}?",
        "confirmationText": "Note: This action cannot be undone.",
        "yesButtonText": "Yes, Delete",
        "noButtonText": "No, Go Back"
    },
    "deleteSuccessMessage": "The {{itemName}} has been successfully deleted.",
    "deviceMarketing": {
        "reportMonth": "Report Month: "
    },
    "diagnosticEventDialog": {
        "addDiagnosticEvent": "New Diagnostic Event",
        "cancelAddText": "You're about to leave New Diagnostic Event without saving your changes. Are you sure you want to continue and exit without saving?",
        "cancelEditText": "You're about to leave Edit Diagnostic Event without saving your changes. Are you sure you want to continue and exit without saving?",
        "diagnosis": "Diagnosis",
        "diagnosisHint": "Select Diagnosis",
        "editDiagnosticEvent": "Edit Diagnostic Event",
        "note": "Note"
    },
    "disableAlarmSetpoint": {
        "title": "Disable Alarm Setpoint",
        "titleAll": "Disable All Alarm Setpoints",
        
        "cancelText": "You're about to leave Disable Alarm Setpoint without saving your changes. Are you sure you want to continue and exit without saving?",
        
        "helpText": "You can temporarily disable the Alarm Setpoint on this device for a specified timeframe. When an Alarm Setpoint is temporarily disabled for a device, no incoming values will be evaluated against the Alarm Setpoint and no alarm or clear notifications will be sent. Once the specified timeframe has elapsed the Alarm Setpoint will be automatically enabled.",
        "helpTextAll": "You can temporarily disable all the Alarm Setpoints on this device for a specified timeframe. When a Alarm Setpoints are temporarily disabled for a device, no incoming values will be evaluated against the Alarm Setpoints and no alarm or clear notifications will be sent. Once the specified timeframe has elapsed the Alarm Setpoints will be automatically enabled.",

        "duration": "Duration",
        "durationUnit": "Unit",
        "beginning": "Beginning",
        "timezone": "Timezone",
        "selectMode": "Select Mode",
        "disableText": "Temporarily disable the Alarm Setpoint for a specified timeframe"
    },
    "disabledRecipientsReport": {
        "timestamp": "Timestamp",
        "actionTaken": "Action Taken",
        "userName": "User Name",
        "recipient": "Recipient",
        "recipientType": "Recipient Type",
        "methodUsed": "Method Used",
        "changedBy": "Changed By",
        "nodata": {
            "title": "",
            "text":"No data has been found for the organization or the period that has been selected."
        },
        "notifyme": {
            "title": "Notify on Recipient Status Change",
            "text": "The system can send you notifications when alarm recipients are disabled or enabled.",
            "instruction": "Please select how you would like to be notified.",
            "noRecipients": "No eligible recipients have been found.",
            "saved": "Saved marked recipients."
        }
    },
    "disableUserNotification": {
        "title": "Disable User Notifications",
        "cancelText": "You're about to leave Disable User Notifications without saving your changes. Are you sure you want to continue and exit without saving?",
        "helpText": "You can temporarily disable notifications to this user for a specified timeframe. When notifications are temporarily disabled for a user, no alarm or clear notifications will be sent to them. Once the specified timeframe has elapsed, notifications will be automatically enabled. If the option to forward notifications is selected, those notifications will be forwarded to an alternate recipient for the selected duration. If longer than one month, the notification lists and schemes will need to be updated.",
        "duration": "Duration",
        "durationUnit": "Unit",
        "beginning": "Beginning",
        "timezone": "Timezone",
        "selectMode": "Select Mode",
        "selectUser": "Select User",
        "disableText": "Temporarily disable notifications for a specified timeframe",
        "forwardText": "Forward notifications for a specified timeframe",
        "notificationMethod": "Notification Method",
        "notificationsDisabledText": "Temporarily disable notifications for {{name}} have been saved",
        "notificationsEnabledText": "Notifications for {{name}} have been enabled",
        "durationWarning": "Notifications cannot be disabled for more than one month. If longer, notification lists and schemes will need to be updated."

    },
    "dialogs": {
        "configDataLimitsDialog": {
            "buttons": {
                "editConfig": "Edit Configuration",
                "editDuration": "Edit Duration"
            },
            "message": "Your request is estimated to return <i><strong>{{numDataValues, number}}</strong> million</i> data values. This exceeds our maximum request limit of <i><strong>{{dataLimit, number}}</strong> million</i> data values.<br><br>To bring the request under the data value limit you can edit the configuration to change the data series from <i>Raw</i> Data to <i>Hourly</i> or <i>Daily</i> Data, include fewer data series, or adjust the duration to a shorter time span.<br><br>How would you like to proceed?",
            "messageNoConfig": "Your request is estimated to return <i><strong>{{numDataValues, number}}</strong> million</i> data values. This exceeds our maximum request limit of <i><strong>{{dataLimit, number}}</strong> million</i> data values.<br><br>To bring the request under the data value limit you can adjust the duration to a shorter time span.<br><br>How would you like to proceed?",
            "messagePreview": "Your request is estimated to return <i><strong>{{numDataValues, number}}</strong> million</i> data values. This exceeds our maximum request limit of <i><strong>{{dataLimit, number}}</strong> million</i> data values.<br><br>To bring the request under the data value limit you can edit the configuration to change the data series from <i>Raw</i> Data to <i>Hourly</i> or <i>Daily</i> Data, include fewer data series, or adjust the duration to a shorter time span.",
            "title": "Maximum Request Limit Reached"
        },
        "graphRowLimitsDialog": {
            "buttons": {
                "editConfig": "Edit Configuration",
                "editDuration": "Edit Duration"
            },
            "message": "Your request is estimated to return <i><strong>{{numRows, number}}</strong> million</i> rows of data. This exceeds our maximum export limit of <i><strong>{{rowLimit, number}}</strong> million</i> rows.<br><br>To bring the request under the row limit you can edit the configuration to change the data series from Raw Data to Hourly or Daily Data, include fewer data series, or adjust the duration to a shorter time span.<br><br><i><i><strong>Note: After changing the configuration or adjusting the duration, the Export button must be clicked again.</strong></i><br><br>How would you like to proceed?",
            "messageNoConfig": "Your request is estimated to return <i><strong>{{numRows, number}}</strong> million</i> rows of data. This exceeds our maximum export limit of <i><strong>{{rowLimit, number}}</strong> million</i> rows.<br><br>To bring the request under the row limit you can adjust the duration to a shorter time span.<br><br><i><i><strong>Note: After adjusting the duration, the Export button must be clicked again.</strong></i><br><br>How would you like to proceed?",
            "title": "Maximum Export Limit Reached"
        },
        "reportRowLimitsDialog": {
            "buttons": {
                "yes": "Yes, Continue",
                "no": "No, Go Back"
            },
            "message": "Your request is estimated to return <i><strong>{{numRows, number}}</strong> million</i> rows of data for Section Name: \"{{sectionName}}\", Section Number: \"{{sectionNumber}}\". This exceeds our maximum export limit of <i><strong>{{rowLimit, number}}</strong> million</i> rows.<br><br>If you continue with this request, you will only be able to view the data on screen.<br><br>Would you like to continue?",
            "title": "Maximum Export Limit Reached"
        },
        "yesContinueButtonText": "Yes, Continue",
        "noGoBackButtonText": "No, Go Back"
    },
    "dragHandle": {
        "tooltip": "Drag to Reorder"
    },
    "dynacard": {
        "noData": "No dynacard data to display.  Please select a different timeframe, then select the dynacards to display.",
        "options": {
            "title": "Dynacard Options"
        },
        "currentDynacard": "Current Dynacard",
        "getCard": "Get Card",
        "getCardSent": "The request to get cards has been sent.",
        "liveStrokes": "Live Strokes",
        "noAnalysisData": "There is no analysis data for this card",
        "noInputData": "There is no input data for this card",
        "noOutputData": "There is no output data for this card",
        "shutdownDynacard": "Shutdown Dynacard",
        "startSampling": "Start Sampling",
        "startupDynacard": "Startup Dynacard"
    },
    "dynamicGroup": {
        "refresh": "Refresh dynamic group"
    },
    "elynxSupport": "eLynx Support",
    "email": "Email",
    "emailRequired": "A valid email address is required.",
    "enums": {
        "alarmNotificationEndingReason": {
            "clear": "Clear",
            "website": "Website",
            "email": "email",
            "voice": "Voice",
            "acknowledged": "Acknowledged",
            "setpointdeleted": "Alarm Setpoint Deleted",
            "text": "Text",
            "mobile": "Mobile",
            "mobile_ios": "Mobile iOS",
            "mobilehtml5": "Mobile HTML 5"
        },
        "dateRangeType": {
            "invalid": "Invalid",
            "raw": "Raw",
            "minute": "Minute",
            "hour": "Hour",
            "day": "Day",
            "week": "Week",
            "month": "Month",
            "year": "Year"
        },
        "waterLossCause": {
            "lineBreak3rdParty": "Line break (3rd party)",
            "lineBreakNon3rdParty": "Line break (Non 3rd party)",
            "unauthorizedUsage": "Unauthorized usage",
            "fireDepartment": "Fire department",
            "systemMaintenance": "System Maintenance",
            "other": "Other"
        },
        "recipientSubType": {
            "cell": "Cell",
            "day": "Day",
            "fax": "Fax",
            "home": "Home",
            "night": "Night",
            "none": "None",
            "work": "Work"
        },
        "recipientType": {
            "email": "Email",
            "fax": "Fax",
            "invalid": "Invalid",
            "text": "Text",
            "voice": "Voice"
        }
    },
    "errors": {
        "authentication": {
            "accountLocked": "Your account has been locked. Please contact your Administrator or eLynx Support.",
            "disabledForCustomer": "Your account has been disabled. Please contact your Administrator or eLynx Support.",
            "loginFailed": "Login failed.  If you continue to receive this message, please contact your Administrator or eLynx Support.",
            "noPermissionsForCustomer": "Your account is currently active, but you have not been granted any security permissions. Please contact your Administrator.",
            "passwordChangeRequired": "Password change required. You must choose a new password in order to continue.",
            "passwordExpired": "Your password has expired. You must choose a new password in order to continue.",
            "ssoNotEnabled": "Your company has not been set up for signing in to the eLynx Application with Microsoft work accounts. Please contact your administrator.",
            "ssoUserNotFound": "Your Microsoft work account has not been set up for signing in to the eLynx Application. Please contact your administrator.",
            "tokenExpired": "Your session has expired. You will need to login again in order to continue."
        },
        "favorites": {
            "invalidHomePageTitle": "Invalid Home Page",
            "notValid": "The '$desc' user favorite is currently set as your home page and is no longer valid. It will be removed from your favorites list."
        },
        "genericMessage": "An error has occurred while processing your request. Details about the error have been logged for our technicians to review. Please retry it in a few minutes."
    },
    "export": "Export",
    "externalContent": {
        "errorTitle": "Unable to load URL",
        "errorMessage":  "The URL cannot be hosted within this application."
    },
    "filterBy": "Filter by name",
    "forms": {
        "template": "Form Template",
        "allTemplates": "All Form Templates",
        "filterTemplates": "Filter Templates",
        "addData": "Add Form Data",
        "editData": "Edit Form Data",
        "viewData": "View Form Data",
        "cancelAddDataText": "You're about to leave Add Form Data without saving your changes. Are you sure you want to continue and exit without saving?",
        "formDataSaved": "Data for \"{{name}}\" has been saved.",
        "details": "Form Details",
        "title": "Forms",
        "close": "Close the form"
    },
    "formula": {
        "bitsInstruction": "Select the bits to check",
        "instructions": "Choose a formula type and enter the formula options in the fields below.",
        "type": "Formula Type",
        "description": "Description",
        "input": "Input",
        "value": "Value",
        "newFormula": "New Formula",
        "reverseFormula": "Reverse Formula",
        "test": "Test",
        "output": "Output",
        "formulaExists": "A formula with this equation already exists.",
        "descriptionExists": "A formula with this description already exists.",
        "swap": "Swap",
        "rescaleInstructions": "Enter any pair of matching input and output values into the fields below to generate a formula for converting from the input values to the output values.  For instance Input Low - 1 & High = 5 to Output Low 0 & High 15 builds a formula to scale readings from a 1-5 volt 15 lb pressurce transducer.",
        "low": "Low",
        "high": "High",
        "saved": "Formula {{description}} saved successfully."


    },
    "gaugeSheetExport": {
        "allDevices": "Include all devices in this group",
        "selectDevices": "Select specific devices",

        "exportDuration": "Export Duration",
        "exportOptions": "Export Options",
        "dataOptions": "Data Options",
        "deviceOptions": "Device Options",
        "deliveryOptions": "Delivery Options",
        "documentType": "Document Type",
        "emailMe": "Email me when complete",
        "includeGaugeSheet": "Include Gauge Sheet data",
        "includeRuntickets": "Include Run Ticket data",
        "msExcel": "Microsoft Excel",
        "pdf": "PDF"
    },
    "group": {
        "addGroup": "Add Child Group",
        "allocationPct": "Allocation Percentage",
        "anyTagInAlarm": "Any Tag in Alarm",
        "availableObjects": "Available {{objectType}}",
        "byEnablingSystemBalance": "By enabling System Balance functionality, wells can be marked as inlets or outlets, and the production from each can be compared to ensure that production is not being lost.",
        "systemBalanceEditingInstructions": "<div>For each device in the list click on the field showing \"Inlet\" to change the type to \"Outlet\" or \"Other\" as necessary.</div><div>For each device in the list you can set the Allocation Percentage for the current Group.</div>",
        "cannotDelete": "Cannot delete this group, it contains child groups.",
        "cancelText": "You're about to leave {{name}} without saving your changes. Are you sure you want to continue and exit without saving?",
        "deleteAllCriteriaText": "Are you sure you want to delete all dynamic criteria for this group?",
        "deleteCriterionText": "Are you sure you want to delete this Criterion?",
        "changeGroupConfirmation": {
            "title": "Are you sure you want to change groups?",
            "text": "You are about to change groups without saving your changes.  Are you sure you want to continue without saving?"
        },
        "deleteCriteriaTitle": "Delete Criteria",
        "deleteCriterionTitle": "Delete Criterion",
        "deleteGroupText": "Are you sure you want to delete '{{name}}'?",
        "deleteGroupTitle": "Confirm Group Delete",
        "dynamicGroupTarget": "{{name}}' cannot be deleted because it is used in dynamic group criteria for the following groups: ",
        "editGroup": "Edit Group",
        "enableDynamicGrouping": "Enable Dynamic Grouping for this group",
        "enableSystemBalance": "Enable System Balance for this group",
        "dynamicGroupsContain": "Dynamic groups contain devices that meet a set of specified criteria. The criteria can be based on attributes, tag values, and alarm states. The criteria is applied in real-time, enabling group operations, from Summary Listings to reports, to take on a dynamic, targeted nature.",
        "dynamicGroupsCouldBeSetUp": "For example, a group could be set up to contain devices that have a particular tag in alarm. By selecting the group in the navigation tree, the Summary Listing for the group would contain only devices with the specified tag in alarm.",
        "dynamicGroupsLogic": "Note that devices must meet all specified criteria in order to be included in the group dynamically.",
        "dynamicGroupCriteriaRequiredTitle": "Dynamic Group Criteria Required",
        "dynamicGroupCriteriaRequiredMessage": "You have enabled Dynamic Grouping on this group, but no criteria are currently defined. Would you like to disable Dynamic Grouping for this group?",
        "childGroups": "Child Groups",
        "maxNameLength": "Name cannot be greater than 50 characters",
        "maxFieldLength": "{{field}} cannot be greater than {{max}} characters",
        "nameUnique": "Group Name must be unique",
        "noChildGroups": "No child groups exist for this group.",
        "parent": "Parent",
        "peerGroupText": "This group is a peer group of an organization and cannot be re-parented.",
        "totalHeader": "Content: {{count}} devices.  ",
        "polledDevices": "Polled devices",
        "alarmLynxDevices": "AlarmLynx devices",
        "compressorLynxDevices": "CompressorLynx devices",
        "wells": "Wells",
        "noDevices": "There are no devices in this group",
        "noSelectedObjects": "There are no selected {{objectType}} in this group",
        "noDynamicCriteria": "No dynamic criteria are configured for this group",
        "filter": "Filter",
        "selectObjectType": "View Object Type",
        "selectedObjects": "Selected {{objectType}}",
        "successfullyUpdatedContents": "Successfully updated group contents.",
        "successfullyUpdatedDynamicGroup": "Successfully updated dynamic group configuration.",        
        "successfullyUpdatedManualEntry": "Successfully updated group manual entry configuration.",
        "successfullyUpdatedSystemBalance": "Successfully updated group system balance configuration.",
        "summaryListingOrder": {
            "label": "Summary Listing Order",
            "alphanumeric": "Alphanumeric",
            "custom": "Custom"
        },
        "systemBalanceDesignation": "System Balance Designation",
        "systemBalanceInvalidAllocation": "The value for allocation percentage must be >= 0 and <= 100",
        "systemBalanceWarning": "Note that all devices included dynamically will be classified as system balance inlets.",
        "viewSelected": "View Selected {{name}}",
        "viewSelectedAndReorder": "View Selected {{name}} and Order",
        "noManualEntryTags": "There are no devices in this group from which to select manual entry tags from.",
        "selectSource": "Select Source Device",
        "selectTarget": "Select Target Device",
        "sourceHelper": "Choose the Device whose Group membership you would like to clone.",
        "targetHelper": "Choose the Device that will be added to the groups to which the source device belongs.",
        "groupsContaining": "Groups containing '{{name}}':",
        "cloneConfirmDescription": "<div>You are about to add the Target Device to all Groups the Source Device currently belongs to.  This action will not remove the Target Device from any Groups it currently belongs to.</div><br /><div>Are you sure you want to clone Group membership?</div>",
        "cloneConfirmMembershipTitle": "Confirm Group Membership Updates",
        "cloneMembershipResult": "Target device added to {{count}} Groups.",
        "deviceNotInGroup": "The selected device is not a member in any group.",
        "sourceGroup": "Select Source Group",
        "anyTag": "Any Tag",
        "isInAlarm": "is in alarm",
        "isEqual": "is equal to",
        "attributeValueCriterion": "{{operation}} Attribute Value Criteria",
        "tagValueCriterion": "{{operation}} Tag Value Criteria",
        "alarmCriterion": "{{operation}} Alarm Criteria",
        "warning": {
            "dynamicGroup": {
                "title": "Dynamic Group Detected",
                "text": "Custom ordering of objects is not available on groups that are configured for Dynamic Grouping. Please contact your administrator for assistance."
            },
            "systembalance": {
                "title": "System Balance Group Detected",
                "text": "Custom ordering of objects is available on groups that are configured for System Balance, but it will override the System Balance ordering. Do you still want to use custom ordering for this configuration?"
            }


        },
        "tag": "Tag",
        "setpoint": "Setpoint",
        "tagInAlarm": "Tag in Alarm",
        "setpointInAlarm": "Setpoint in Alarm"
    },
    "groupMarketingReport": {
        "reportMonth": "Report Month: ",
        "reportTag": "Report Tag: "
    },
    "helpMenu": {
        "assistance": "Assistance",
        "contactSupport": "Contact Support",
        "contactSupportDescription": "Get help from our expert Support Agents",
        "contactSupportForAssistance": "Get help from our expert Support Agents for assistance",
        "cobrowse": "Get Remote Support Code",
        "cobrowseDescription": "Use this option when directed by eLynx Support",
        "cobrowseCodeText": "Your remote support code is: {{code}}",
        "hardwareOrder": "Hardware Order Form",
        "hardwareOrderDescription": "Need additional hardware? Click to order!",
        "help": "Help",
        "legal": "Legal",
        "onlineHelp": "Online Help",
        "privacyPolicy": "Privacy Policy",
        "recentUpdates": "Recent Updates",
        "recentUpdatesDescription": "Check out the latest features and updates",
        "searchHelp": "Search our Help Files",
        "searchHelpDescription": "Find the answers you need in our extensive help articles",
        "submitIdea": "Submit Product Idea",
        "submitIdeaDescription": "Have an idea for a future release of our software? Click to Submit!",
        "termsOfService": "Terms and Conditions",
        "about": "About",
        "version": "Version {{version}}"
    },
    "historicalData": {
        "noTagsFound": "No Historical Data tags have been found for this device.",
        "noData": "No Historical Data found for the selected date range."
    },
    "hmiView": {
        "options": {
            "viewList": {
                "placeholder": "Choose a View",
                "shared": "Shared Views",
                "sharedReadOnly": "Shared Read-Only Views",
                "private": "Private Views"
            },
            "scaleToFit": "Scale to Fit",
            "showMiniMap": "Show Mini Map",
            "showControls": "Show Controls"
        },
        "messages": {
            "selectOrCreateView": {
                "text": "Please choose a saved View from the Options panel, or create a new View.",
                "title": "No View"
            }
        }
    },
    "hmiConfiguration": {
        "steps": {
            "pages": {
                "title": "Image View Pages",
                "editPageView": "Edit Page View",
                "info": "A View can have multiple Pages of data. The following options are specific to each View Page that you build.",
                "addPage": "Add Page",
                "pageName": "Page Name"
            },

            "selectImage": {
                "title": "Select Image"
            },

            "selectContents": {
                "title": "Select Contents",
                "tabs": {
                    "devices": {
                        "title": "Devices"
                    },
                    "tanks": {
                        "title": "Tanks"
                    },
                    "wells": {
                        "title": "Wells"
                    }
                }
            },
            "screenLayout": {
                "title": "Screen Layout"
            }
        },
        "exceptions": {
            "nameInUse": {
                "message": "A view with the specified name already exists. Please choose a different name.",
                "title": "Duplicate Names Are Not Allowed"
            }
        },
        "modals": {
            "removePanelItemsConfirmation": {
                "title": "Remove selected items?",
                "text": "Are you sure you want to remove the selected items from the page?",
                "yesButton": "Yes, Remove",
                "noButton": "No, Do Not Remove"
            },
            "removeObjectConfirmation": {
                "title": "Remove Object?",
                "text": "There are items in this page's layout that are related to this object. If you remove this object, the related items will be removed from the layout. Do you wish to continue?",
                "yesButton": "Yes, Continue",
                "noButton": "No, Cancel"
            },
            "uploadImage": {
                "title": "Upload Image",
                "errors": {
                    "fileExtensionWarning": "Please select a file with valid file extension (.gif, .png, or .jpg, ).",
                    "fileSizeWarning": "Please select a file that is less 10 MB in size.",
                    "uploadImageError": "There was an error uploading your image file.",
                    "descriptionInUse": {
                        "message": "An image with the specified description already exists.  Please choose a different description.",
                        "title": "Duplicate Descriptions Are Not Allowed"
                    }
                }
            },
            "ruleEditDialog": {
                "title": "Edit Rules",
                "cancelEditText": "You're about to leave Edit Rules without saving your changes. Are you sure you want to continue and exit without saving?"
            },
            "layerStyleEditDialog": {
                "title": "Edit Layer Style",
                "cancelEditText": "You're about to leave Edit Layer Style without saving your changes. Are you sure you want to continue and exit without saving?",
                "sections": {
                    "attributes": {
                        "title": "Attributes"
                    },
                    "layout": {
                        "title": "Layout"
                    },
                    "properties": {
                        "title": "Properties",
                        "tabs": {
                            "container": {
                                "title": "Default Style"
                            },
                            "actions": {
                                "title": "Actions"
                            },
                            "label": {
                                "title": "Label"
                            },
                            "value": {
                                "title": "Value"
                            }
                        },
                        "alignment": {
                            "title": "Alignment"
                        },
                        "font": {
                            "title": "Font",
                            "fontColor": "Font Color",
                            "fontSize": "Font Size",
                            "fontWeight": "Font Weight",
                            "fontStyle": "Font Style"
                        },
                        "border": {
                            "title": "Border",
                            "borderColor": "Border Color",
                            "borderStyle": "Border Style",
                            "borderWidth": "Border Width",
                            "borderRadius": "Border Radius"
                        },
                        "background": {
                            "title": "Background",
                            "backgroundColor": "Background Color"
                        }
                    }
                }
            },
            "layerLayoutPickerDialog": {
                "title": "Select {{assetTypeName}} Layer Layout"
            }
        },
        "assetTypeNames": {
            "image": "Image",
            "images": "Images",
            "device": "Device",
            "devices": "Devices",
            "well": "Well",
            "wells": "Wells",
            "tank": "Tank",
            "tanks": "Tanks",
            "attribute": "Attribute",
            "attributes": "Attributes",
            "dataValue": "Data Value",
            "dataValues": "Data Values",
            "historicalData": "Historical Data",
            "historicalDatas": "Historical Data",
            "tankBattery": "Tank Battery",
            "tankBatteries": "Tank Batteries",
            "group": "Group",
            "groups": "Groups",
            "text": "Text",
            "texts": "Texts"
        }
    },
    "ipaddress": "IP Address",
    "liquidProd": {
        "addRunTicket": "Add Run Ticket",
        "createTank": "Create New Tank",
        "interfaceLevel": "Interface Level",    
        "oil": "Oil",
        "oilStock": "Oil Stock",
        "tankOverflow": "Overflow",
        "tankRemainingCapacity": "Remaining capacity",
        "topLevel": "Top Level",
        "topLevels": "Tank Top Levels",
        "water": "Water",
        "waterStock": "Water Stock",
        "gaugeSheetDate": "Gauge Sheet for",
        "formDate": "Manual Entry for",
        "goToTankBattery": "Go to Tank Battery",
        "goToRunTickets": "Go to Run Tickets",
        "showDevice": "Show Device Columns",
        "showTanks": "Show Tank Columns",
        "legend": {
            "title": "Legend",
            "manualEntry": "Manual Entry Value",
            "calculated": "Calculated Value",
            "tankEvent": "Tank Configuration Change"
        },
        "mode": {
            "title": "View Mode",
            "form": "Form View",
            "spreadsheet": "Spreadsheet View"
        },
        "invalidTopLevel": "The Top level must be greater than or equal to the Interface level.",
        "invalidInterfaceLevel": "The Interface level must be less than or equal to the Top level.",
        "combinedTargetProduction": "Combined Target Production",
        "oilTargetProduction": "Oil Target Production",
        "liquidProduction": "Liquid Production",
        "tankBattery": {
            
            "form": {
                "oilAllocationTag": "Oil Allocation Tag",
                "waterAllocationTag": "Water Allocation Tag",
                "oilTransferTag": "Oil Transfer Tag",
                "waterTransferTag": "Water Transfer Tag"

            },

            "delete": {
                "title": "Delete Tank Battery",
                "text": "Are you sure you want to delete '{{name}}'?"
            },
            "noSelectedObjects": "There are no selected {{objectType}} in this tank battery",
            "oilTanks": "Oil Tanks",
            "waterTanks": "Water Tanks",
            "steps": {
                "properties": "Properties",
                "devicesAndTanks": "Devices and Tanks",
                "allocationTags": "Allocation Tags",
                "tags": "Allocation and Transfer Tags"
            }

        },
        "tankForm": {
            "tankName":"Tank Name",
            "tankStyle":"Tank Style",
            "resource": "Resource",
            "dualPhase": "Dual Phase",
            "contractHour": "Contract Hour",
            "nameRequired": "Name is required and must be unique",
            "nameLength": "Name cannot be greater than 50 characters",
            "nameUnique": "Name must be unique",
            "oil": "Oil",
            "water": "Water",
            "tankAddedSuccess": "The tank {{name}} has been added to the Battery {{tankBattery}}. This tank is now ready for manual data entry, if tank levels are to be automated please contact eLynx Support to setup registers"

        },
        "tankPad": {
            "capacity":"Capacity (Barrels):  {{value}}",
            "contractHour":"Contract Hour:  {{value}}",
            "buttons": {
                "createTank": "Create Tank",
                "edit": "Edit",
                "delete": "Delete",
                "addTankPad": "Add Tank Pad",
                "editTankPad": "Edit Tank Pad",
                "deleteTankPad": "Delete Tank Pad",
                "addTankBattery": "Add Tank Battery",
                "editTankBattery": "Edit Tank Battery",
                "deleteTankBattery": "Delete Tank Battery",
                "addTank": "Add Tank",
                "newTank": "New Tank"

            },
            "filterLabel": "Filter by Name",
            "tankNumber": "Tank Number:  {{value}}",
            "nameRequired": "Name is required",
            "nameLength": "Name cannot be greater than 50 characters",
            "nameUnique": "Name must be unique",
            "oilAllocationTag": "Oil Allocation Tag:  {{value}}",
            "waterAllocationTag": "Water Allocation Tag:  {{value}}",
            "oilTransferTag": "Oil Transfer Tag:  {{value}}",
            "waterTransferTag": "Water Transfer Tag:  {{value}}",
            "tankBatteryCount": "Tank Batteries [{{value}}]",
            "nodata": {
                "devices": {
                    "title": "No Devices",
                    "text": "There are no devices available or that match the text entered in the filter."
                },
                "tankBatteries": {
                    "title": "No Tank Batteries",
                    "text": "There are no tank batteries available or that match the text entered in the filter."
                },
                "tanks": {
                    "title": "No Tanks",
                    "text": "There are no tanks available or that match the text entered in the filter."
                },
                "title": "No Tank Pads",
                "text": "There are no tank pads in the selected organization.  Click the 'Add Tank Pad' button to create a new tank pad."

            },
            "saved": "{{name}} has been saved.",
            "deleted": "{{name}} has been deleted."


        }
    },

    "gasProd": {
        "gas": "Gas",
        "gasTargetProduction": "Gas Target Production",
        "gasProduction": "Gas Production"
    },

    "livedata": {
        "communicationFailed": "Communication with the {0} could not be established.  Please try again later. If this problem persists contact eLynx support.",
        "demandscan": "Demand Scan",
        "demandscanComplete": "Demand Scan Complete",
        "demandscanCanceled": "Demand Scan on {0} canceled",
        "demandscanFailed": "Demand Scan on {0} failed",
        "demandscanSuccess": "Demand Scan on {0} has finished",

        "testChangeRegisterFailed": "Change register test failed.",
        "testChangeRegisterSuccess": "Change register test completed successfully.",
        "initiatingChangeRegisterTest": "Initiating change register test.",

        "establishCommunication": "Establishing communication with {0}",
        "makeChanges": "Make Changes",
        "reviewChanges": "Review Changes",
        "reviewChangesDesc": "The following data values have changes that will be written to the device. Please review these changes to ensure the data values are correct. You can deselect any modified data values you do not want to write to the device.",
        "writedown": "Write Down",
        "writedownComplete": "Write Down Complete",
        "writedownCanceled": "Write Down on {0} canceled",
        "writeDownFailed": "Write Down on {0} failed",
        "writeDownSuccess": "Write Down on {0} has finished",
        "currentvalue": "Current Value",
        "newvalue": "New Value",
        "noTags": "There are no writeable tags or tags that match the text entered in the filter.",
        "confirmWriteDown": {
            "text": "Would you like to make changes without retrieving current values?",
            "yes": "Yes, Make Changes",
            "no": "No, Retrieve Values",
            "noCancel": "No, Cancel"
        },
        "failedText": "{{count}} of {{total}} tags failed.",
        "successText": "{{count}} of {{total}} tags succeeded.",
        "writedownTitle": "Write Down to {{name}}"
    },
    "login": {
        "emailAddress": "Email Address",
        "forgotPassword": "Forgot password?",
        "forgotPasswordSent": "A password reset email will be sent to your User Login email address, containing a link allowing you to reset your password if your account is active. Please contact support if you haven't received the reset e-mail in the next 20 minutes.",
        "initializing": "Initializing",
        "otp": "One Time Password",
        "otpEmailSent": "Your OTP has been mailed to you.",
        "password": "Password",
        "rememberMe": "Remember my email address",
        "sendLoginInfo": "Send Login Info",
        "signingIn": "Signing in",
        "terms1": "By logging in, you agree to our ",
        "terms2": "",
        "sendLoginEmail": "Send Login Email",
        "passwordToBeSent": "A password reset email will be sent to {{login}}, containing a link allowing them to reset their password. Are you sure you want to send a password reset email?",
        "yesSendEmail": "Yes, send email",
        "resetPasswordSent": "Login email has been sent."
    },
    "lookupList": {
        "added": "Lookup list {{name}} was successfully added",
        "addListText": "Add Text Description",
        "basedOn": "Based on",
        "category": "Category",
        "deleteConfirmation": {
            "title": "Are you sure you want to delete \"{{name}}\"?",
            "text": "Note: This action cannot be undone.",
            "yesButtonText": "Yes, Delete",
            "noButtonText": "No, Go Back"
        },
        "deleted": "Lookup list {{name}} was successfully deleted",
        "listText": "List Text",
        "usage": "Usage",
        "nameRequired": "A Lookup List name is required",
        "nameLength": "The Lookup List name cannot be more than 50 characters",
        "nameUnique":"The lookup list name must be unique name.",
        "nodata": {
            "title": "No Lookup Lists",
            "text": "There are no lookup lists or that match the text entered in the filter.",
            "usage": "Lookup List is not in use",
            "listText": "There are no  text descriptions for this look up list."
        },
        "removeListText": "Remove Text Description",
        "updated": "Lookup list {{name}} was successfully updated",
        "subCategory": "Subcategory",
        "textDescriptions": "Text Descriptions",
        "maxDescriptionLength": "Text Description cannot be greater than 100 characters",
        "valueUnique": "The value cannot be the same as another text description value.",
        "valueRequired": "Value is required"
    },
    "manualEntry": {
        "deleteConfirmation": "Delete Confirmation",
        "deleteConfirmationText": "Are you sure you want to delete the selcted data value?",
        "pickerLabel": "Manual entry for",
        "tagManualEntryModalTitle": "Add New Value",
        "tagManualEntryNoData": "There are no values for the specified duration.",
        "tagManualEntryNewValue": "New Value",
        "valueSaved": "Manual tag value successfully added.",
        "cancelAddText": "You're about to leave Add New Value without saving your changes. Are you sure you want to continue and exit without saving?",
        "valueRequired": "Value is required",
        "title": "Manual Entry {{name}}"
    },
    "mapping": {
        "actions": {
            "upload": "Upload GIS Files"
        },
        "currentGroup": "Current Group",
        "list": {
            "placeholder": "Choose a Configuration",
            "shared": "Shared Mapping Configurations",
            "sharedReadOnly": "Shared Read-Only Mapping Configurations",
            "private": "Private Mapping Configurations"
        },
        "disableClustering": "Disable Clustering",
        "filterShapeFiles": "Filter GIS Files",
        "hideAlarmBanner": "Hide Alarm Banner",
        "hideDataLayer": "Hide Data Layer",
        "objectsOnScreen": "Objects on Screen",
        "tagsOnScreen": "Tags on Screen",
        "shapeFiles": "GIS Files",
        "showActiveAlarms": "Show Active Alarms For",
        "zoomToDevice": "Zoom to Device",
        "uploadDialog": {
            "title": "Upload GIS Files",
            "gisFileType": "GIS File Type",
            "kmz": "KML or KMZ File",
            "prj": "Projection File",
            "shapeProject": "Shape and Projection files",
            "shp": "Shape File",
            "maxSizeExceededTitle": "File Too Large",
            "maxSizeExceededConfirmation": "The selected file exceeds the maximum file size of {{maxSizeBytes}} bytes. Please select a smaller file and try again.",
            "fileExistsTitle": "Overwrite GIS File",
            "fileExistsConfirmation": "A GIS file with that name already exists, would you like to replace it?"
        }
    },
    "mapViewConfiguration": {
        "allDeviceTypes": "All Device Types",
        "sections": "Sections",
        "selectContents": "Select Data",
        "dataValues": "Data Values",
        "attributes": "Attributes",
        "filterLabel": "Filter by Name",
        "viewSelectedLabel": "View Selected",
        "deviceTypeChangeConfirmation": {
            "title": "Are you sure you want to change the device type?",
            "confirmationText": "Tags have already been selected for this map section. If you change the device type, the list of selected tags will be reset and you will have to select new ones.",
            "yesButtonText": "Yes, Change",
            "noButtonText": "No, Go Back"
        },
        "options": "Map Options",
        "selectedShapeFilesLabel": "Show these GIS files",
        "overlayOptions": "Select Overlay Options",
        "include": "Include",
        "dataValue": "Data Value",
        "showOnMap": "Show on Map",
        "label": "Label",
        "optionalDisplayName": "Optional Display Name",
        "mapSections": "Map Sections",
        "shownOnMapLimitExceededDialog": {
            "title": "Data Card Item Limit Exceeded",
            "confirmationText": "The data layer can only show 4 values at a time, adding more values will cause a scroll area to be displayed in the data card."
        }
    },
    "memoAutoText": {
        "add": "Add Entry",
        "cancelChanges":"You're about to cancel editing memo auto-text entries without saving your changes. Are you sure you want continue and cancel without saving?",
        "chooseObjectType": "Select an object type...",
        "entries": "Memo Auto-Text Entries",
        "instructions": "Select an object type to begin managing memo auto-text entries.",
        "addInstructions": "There are no memo auto-text entries for the selected object type.  Click the 'Add Entry' button to create new memo auto-text entries.",
        "valueRequired": "Text is required",
        "maxLength": "Memo auto-text cannot be greater than 256 characters",
        "valueUnique": "The value cannot be the same as another memo auto-text value.",
        "savedMessage": "Memo Auto-Text for '{{objectType}}' successfully saved."


    },
    "memo": "Memo",
    "memos": "Memos",
    "memoDialog": {
        "addMemo": "New Memo",
        "cancelAddText": "You're about to leave New Memo without saving your changes. Are you sure you want to continue and exit without saving?",
        "cancelEditText": "You're about to leave Edit Memo without saving your changes. Are you sure you want to continue and exit without saving?",
        "editMemo": "Edit Memo"
    },
    "navigation": {
        "groupHierarchy": "Group Hierarchy",
        "hierarchy": "Hierarchy",
        "home": "Home",
        "menu": "Menu",
        "organizations": "Organizations",
        "groups": "Groups",
        "favorites": "Favorites"
    },
    "noData": {
        "title": "No Data",
        "noDataFound": "No data found.",
        "noDataWithinDateRange": "No data within date range {0} - {1}.",
        "noDataForChart": "Cannot display chart using one data point.",
        "noDataForChartWithinDateRange": "Cannot display chart using one data point within date range {0} - {1}.",
        "noDataForMonthYear": "No data could be found for the selected month and year.",
        "nodatafoundforsection": "No data found for this section.",
        "noDataFoundForPeriod": "No data for time period.",
        "noDataForObject": "No data for \"{{objectName}}\".",
        "noDataForObjectSearch": "There are no \"{{objectName}}\" matching the search filter you entered.",
        "noDataComparisonBeginning": "No data with override duration beginning {{offset}} {{type}} earlier",
        "noDataComparisonSpecificStart": "No data with override duration starting on {{date}}",
        "noDataForObjectWithinDateRange": "No data within date range {{startDate}} - {{endDate}} for \"{{objectName}}\".",
        "noDataForChartObject": "Cannot display chart using one data point for \"{{objectName}}\".",
        "noDataForChartObjectWithinDateRange": "Cannot display chart using one data point within date range {{startDate}} - {{endDate}} for \"{{objectName}}\".",
        "noDataTypesForObject": "There are no {{dataTypeName}}s for \"{{objectName}}\".",
        "noDataTypesForObjectForPeriod": "There are no {{dataTypeName}}s for \"{{objectName}}\" during the configured time period.",
        "noFilteredDataTypesForObject": "There are no {{dataTypeName}}s for \"{{objectName}}\" that match the selected filter criteria."
    },
    "noDescription": "No description",
    "noFirstName": "No first name",
    "noLastName": "No last name",
    "noLogin": "No login",
    "noName": "No name",
    "normal": "Normal",
    "notificationMessage": {
        "export": "Export",
        "liveData": "Live Data Status",
        "graphReport": "Graph Result",
        "report": "Report Result"
    },
    "notificationOptOut": {
        "doNotShowAgain": "Don't show me this again"
    },
    "pageActions": "Page Actions",
    "plungerAnalysis": {
        "nodata": {
            "plungerCycles": "No plunger cycles found for this device."

        },
        "cycles": "cycles",
        "showPrevious": "Show previous",
        "tabs": {
            "currentValues": "Current Values",
            "cycles": "Plunger Cycles",
            "defaultTrend": "Default Trend",
            "historicalData": "Historical Data",
            "imageView": "Image View",
            "statusMessages": "Status Messages"

        }

    },
    "pollingFrequencyAdmin": {
        "filterBy":"Filter by {{name}}",
        "viewSelected":"View Selected {{name}}",
        "objectInterval": "{{objectType}} polling interval",
        "modifyInstructions": "Choose the polling schedule interval for the {{objectType}} or for any individual tags on the {{objectType}}.",
        "newSchedule": "New Schedule",
        "nodata": {
            "noFilterMatch": "There are no {{name}} that match the text entered in the filter or the selected polling schedule.",
            "title": "There are no objects for which polling frequencies can be set in the '{{name}}' Group",
            "text": "You can add Devices to this Group using the 'Group Administration' Site Configuration view"
    
        },
        "tagType": "Tag Type",
        "tagTypes": "Tag Types",
        "dataSavedMessage": " The Polling Schedules have been updated.",
        "highFrequencyWarning": {
            "title": "NOTICE: High Frequency Data",
            "text": "Some data values have been set to high frequency polling.  High frequency polling may cause network congestion on field radio networks, increased power usage, or result in additional communication data costs. Are you sure you want to continue?"
        }

    },
    "objectDetails": {
        "liftController": "Lift Controller",
        "description": "Description",
        "value": "Value",
        "category": "Category",
        "tabs": {
            "tagValues": "Tag Values",
            "properties": "Properties",
            "defaults": "Defaults",
            "alarmSetpoints": "Alarm Setpoints",
            "attachments": "Attachments",
            "history": "History",
            "membership": "Membership",
            "relationships": "Relationships",
            "runTickets": "Run Tickets"
        }
    },
    "objectHistory": {
        "alarmItem": {
            "eLynxAlarm": "eLynx Alarm",
            "alarmText": "{{setpointName}} ({{tagName}} = {{value}} {{uom}})"
        },
        "settingChangeItem": {
            "changeText": "The value on {{tagName}} was changed from {{oldValue}} to {{newValue}}",
            "newText": "A new manual entry value of {{newValue}} was added to {{tagName}}"
        },
        "eventItem": {
            "dataQualityAbnormalSynopsis": "A potential problem with Data Quality on {{tagName}} has been detected.",
            "deviceAbnormalSynopsis": "The device is behaving abnormally.",
            "wellAbnormalSynopsis": "The well is behaving abnormally.",
            "dataQualityNormalSynopsis": "Data Quality on {0} has returned to normal behavior.",
            "deviceNormalSynopsis": "The device has returned to normal behavior.",
            "wellNormalSynopsis": "The well has returned to normal behavior.",
            "deviceDiagnosis": "The latest diagnosis is ",
            "wellDiagnosis": "The latest diagnosis is ",
            "endSummary": " started at {{startTime}} and lasted {{durationText}}.",
            "on": "on",
            "formCreated": "{{formName}} form was created.",
            "formOpened": "{{formName}} form was opened.",
            "formClosed": "{{formName}} form was closed.",
            "waterLossAbnormalSynopsis": "Potential water loss has been detected. The probable cause is ",
            "waterLossNormalSynopsis": "Potential water loss has been resolved.",
            "waterLossEndSummary": " started at {{startTime}}, lasted {{durationText}}, and resulted in an estimated loss of {{estimatedLoss}} gallons.",
            "waterLossDueTo": "Loss due to "
        }
    },
    "objectHistoryFilter": {
        "filter": "Filter",
        "filterText": "Filter Text",
        "memos": "Memos",
        "settingsChange": "Settings Change",
        "alarms": "Alarms",
        "diagnosticEvents": "Diagnostic Events",
        "dataQualityEvents": "Data Quality Events",
        "formEvents": "Form Events",
        "manualEvents": "Manual Events"
    },
    "objectTagValues": {
        "graph": "Graph",
        "grid": "Grid",
        "noDataCharts": "No Default Trending TATs are configured. Choose the 'Defaults' tab for configuration.",
        "selectView": "Select View",
        "showAlarmSetpointThresholds": "Setpoint Thresholds",
        "showTagDescriptions": "Show Tag Descriptions",
        "tankLevels": "Tank Levels",
        "noTankLevelData": "No tank level data is available for the selected time frame",
        "liquidHeight": "Liquid Height",
        "liquidStock": "Liquid Stock",
        "dataError": "Unexpected data error",
        "dataErrorText": "There was a problem retrieving the data for this object. Please contact eLynx Support for assistance.",
        "columnOptions": {
            "label": "Show Additional Columns",
            "showUIDColumn": "Show UID Column",
            "showReadItemColumn": "Show Read Item Column",
            "showWriteItemColumn": "Show Write Item Column",
            "showLiveDataColumn": "Show Live Data Column",
            "showLookupListColumn": "Show Lookup List Column",
            "showFormulaColumn": "Show Formula Column"
        },
        "filterTagGroups": "Filter Tag Groups",
        "filterPollingSchedules": "Filter Polling Schedules",
        "tagGroups": "Tag Groups",
        "viewList": {
            "label": "Choose a View",
            "placeholder":"All Tags",
            "shared": "Shared Views",
            "sharedReadOnly": "Shared Read-Only Views",
            "private": "Private Views"
        }
    },
    "objectTagValuesConfiguration": {
        "steps": {
            "landing": {
                "title": "Device Details",
                "editTagGroup": "Edit Tag Group",
                "info": "A View can have multiple sections or custom tag groups.",
                "addTagGroup": "Add Tag Group",
                "customTagGroup": "Custom Tag Group"
            },
            "selectTags": {
                "title": "Select Tags",
                "tabs": {
                    "tagValues": {
                        "title": "Tag Values"
                    }
                },
                "viewSelected": "View Selected Tags",
                "viewAll": "View All Tags"
            },
            "displayOptions": {
                "title": "Display Options",
                "tabs": {
                    "tagValues": {
                        "title": "Tag Values"
                    }
                }
            },
            "screenLayout": {
                "title": "Screen Layout"
            }
        },
        "exceptions": {
            "nameInUse": {
                "message": "A view with the specified name already exists. Please choose a different name.",
                "title": "Duplicate Names Are Not Allowed"
            }
        }
    },
    "objectType": "Object Type",
    "objectName": "Object Name",
    "objectTypeNames": {
        "accounting": "Accounting",
        "alarmSchedule": "Alarm Schedule",
        "alarmSchedules": "Alarm Schedules",
        "alarmScheme": "Alarm Scheme",
        "alarmSchemes": "Alarm Schemes",
        "applicationType": "Application Type",
        "attribute": "Attribute",
        "attributes": "Attributes",
        "attributeValueOption": "Attribute Value Option",
        "basin": "Basin",
        "communicationDevice": "Communication Device",
        "communicationDevices": "Communication Devices",
        "customer": "Customer",
        "customers": "Customers",
        "dataFileImportConfig": "Datafile Import Configuration",
        "device": "Device",
        "devices": "Devices",
        "deviceConfiguration": "Device Configuration",
        "drcConfigInstance": "DRC Config Instance",
        "drcConfigInstances": "DRC Config Instances",
        "drcConfigInstanceCollection": "DRC Config Instance Collection",
        "drcConfigInstanceCollectionss": "DRC Config Instance Collections",
        "drcExtendedConfig": "DRC Extended Configuration",
        "dynacard": "Dynacard",
        "dynacards": "Dynacards",
        "facility": "Facility",
        "facilities": "Facilities",
        "field": "Field",
        "formulae": "Formulae",
        "groupTrendConfiguration": "Group Trend Configuration",
        "groupTrendConfigurations": "Group Trend Configurations",
        "group": "Group",
        "groups": "Groups",
        "lookupList": "Lookup List",
        "lookupLists": "Lookup Lists",
        "lookupListText": "Lookup List Text",
        "lookupListTexts": "Lookup List Texts",
        "memo": "Memo",
        "memos": "Memos",
        "memoAutoText": "Memo Auto Text",
        "none": "None",
        "notificationList": "Notification List",
        "notificationLists": "Notification Lists",
        "organization": "Organization",
        "organizations":"Organizations",
        "objectRelationship": "Object Relationship",        
        "objectTemplate": "Object Template",
        "pad": "Pad",
        "pageConfiguration": "Page Configuration",
        "pageConfigurations": "Page Configurations",
        "platformObject": "Platform Object",
        "pollingServerCommunicationsObject": "Polling Server Communications Object",
        "pollingServerProtocolObject": "Polling Server Protocol Object",
        "tagThreadType": "Tag Thread Type",
        "trendConfiguration": "Trend Configuration",
        "trendConfigurations": "Trend Configurations",
        "userList": "User List",
        "recipient": "Recipient",
        "recipients": "Recipients",
        "role": "Role",
        "roles": "Roles",
        "rulesEngineInstance": "Rules Engine Rule Instance",
        "rulesEngineRule": "Rules Engine Rule",
        "setpoint": "Setpoint",
        "setpoints": "Setpoints",
        "summaryListingPage": "Summary Listing Page",
        "summaryListingPages": "Summary Listing Pages",
        "tag": "Tag",
        "tags": "Tags",
        "tank": "Tank",
        "tanks": "Tanks",
        "tankBattery": "Tank Battery",
        "tankBatteries": "Tank Batteries",
        "tankPad": "Tank Pad",
        "tankPads": "Tank Pads",
        "unitSet": "Unit Set",
        "unitSets": "Unit Sets",
        "user": "User",
        "users": "Users",
        "well": "Well",
        "wells": "Wells"
    },
    "offlineDetect": {
        "isOffline": "The app cannot communicate with the server and will be set to offline mode.",
        "isOnline": "The app can now communicate with the server and will be set back to online mode."
    },
    "moreOptions": "More Options",
    "notificationList": {
        "nameRequired": "A Notification List name is required",
        "nameLength": "The Notification List name cannot be more than 50 characters",
        "cancelAdd": "You're about to leave Add Notification List without saving your changes. Are you sure you want to continue and exit without saving?",
        "cancelEdit": "You're about to leave Edit Notification List without saving your changes. Are you sure you want to continue and exit without saving?",
        "successMessageAdded": "Notification List '{{name}}' was successfully added.",
        "successMessageDeleted": "The Notification List was successfully deleted.",
        "successMessageUpdated": "'{{name}}' was successfully updated.",
        "successMessageSaved": "'{{name}}' was successfully saved.",
        "nodata": {
            "title": "No Notification Lists",
            "text": "There are no notification lists for the selected organization or that match the text entered in the filter."
        },
        "usage": "Usage"


    },
    "options": "Options",
    "pendingExport": "You currently have an export in progress for '{{description}}'. You can try this export again once it has completed.",
    "phone": "Phone",
    "profile": {
        "account": "Account Settings",
        "accountInfo": "Account Information",
        "accountSettingsUpdated": "Account Settings have been updated",
        "api": "API",
        "apiManagement": "API Management",
        "appearance": "Appearance",
        "appPreferences": "Application Preferences",
        "appPreferencesUpdated": "Application Preferences have been updated",
        "authenticationSource": "Authentication Source",
        "authenticatorNotPersisted": "Save your profile to commit your Authenticator settings.",
        "authenticatorValidationInfo": "When switching to Authenticator or requesting a new secret, you must verify an OTP from your Authenticator before saving changes to your profile.",
        "authenticatorValidationSuccess": "Your authenticator has been verified.",
        "cancelEditText": "You are about to leave Account Settings without savings the changes you made. Are you sure you want to continue and exit without saving?",
        "changeCustomer": "Change Customer",
        "changePassword": "Change Password",
        "collapseTagGroups": {
            "label": "Default Tag Group Presentation",
            "collapsed": "Collapsed",
            "expanded": "Expanded"
        },
        "company": "Company",
        "defaultStackedView": {
            "label": "Default Stacked View"
        },
        "defaultTankLevelDisplay": "Tank Levels",
        "defaultView": "Default View",
        "deviceDetailPreferences": "Device Preferences",
        "deviceViewMobile": {
            "label": "Default Tag History View for Mobile",
            "all": "All Tags",
            "summary": "Summary Listing Tags"
        },
        "dataTooltip": {
            "label": "Data Tooltip Display",
            "separate": "Separate",
            "shared": "Shared"
        },
        "display": "Display",
        "chooseTheme": "Choose a theme",
        "light": "Light",
        "myProfile":"My Profile",
        "dark": "Dark",
        "defaultViews": "Default Views",
        "displayAlarmsTop": "Display devices in alarm at the top the grid",
        "displayFunctionIcons": "Display Shortcuts",
        "historicalData": "Historical Data",
        "plungerAnalysis":"Plunger Analysis",
        "gaugeSheet": "Gauge Sheet",
        "dynacard": "Dynacard",
        "addMemo":"Add Memo",
        "mapIt":"Map It",
        "displayOutletsFirst": "Display outlet devices at the top of the grid",
        "shortcuts": "Shortcuts",
        "alarmFirst": "{{objectType}} in Alarm First",
        "outletFirst": "Outlet Devices First",
        "emailLabel": "Login and Contact Email",
        "gaugeSheetPreferences": "Gauge Sheet Preferences",
        "gaugeSheetView": "Gauge Sheet View",
        "generalPreferences": "General Preferences",
        "graphing": "Graphing",
        "graphingAndReporting": "Graphing & Reporting",
        "graphPreferences": "Graph Preferences",
        "groupPreferences": "Group Preferences",
        "groupDefaultViewDesc": "Selecting a Default View will override any group default set by your administrator.",
        "gridPageSize": "Data Grid Page Size",
        "gridFontSize": "Data Grid Font Size",
        "gridCellPadding": "Data Grid Cell Padding",
        "invalidEmail": "A valid email is required",
        "invalidExternalSignInName": "The single sign-on name must be a valid email address",
        "invalidOtp": "OTPs must be six digits",
        "invalidPhone": "Phone number must be valid",
        "jobFunctions": {
            "admin": "Administrative/Clerk",
            "assetManager": "Asset Manager",
            "eng": "Engineer/Analyst",
            "engmanager": "Engineering Manager",
            "execmanager": "Executive Manager",
            "investor": "Shareholder/Investor",
            "it": "SCADA/Automation/IT Specialist",
            "marketer": "Marketer/Accountant/Auditor",
            "measurement": "Measurement Technician/Manager",
            "opsmanager": "Operations Manager",
            "other": "Other",
            "prodForeman": "Production Foreman",
            "pumper": "Operator/Pumper/Technician",
            "workSuper": "Workover Superintendent"
        },
        "jobFunction": "Job Function",
        "jobTitle": "Job Title",
        "lastRefresh": "Last Refresh",
        "lastSync": "Last Sync",
        "manualAuthInfo": "Manual Authenticator Connection Info",
        "marketingReport": "Marketing Report",
        "marketingReportPreferences": "Marketing Report Preferences",
        "multifactorAuthentication": "Multifactor Authentication",
        "mfaAccount": "Account",
        "mfaSecret": "Secret",
        "name": "Name",
        "notifications": "Notifications",
        "offlineData": "Offline data",
        "offlineDataRefreshed": "Offline data has been refreshed",
        "offlineMode": "Offline Mode",
        "otpInvalid": "Invalid OTP",
        "otpLastVerified": "OTP last verified on {{timestamp}}",
        "otpNotNumeric": "OTP must be numbers only",
        "otpTooShort": "OTP must be 6 digits",
        "otpVerificationRequired": "OTP Verification Required",
        "phone": "Phone",
        "prefDesc": "Control how data and views appear across the application.",
        "preview": "Preview",
        "profile": "Profile",
        "profileUpdated": "Your profile has been updated",
        "qrCodeInstruction": "Scan this QR code from your Authenticator app",
        "refreshOfflineData": "Refresh Offline Data",
        "requestNewSecret": "Request New Secret",
        "settings": "Settings",
        "sortDates": {
            "label": "Sort Dates",
            "left": "Left to Right",
            "right": "Right to Left"
        },
        "summaryListingPreferences": "Summary Listing Preferences",
        "tagDetailPreferences": "Tag Preferences",
        "tagHistory": {
            "label": "Default Tag History View",
            "chart": "Chart",
            "grid": "Grid"
        },
        "textAndTable": "Text and Table Defaults",
        "theme": "Theme",
        "timeZone": "Time Zone",
        "userImageUploaded": "User profile image successfully updated.",
        "userInfo": "User Information",
        "verifyOtp": "Verify OTP"
    },
    "progress": {
        "sendingRequest": "Sending download request...",
        "exportFailed": "Export failed, notification not received"
    },
    "properties": {
        "additionalContentDisclaimer": "This feature allows you to specify an address that will be presented as an additional tab in the Properties view. The content from that address will be displayed in a frame.",
        "additionalContentDisclaimer2": "While embedded URLs to third parties can help users remain within the eLynx application, eLynx has no control over the third-party. As a result, any security risks posed by the third-party are the responsibility of the user.",
        "alarmCompressorLynx": "Alarmlynx/CompressorLynx Admin",
        "alarmSchedule": "Alarm Schedule",
        "api": "API/UWI",
        "attributesSaved": "The attributes for the object were saved.",
        "attributeName": "Attribute Name",
        "attributeValue": "Attribute Value",
        "basin": "Basin",
        "bblsPerInch": "Barrels/Inch",
        "capacity": "Capacity",
        "changeTagType": "Change Tag Type...",
        "commInfo": "Comm Info",
        "comparison": "Comparison",
        "cstOffset": "CST Offset (minutes)",
        "commEndpointType": "Comm Endpoint Type",
        "commAddress": "Comm Address",
        "commAddressUpdated": "Comm Address Updated",
        "commEndpointID": "Comm Identifier",
        "commEndpointSource": "Comm Endpoint Source",
        "commEndpointUpdated": "Comm Endpoint Updated",
        "contractHour": "Contract Hour",
        "contractHourFormat": "Contract hour must be entered as ##:##",
        "currentMonthUsage": "Current Month Usage",
        "currentValue": "Current Value",
        "currentValueStatus": "Current Value / Status",
        "customAttributes": "Custom Attributes",
        "dataChracterization": "Data Characterization",
        "dataType": "Data Type",
        "dataValidation": "Data Validation",
        "dateTime": "Date Time",
        "decimals": "Decimal Places",
        "deviceName": "Device Name",
        "deviceType": "Device Type",
        "disabled": "Disabled",
        "enableWriteDownConfiguration": "Enable Write",
        "endTime": "End Time",
        "excludeFromOilCalc": "Exclude from Oil Production Calculation",
        "excludeFromWaterCalc": "Exclude from Water Production Calculation",
        "field": "Field",
        "firstName": "First Name",
        "formula": "Formula",
        "geolocation": "Geolocation",
        "height": "Height",
        "identifier": "Identifier",
        "interval": "Interval",
        "images": "Images",
        "lastAlarm": "Last Alarm",
        "lastName":"Last Name",
        "latitude": "Latitude",
        "latitudeRange": "Valid latitudinal values are between and include -90 and 90.",
        "liftType": "Lift Type",
        "limitError": "Enter a value from -999999999 to 999999999 up to 9 decimal places",
        "longitude": "Longitude",
        "longitudeRange": "Valid longitudinal values are between and include -180 and 180.",
        "location": "Location",
        "lookupList": "Lookup List",
        "lowerLimit": "Lower Limit",
        "manualEntryEnabled": "Manual Entry Enabled",
        "maxDeviceNameLength": "Device name cannot be greater than 200 characters",
        "maxLocationLength": "Location cannot be greater than 200 characters",
        "maxAttributeLength": "Attribute text cannot be greater than 128 characters",
        "maxUrlTabNameLength": "URL tab name text cannont be greater than 128 characters",
        "maxUrlLength": "URL text cannont be greater than 256 characters",
        "maxFieldLength": "{{field}} cannot be greater than {{max}} characters",
        "miscellaneous": "Miscellaneous",
        "name": "Name",
        "newValue":"New Value",
        "none": "None",
        "numericInputRequired": "Numeric input is required",
        "operator": "Operator",
        "pad": "Pad",
        "phoneticName": "Phonetic Name",
        "pollingSchedule": "Polling Schedule",
        "productType": "Product Type",
        "readItem": "Read Item",

        "simId": "SIM ID",
        "standard": "Standard Properties",
        "startTime": "Start Time",
        "staleDataScheme": "Stale Data Scheme",
        "tagName":"Tag Name",
        "tags": "Tags",
        "tagType": "Tag Type",
        "tagValue": "Tag Value",
        "tankBatteries":"Tank Batteries",
        "tankLevelTransmitterType": "Tank Level Transmitter Type",
        "tankStyle": "Tank Style",
        "tankProperties": "Tank Properties",
        "tiers": "Tiers",
        "timeframe": "Timeframe",
        "timezone": "Time Zone",
        "type": "Type",
        "unitClassification": "Unit Classification",
        "uom": "Unit of Measure",
        "uomAbbreviation": "UoM",
        "update": "Update Properties",
        "upperLimit": "Upper Limit",
        "urlViewer": "URL Viewer",
        "urlTabName": "URL Tab Name",
        "url": "URL",
        "urlPrivate": "The URL IP address must be private.",
        "validateGasAnalysis": "Enable Gas Analysis Write Down Validation",
        "value": "Value",
        "valueRequired": "{{item}} is required",
        "visible": "Visible",
        "writeItem": "Write Item",
        "propertiesSaved": "The properties for the object were saved.",
        "cancelPropertiesConfirmationDialogText": "You are about to exit without saving {{objectType}} property changes. Are you sure you want to continue and exit without saving?",
        "settings": "Settings",
        "noCommInfo": "Unable to retrieve comm info.",
        "alarmCriteria": "Alarm Criteria",
        "setpoint": "Setpoint"
    },
    "recipientEditDialog": {
        "addRecipient": "Add Recipient",
        "editRecipient": "Edit Recipient",
        "country": "Country",
        "emailAddress": "Email Address",
        "phoneNumber": "Phone Number",
        "subType": "Sub Type",
        "type": "Type",
        "cancelAddRecipient": "You're about to leave Add Recipient without saving your changes. Are you sure you want to continue and exit without saving?",
        "cancelEditRecipient": "You're about to leave Edit Recipient without saving your changes. Are you sure you want to continue and exit without saving?",
        "recipients": "Recipients",
        "linkToExistingRecipientUser": "Link the new recipient to the user of an existing recipient",
        "cloneRecipientUsage": "Add this recipient to the notification lists and alarm setpoints of another recipient"
    },
    "refresh": "Refresh",
    "relationships": {
        "devices": "Devices for",
        "tankBatteries": "Tank Batteries for",
        "tanks": "Tanks for"
    },
    "graphReport": {
        "databaseAlarms": "Database Alarms",
        "fieldAlarms": "Field Alarms",
        "messages": {
            "runReport": {
                "text": "Click the <i><strong>Run Report</strong></i> button to run a report with defaults or change options and then click the <i><strong>Run Report</strong></i> button .",
                "title": "Run Report"
            }
        },
        "options": {
            "labels": {
                "ConfigSel": "Configuration Selections",
                "documentOptions": "Document Options",
                "chartOptions": "Chart Options",
                "objectType": "Object Type",
                "pageSize": "Page Size:",
                "textOptions": "Text Options"
            },
            "checkBoxes": {
                "includeTitlePage": {
                    "name": "Include Title Page",
                    "tooltip": "Include Title Page - PDF and Word"
                },
                "includeContents": {
                    "name": "Include Table of Contents",
                    "tooltip": "Include Table of Contents - Word"
                },
                "includeMemoContents": {
                    "name": "Include Memo Contents",
                    "tooltip": "Include Memo Contents"
                },
                "includeAlarmDesc": {
                    "name": "Include Alarm Descriptions",
                    "tooltip": "Include Alarm Descriptions"
                },
                "showMemoMarkers": {
                    "name": "Show Memo Markers",
                    "tooltip": "Show Memo Markers"
                },
                "showAlarmMarkers": {
                    "name": "Show Alarm Markers",
                    "tooltip": "Show Alarm Markers"
                },
                "hideSecondaryAxes": {
                    "name": "Hide Secondary Axes",
                    "tooltip": "Hide Secondary Axes"
                }
            },
            "pageSizes": {
                "letter": "Letter (8.5x11)",
                "legal": "Legal (8.5x14)",
                "ledger": "Ledger (11x17)"
            },
            "radioButtons": {
                "objectDefault": "Use {{objectType}}'s Default",
                "groupDefault": {
                    "name": "Use Group's Default",
                    "tooltip": "No group default Graph Configuration set. Set a group default Graph Configuration to enable this option."
                },
                "specifyObjectConfig": "Specify {{objectType}} Configuration",
                "specifyGroupConfig": "Specify Group Configuration"
            },
            "selections": {
                "pageSize": {
                    "name": "Page Size",
                    "tooltip": "Page Size - PDF and Word"
                }
            },
            "title": "Override Options"
        },
        "reportInProgressDialog": {
            "title": "Graph Report Already Running",
            "message": "The requested Graph Report is already running. Please wait for the current Graph Report to finish before running again."
        }
    },
    "reporting": {
        "reportList": {
            "placeholder": "Choose a Report",
            "shared": "Shared Reports",
            "sharedReadOnly": "Shared Read-Only Reports",
            "private": "Private Reports"
        },
        "deliveryOptions": {
            "label": "Delivery",
            "onScreen": "On-screen",
            "download": "Download"
        },
        "rowsPerPage": {
            "label": "Rows per Page"
        },
        "messages": {
            "selectOrCreateReport": {
                "text": "Please choose a saved Report from the Options panel, or create a new Report.",
                "title": "No Report"
            },
            "runReport": {
                "text": "Please run your chosen Report to see your data.",
                "title": "No Data"
            },
            "noDataFoundForSection": "No data found for this section.",
            "deferred": {
                "title": "Running Report",
                "text": "The report is running and may take a few minutes to complete."
            }
        },
        "created": "Created"
    },
    "reportConfiguration": {
        "aggregates": {
            "raw": "Raw",
            "avg": "Avg",
            "min": "Min",
            "max": "Max",
            "sum": "Sum",
            "lkv": "LKV",
            "lkhv": "LKHV",
            "dt": "DT",
            "rt": "RT",
            "fkv": "FKV",
            "count": "Count"
        },
        "sections": "Sections",
        "steps": {
            "reportSections": {
                "title": "Report Sections",
                "dataLayout": {
                    "title": "Data Layout",
                    "sample": "Sample",
                    "style1": {
                        "title": "List of data with one row for each {{singularObjectTypeName}}, timeframe, and data value",
                        "description": "A report consisting of a list of {{pluralObjectTypeName}} with a single row for each {{singularObjectTypeName}}, timeframe, and data value in the configured duration."
                    },
                    "style2": {
                        "title": "List of timeframes for each {{singularObjectTypeName}} with data values as columns",
                        "description": "A report consisting of a list of {{pluralObjectTypeName}} with a row for each timeframe in the configured duration. The columns in the list will consist of the attributes and data values selected for the report."
                    },
                    "style4": {
                        "title": "List of {{pluralObjectTypeName}} and data values with",
                        "asColumns": "as columns",
                        "timeframesAsColumns": "timeframes as columns",
                        "description": "A report consisting of a list of {{pluralObjectTypeName}} with a row for each selected {{singularObjectTypeName}} and data value. The columns in the list will consist of each timeframe in the configured duration for the report."
                    },
                    "style8": {
                        "title": "List of events with one row for each event",
                        "description": "A report consisting of a list of events with a row for each selected event. The columns in the list will consist of each timeframe in the configured duration for the report."
                    },
                    "viewSample": "View Sample",
                    "timeframes": {
                        "hours": "Hours",
                        "days": "Days",
                        "months": "Months"
                    }
                },
                "options": {
                    "title": "Options",
                    "useEffectiveDate": "Use effective date",
                    "includeTimeframesWithNoDataForObjects": "Include timeframes with no data for the specified {{pluralObjectTypeName}}",
                    "includeObjectsWithNoData": "Include {{pluralObjectTypeName}} with no data during the specified duration",
                    "includeTotalsRow": "Include final row with totals",
                    "rawDataCloseness": "Group timestamps when within",
                    "rawDataClosenessTooltip": "This option can be used to force data values with slightly different timestamps into a single row in the output. This will only affect Raw data values included in the report. When enabling set the time period you want to use to determine how far apart timestamps can be and still be forced to a single row. Limited to values 1 through 59.",
                    "minutes": "Minutes",
                    "seconds": "Seconds"
                },
                "duration": "Duration",
                "sortOrder": {
                    "title": "Sort Order",
                    "dateSortOrder": "Date Sort Order",
                    "objectSortOrder": "{{singularObjectTypeName}} Sort Order",
                    "ascending": "Ascending",
                    "descending": "Descending"
                },
                "typeOfData": {
                    "title": "Type of Data",
                    "device": "Device Data",
                    "tank": "Tank Data",
                    "well": "Well Data"
                },
                "menu": {
                    "duplicate": "Duplicate",
                    "delete": "Delete",
                    "rename": "Rename"
                },
                "editContents": "Edit Contents",
                "info": "A Report can have multiple Sections of data. The following options are specific to each Report Section that you build.",
                "expandAll": "Expand All",
                "collapseAll": "Collapse All",
                "addSection": "Add Section",
                "reportOptions": {
                    "title": "Report Options",
                    "info": "A Report can have a single duration specified for the entire Report, or it can have a custom duration specified for each Report Section that you build.",
                    "overrideInstances": "Specify a single duration for the entire report",
                    "configurationType": "Configuration Type",
                    "report": "Report",
                    "tagCalculation": "Tag Calculation"
                },
                "name": "Section Name"
            },
            "selectContents": {
                "title": "Select Contents",
                "filter": "Filter by {{singularObjectTypeName}} Name",
                "idFilter": "Filter by ID",
                "viewSelected": "View Selected {{pluralObjectTypeName}}"
            },
            "selectData": {
                "title": "Select Data",
                "tabs": {
                    "dataValues": {
                        "title": "Data Values",
                        "filter": "Filter by Data Value Name",
                        "viewSelected": "View Selected Data Values"
                    },
                    "attributes": {
                        "title": "Attributes",
                        "filter": "Filter by Attribute Name",
                        "viewSelected": "View Selected Attributes"
                    }
                }
            },
            "selectEvents": {
                "title": "Select Events",
                "tabs": {
                    "dataQuality": {
                        "title": "Data Quality",
                        "filter": "Filter by Event Name",
                        "viewSelected": "View Selected Events"
                    },
                    "diagnostic": {
                        "title": "Diagnostic",
                        "filter": "Filter by Event Name",
                        "viewSelected": "View Selected Events"
                    },
                    "user": {
                        "title": "User",
                        "filter": "Filter by Event Name",
                        "viewSelected": "View Selected Events"
                    }
                }
            },
            "dataOptions": {
                "title": "Data Options",
                "tabs": {
                    "dataSeries": {
                        "title": "Data Series",
                        "name": "Name",
                        "rawData": "Raw Data",
                        "hourlyData": "Hourly Data",
                        "dailyData": "Daily Data",
                        "monthlyData": "Monthly Data",
                        "filter": "Filter by Name"
                    }
                }
            },
            "eventOptions": {
                "title": "Event Options",
                "tabs": {
                    "eventSeries": {
                        "title": "Event Series",
                        "name": "Name",
                        "objectName": "Object Name",
                        "eventType": "Event Type",
                        "startTime": "Start Time",
                        "endTime": "End Time",
                        "duration": "Duration",
                        "notes": "Notes",
                        "selectColumns": "Select Columns"
                    }
                }
            },
            "formatDataSeries": {
                "title": "Format Data Series",
                "dataSeries": "Data Series",
                "optionalDisplayName": "Optional Display Name",
                "decimal": "decimal",
                "decimals": "decimals",
                "default": "Default",
                "new": "NEW!"
            },
            "formatEventSeries": {
                "title": "Format Event Series",
                "eventSeries": "Event Series",
                "optionalDisplayName": "Optional Display Name",
                "new": "NEW!"
            }
        },
        "exceptions": {
            "nameInUse": {
                "message": "A report with the specified name already exists. Please choose a different name.",
                "title": "Duplicate Names Are Not Allowed"
            }
        },
        "dialogs": {
            "deprecationConfirmationEdit": {
                "title": "NOTICE: This Report Contains Options That Are No Longer Supported",
                "confirmationHtml": "This Report contains one or more Sections that were built using a Legacy option to include Devices and Tanks in a single Section. We now require each Section to use a single data type, so this Report can no longer be edited.<br/><br/>Would you like to Duplicate this Report using Device data for the affected Section?",
                "yesButtonText": "Yes, Continue",
                "noButtonText": "No, Go Back"
            },
            "deprecationConfirmationDuplicate": {
                "title": "NOTICE: This Report Contains Options That Are No Longer Supported",
                "confirmationHtml": "This Report contains one or more Sections that were built using a Legacy option to include Devices and Tanks in a single Section. We now require each Section to use a single data type.<br/><br/>Would you like to Duplicate this Report using Device data for the affected Section?",
                "yesButtonText": "Yes, Continue",
                "noButtonText": "No, Go Back"
            },
            "changeToStyle4Confirmation": {
                "title": "Change Report Style?",
                "hourlyHtml": "NOTICE: This report style only allows data values to be selected for a single timeframe. This section has non-hourly data values already selected so they will be automatically converted to hourly.<br/><br/>Do you still want to change to this style with an hourly timeframe?",
                "dailyHtml": "NOTICE: This report style only allows data values to be selected for a single timeframe. This section has non-daily data values already selected so they will be automatically converted to daily.<br/><br/>Do you still want to change to this style with a daily timeframe?",
                "monthlyHtml": "NOTICE: This report style only allows data values to be selected for a single timeframe. This section has non-monthly data values already selected so they will be automatically converted to monthly.<br/><br/>Do you still want to change to this style with a monthly timeframe?",
                "yesButtonText": "Yes, Continue",
                "noButtonText": "No, Go Back"
            },
            "changeToEventStyleConfirmation": {
                "title": "Change Report Style?",
                "confirmationHtml": "NOTICE: This report style only allows data values for events. This section has non-event data values already so they will be removed.<br/><br/>Do you still want to change to this style for Events?",
                "yesButtonText": "Yes, Continue",
                "noButtonText": "No, Go Back"
            },
            "changeFromEventStyleConfirmation": {
                "title": "Change Report Style?",
                "confirmationHtml": "NOTICE: This report style does not allow data values for events. This section has event data values already so they will be removed.<br/><br/>Do you still want to change to this style that is no longer for Events?",
                "yesButtonText": "Yes, Continue",
                "noButtonText": "No, Go Back"
            },
            "changeDataTypeConfirmation": {
                "title": "Change Data Type?",
                "confirmationHtml": "NOTICE: This report section contains selected {{oldPluralObjectTypeName}} and/or columns. If you change the data type to {{newPluralObjectTypeName}}, the selected {{oldPluralObjectTypeName}} and/or columns will be automatically removed.<br/><br/>Do you still want to change to this data type?",
                "yesButtonText": "Yes, Continue",
                "noButtonText": "No, Go Back"
            },
            "preview": {
                "title": "Preview of {{name}}"
            }
        }
    },
    "reportDuration": {
        "ago": "ago",
        "beginning": "Beginning",
        "current": "Current",
        "duration": "Duration",
        "previous": "Previous"
    },

    "rulesEngineAdmin": {
        "tabs": {
            "rules": {
                "title": "Available Rules",
                "filter": "Filter by Rule Name",
                "noData": {
                    "title": "There are no available rules",
                    "text1": "You can create rules using the",
                    "text2": "button in the toolbar"
                },
                "noFilteredData": {
                    "title": "There are no available rules that match the filter criteria"
                }            
            },
            "ruleInstances": {
                "title": "Applied Rules",
                "filter": "Filter by Rule Name",
                "noData": {
                    "title": "There are no applied rules related to the selected group",
                    "text1": "You can apply rules using the",
                    "text2": "button in the toolbar"
                },
                "noFilteredData": {
                    "title": "There are no applied rules related to the selected group that match the filter criteria"
                }
            }
        },

        "ruleInstanceFilters": {
            "allRules": "All Rules",
            "elynxDiagnosticRules": "eLynx Diagnostic Rules",
            "elynxDataQualityRules": "eLynx Data Quality Rules",
            "customDiagnosticRules": "Custom Diagnostic Rules",
            "customDataQualityRules": "Custom Data Quality Rules"
        },
        "ruleTypes": {
            "elynxDiagnosticRule": "eLynx Diagnostic Rule",
            "elynxDataQualityRule": "eLynx Data Quality Rule",
            "customDiagnosticRule": "Custom Diagnostic Rule",
            "customDataQualityRule": "Custom Data Quality Rule"
        },
        "rulePopupMessages": {
            "noObjects": "The selected group does not currently contain any objects. Please use Group Administration to add objects to the group before creating Rules."
        },
        "noDataTitle": "There are no Rules defined for the '{0}' Group",
        "noDataText": "You can add Rules to this Group using the 'Add Rule' button in the toolbar",
        "applyRule": "Apply Rule",
        "createRule": "Create Rule",
        "newRule": "New Rule",
        "modifySearch": "Modify Search",
        "clearSearch": "Clear Search",
        "ruleSearch": "Rule Search",
        "searchText1": "Search for all Rule Instances in the current Group where the",
        "searchText2": "contains",
        "searchResults": "Showing {0} search results for all {1}s that match '{2}'",
        "searchResultsAll": "Showing {0} search results for all {1}s",
        "ruleInstanceDisabled": "The Applied Rule \"{{name}}\" was successfully disabled.",
        "ruleInstanceEnabled": "The Applied Rule \"{{name}}\" was successfully enabled.",
        "ruleName": "Rule Name",
        "device": "Device",
        "well": "Well",
        "linkToSelected": "Link selected to Rule",
        "searchResultsTitle": "Search Results",
        "selectDevicesOrWells": "Select Devices or Wells...",
        
        "filterByRuleName": "Filter by Rule Name",
        "filterByRuleType": "Filter by Rule Type",
        
        "nameFilter": "Name Filter",
        "searchCriteria": "Search Criteria",
        "devicesFilterHint": "Filter by Device Name",
        "wellsFilterHint": "Filter by Well Name",
        "tatFilterHint": "Filter by TAT Name",
        "instancesFilterHint": "Filter by Name",
        "viewSelectedDevices": "View Selected Devices",
        "viewSelectedWells": "View Selected Wells",
        "deleteSuccessText": "Rule '{{ruleName}}' has been deleted.",
        "saveSuccessText": "Rule '{{ruleName}}' has been saved.",
        "modals": {
            "disableRuleObjectModal": {
                "beginningLabel": "Beginning",
                "endingLabel": "Ending",
                "dialogTitle": "Disable Options for a Rule on a {{objectType}}",
                "disableCheckBoxLabel": "Temporarily disable the Rule for this {{objectType}} for a specified timeframe",
                "disableForLabel": "Disable For",
                "disableBetweenLabel": "Disable Between",
                "duration": "Duration",
                "durationUnit": "Unit",                    
                "disableInstructions": "You can temporarily disable this Rule from evaluating on this {{objectType}} for a specified timeframe. Once the specified timeframe has elapsed Rule evaluation will be automatically enabled.",
                "ruleObjectDisabled": "The Rule will not be evaluated during the specified time interval for the specified {{objectType}}.",
                "ruleObjectEnabled": "The Rule has been re-enabled to evaluate on the specified {{objectType}}.",
                "selectMode": "Select Mode",
                "timezone": "Timezone",
                "hour": "Hour",
                "day": "Day",
                "week": "Week",
                "month": "Month",
                "year": "Year",
                "cancelText": "You're about to leave Disable Options for a Rule on a {{objectType}} without saving your changes. Are you sure you want to continue and exit without saving?"
            }
        },
        "disabledUntil": "Disabled until",
        "simulation": {
            "selectObject": "Select Object",
            "start": "Start: ",
            "end": "End: ",
            "resetToDefault": "Reset to Default",
            "saveModifications": "Save Modifications",
            "simulate": "Simulate",
            "ruleLogic": "Rule Logic"
        },
        "usage": "Usage [{{count}}]",
        "devices": "Devices [{{count}}]",
        "wells": "Wells [{{count}}]"
    },
    "ruleEditor": {
        "steps": {
            "ruleType": {
                "title": "Rule Type",
                "ruleType": "Rule Type",
                "ruleName": "Rule Name",
                "ruleDescription": "Rule Description",
                "selectRuleType": "Select the Rule Type",
                "enterRuleName": "Enter Rule Name",
                "enterRuleDescription": "Enter a Rule Description"
            },
            "ruleLogic": {
                "title": "Rule Logic",

                "operators": {
                    "logical": {
                        "and": "AND",
                        "or": "OR"
                    },
                    "query": {
                        "contains": "Contains",
                        "doesNotContain": "Does Not Contain",
                        "exactlyMatches": "Exactly Matches"
                    },
                    "relational": {
                        "equalTo": "Equal To",
                        "notEqualTo": "Not Equal To",
                        "lessThan": "Less Than",
                        "lessThanOrEqualTo": "Less Than Or Equal To",
                        "greaterThan": "Greater Than",
                        "greaterThanOrEqualTo": "Greater Than Or Equal To",
                        "between": "Between"
                    }
                },
                "functions": {
                    "lastKnownValue": "Last Known Value",
                    "maximum": "Maximum Value",
                    "minimum": "Minimum Value",
                    "average": "Average Value"
                },
                "durationUnits": {
                    "minutes": "Minutes",
                    "hours": "Hours",
                    "days": "Days",
                    "weeks": "Weeks",
                    "months": "Months",
                    "years": "Years"
                },
                "eventStartHeading": "Rule Logic Event Start",
                "eventEndHeading": "Rule Logic Event End",
                "separateEndCheckboxLabel": "End the event when the conditions from Rule Logic Event Start return to normal.",
                "selectTag": "Select Tag",
                "function": "Function",
                "operator": "Operator",
                "duration": "Duration",
                "newCondition": "New Condition",
                "nestedCondition": "Nested Condition",
                "logicDescription": "Rule Logic Description",
                "clearAll": "Clear All",
                "advanced": "Advanced",
                "basic": "Basic",
                "checkCode": "Check Code",
                "commit": "Commit",
                "compileErrors": "Compilation resulted in errors. See output pane for details.",
                "compileSuccess": "Successfully compiled template with no errors or warnings",
                "compileWarnings": "Compilation resulted in warnings. See output pane for details."
            },
            "simulation": {
                "title": "Simulation"
            },
            "summary": {
                "title": "Summary"
            }
        },
        "modals": {
            "saveConfirmation": {
                "title": "Save as New",
                "instructions": "Enter a name for your new rule below.",
                "buttonLabel": "Save as New"
            },
            "cancelConfirmation": {
                "title": "Are you sure you want to cancel?",
                "text": "You are about to exit without saving any changes. Are you sure you want to continue and exit without saving?",
                "yesButtonText": "Yes, Cancel",
                "noButtonText": "No, Go Back"
            },
            "renameConfirmation": {
                "title": "NOTICE: Changes Affect Other Users",
                "text": "Would you like to Continue Renaming?",
                "yesButton": "Continue Renaming",
                "noButton": "Cancel"
            },
            "renameInstanceDialog": {
                "title": "Rename",
                "instructions": "Enter a new name for your rule below.",
                "buttonLabel": "Rename"
            },
            "deleteConfirmation": {
                "title": "Delete Current Rule?",
                "text": "Note: This action cannot be undone.",
                "yesButton": "Yes, Delete",
                "noButton": "No, Do Not Delete"
            }
        },
        "copy": "(copy)",
        "exceptions": {
            "nameInUse": {
                "message": "A rule with the specified name already exists. Please choose a different name.",
                "title": "Duplicate Names Are Not Allowed"
            }
        },
        "saveAsNew": "Save As New",
        "saveChanges": "Save Changes"
    },
    "ruleInstanceEditor": {
        "steps": {
            "ruleLogic": {
                "title": "Rule Logic",
                "selectRule": "Select Rule",
                "selectRuleType": "Select Rule Type",
                "ruleDescription": "Rule Description",
                "ruleLogic": "Rule Logic",
                "resetToDefault": "Reset to Default"
            },
            "simulation": {
                "executionInstanceWarning": "Your simulation request may take a few moments to complete. Please do not close the browser or navigate away from this view. If you need to continue working in eLynx while the simulation is running, you can open an additional tab.",
                "executionInstanceError": "The requested simulation contains too many data points to simulate. We suggest narrowing the Start and End times and trying again.",
                "invalidDateRange": "Invalid date range",

                "longSimulationTime": "Long Simulation Time",

                "maximumSimulationRangeExceeded": "You have requested a simulation for too long of a period. Please select a range that does not exceed {{maxRange}} days and try again.",
                "modificationsSaved": "The working copy of your rule has been updated.",

                "noDataMessage": "This screen allows you to test the logic of a rule before you save it and apply it. We recommend isolating the event you are trying to detect with rule logic before you run a simulation.<br /><br />This step is optional, but may be useful to validate the rule logic and thresholds for the rule on specific devices.<br /><br />To run a simulation, select an object, set start and end dates (maximum of __maxDayLimit__ days). You may adjust the parameters and re-run the simulation.<br /><br />If you made changes to the rule parameters you may click the \"Save Modifications\" button to update the defaults to the new values.",

                "simulationTerminated": "Simulation Terminated",


                "startEndTimesRequired": "The start and end times are required.",
                "startTimeAfterEndTime": "The start time cannot be after the end time.",
                "title": "Simulation"
            },
            "usage": {
                "title": "Usage",
                
                "noDevices": "There are no devices in the '{0}' Group with the necessary Tags for this rule.",
                "noDevicesExplanation": "You can choose a different Group in the Rules Administration view.",
                
                "noWells": "There are no wells in the '{0}' Group with the necessary Tags for this rule.",
                "noWellsExplanation": "You can choose a different Group in the Rules Administration view.",
                
                "filter": "Filter by {{singularObjectTypeName}} Name",
                "viewSelected": "View Selected {{pluralObjectTypeName}}"
            },
            "availability": {
                "deviceAndWell": "Please select a device or well to run the rule simulation.",
                "deviceOnly": "Please select a device to run the rule simulation.",
                "wellOnly": "Please select a well to run the rule simulation."
            },
            "actions": {
                "title": "Actions",
                "instructions": "Users can apply multiple actions to applied Rules, please select Add Action to create a new action.",
                "sidebar": {
                    "title": "Available Actions",
                    "instructions": "Add the desired actions to be performed when the {{ruleName}} rule is triggered",
                    "addAction": "Add Action"
                },
                "tabs": {
                    "reporting": "Reporting",
                    "alarmNotifications": "Rule Alarm Notifications"
                },
                "steps": {
                    "messages": {
                        "title": "Messages",
                        "eventStart": "Event Start",
                        "eventEnd": "Event End",
                        "reusableContent": "Insert reusable content",
                        "templateRequired": "{{name}} cannot be blank",
                        "invalidSpecifier": "<Invalid Specifier>"
                    },
                    "notifications": {
                        "title": "Notifications"
                        
                    },

                    "notificationLists": {
                        "title": "Notification Lists",
                        "viewSelected": "View Selected Lists",                                                                 
                        "filter": "Filter by Name",
                        "alarmSchemes": "Alarm Schemes",
                        "notificationMethods": {
                            "oneTimeNotification": "One-Time Notification",
                            "tieredNotifications": "Alarm Scheme"
                        }
                    },
                    "recipients": {
                        "title": "Recipients",
                        "viewSelected": "View Selected Recipients",
                        "filter": "Filter by Name"
                    }
                }
            },
            "summary": {
                "title": "Summary"
            }
        },
        "saveAsNew": "Save As New",
        "saveChanges": "Save Changes",
        "modals": {
            "saveConfirmation": {
                "title": "Save as New",
                "instructions": "Enter a name for your new rule instance below.",
                "buttonLabel": "Save as New"
            },
            "cancelConfirmation": {
                "title": "Are you sure you want to cancel?",
                "text": "You are about to exit without saving any changes. Are you sure you want to continue and exit without saving?",
                "yesButtonText": "Yes, Cancel",
                "noButtonText": "No, Go Back"
            },
            "objectSelection": {
                "deviceDescription": "Please select a device to run the rule simulation.",
                "deviceFilterHint": "Filter by Device",
                "devices": "Devices",
                "wellDescription": "Please select a well to run the rule simulation.",
                "wellFilterHint": "Filter by Well",
                "wells": "Wells"
            },
            "renameConfirmation": {
                "title": "NOTICE: Changes Affect Other Users",
                "text": "Would you like to Continue Renaming?",
                "yesButton": "Continue Renaming",
                "noButton": "Cancel"
            },
            "renameInstanceDialog": {
                "title": "Rename",
                "instructions": "Enter a new name for your rule instance below.",
                "buttonLabel": "Rename"
            },
            "deleteConfirmation": {
                "title": "Delete Current Rule Instance?",
                "text": "Note: This action cannot be undone.",
                "activeEventsHtml": "This rule instance contains active events in the following objects: __objects__ Deleting this rule instance will close these active events. Are you sure you wish to delete? <br />Note: This action cannot be undone.",
                "yesButton": "Yes, Delete",
                "noButton": "No, Do Not Delete"
            },
            "simulationSaveConfimration": {
                "title": "Are you sure you want to continue?",
                "text": "You have made changes to the rule logic without saving. Are you sure you want to continue and lose these changes?",
                "yesButtonText": "Yes, Continue",
                "noButtonText": "No, Go Back"
            },
            "deleteActionConfirmation": {
                "title": "Remove Current Action?",
                "text": "Are you sure you want to remove the {{actionName}} Action from the {{ruleInstanceName}} rule?",
                "yesButton": "Yes, Remove",
                "noButton": "No, Cancel"
            }
        },
        "copy": "(copy)",
        "exceptions": {
            "nameInUse": {
                "message": "A rule instance with the specified name already exists. Please choose a different name.",
                "title": "Duplicate Names Are Not Allowed"
            }
        }
    },

    "runTicket": {
        "bsw": "BS&W",
        "comments": "Comments",
        "condition": "Condition",
        "estimatedHaul": "Estimated Haul",
        "firstMeasurement": "1st Measurement",
        "interfaceLevel": "Interface Level",
        "interfaceLevelInches": "Interface Level (Inches)",
        "label": "Run Ticket",
        "oilHaul": "Oil Haul",
        "purchaser": "Purchaser",
        "sealOff": "Seal Off",
        "sealOn": "Seal On",
        "secondMeasurement": "2nd Measurement",
        "specificGravity": "Specific Gravity",
        "tank": "Tank",
        "temperature": "Temperature",
        "ticketNumber": "Ticket Number",
        "timestamp": "Timestamp",
        "topLevel": "Top Level",
        "topLevelInches": "Top Level (Inches)",
        "waterHaul": "Water Haul"
    },
    "runTicketDialog": {
        "addRunTicket": "New Run Ticket",
        "cancelAddText": "You're about to leave New Run Ticket without saving your changes. Are you sure you want to continue and exit without saving?",
        "cancelEditText": "You're about to leave Edit Run Ticket without saving your changes. Are you sure you want to continue and exit without saving?",
        "editRunTicket": "Edit Run Ticket",
        "differenceInHoursWarning": "The difference between the 1st and 2nd Measurement timestamp is {{value}} hours. Is this correct?"
    },
    "runTicketFilter": {
        "filter": "Filter",
        "selectMonth": "Select Month",
        "selectTanks": "Select Tanks",
        "allTanks": "All Tanks"
    },
    "runTicketList": {
        "itemMenu": {
            "edit": "Edit",
            "delete": "Delete"
        },
        "options": {
            "filter": "Filter",
            "selectMonth": "Select Month",
            "selectTanks": "Select Tanks",
            "allTanks": "All Tanks"
        }
    },
    "runtimeStatistics": {
        "last7Days": "Last 7 Days",
        "monthToDate": "Month to Date",
        "totalHours": "Total Hours",
        "uptime": "Uptime",
        "downtime": "Downtime"

    },
    "search": {
        "alarmlynx": "AlarmLynx meters containing",
        "compressorlynx": "CompressorLynx meters containing",
        "devices": "Devices containing",
        "groups": "Groups",
        "groupsContaining": "Groups containing",
        "membership": "Membership",
        "nodata": "No data found with the specified search entry.",
        "nodataTitle": "No search results found",
        "wells": "Wells containing",
        "tankBatteries": "Tank Batteries containing"
    },
    "alarmSchedule": {
        "allDay": "All Day",
        "blackoutDays": "Blackout Days",
        "blackoutHours": "Blackout Hours",
        "blackoutInfo": "Note: If Blackout hours are set, notifications will NOT be sent during those hours for the schedule.",
        "blackoutOptions": "Blackout Options",
        "blackoutPreview": "Blackout Preview",
        "duration": "Duration",
        "everyDay": "Every day",
        "repeatInterval": "Repeat Interval",
        "interval": "Interval",
        "invalidEndHour": "End time cannot be less than the start time",
        "invalidStartHour": "Start time cannot be greater than the end time",
        "nameRequired": "An alarm schedule name is required",
        "nameLength": "The alarm schedule name cannot be more than 64 characters",
        "valueRequired": "Value is required",
        "nodata": {
            "title": "No Alarm Schedules",
            "text": "There are no alarm schedules for the selected organization or that match the filter."
        },
        "setBlackoutDays": "Set Blackout Days",
        "setBlackoutHours": "Set Blackout Hours",
        "nameUnique": "The alarm schedule name must be unique name.",
        "unit": "Unit",
        "added": "The alarm schedule was successfully added.",
        "deleted": "The alarm schedule was successfully deleted.",
        "updated": "The alarm schedule was successfully updated."

    },
    "alarmSchemeAdmin": {
        "nameLength": "The Alarm Scheme name cannot be more than 50 characters",
        "nameRequired": "An Alarm Scheme name is required",

        "successMessageAdded": "The alarm scheme was successfully added.",
        "successMessageDeleted": "The alarm scheme was successfully deleted.",
        "successMessageUpdated": "The alarm scheme was successfully updated.",

        "tiers": {
            "alarmOnce": "Alarm Once",
            "delayMinutesRequired": "minutes after alarm is required",
            "descriptionFormat": {
                "beginNotZero": "Notifications for '{{name}}' will begin {{delayMinutes}} minutes after the alarm occurs",
                "beginImmediately": "Notifications for '{{name}}' will begin immediately after the alarm occurs",
                "alarmOnce": "and will alarm once.",
                "notifyXminutes": "and will alarm every {{repeatMinutes}} minutes until acknowledged.",
                "notifyZTimesXMinutes": "and will alarm {{repeatCount}} times, {{repeatMinutes}} minutes apart."
            },
            "everyXMinutes": "Alarm Every",
            "everyXMinutes1": "minutes until acknowledged",
            "minutesApart": "minutes apart",
            "invalidRepeatCount": "Alarm Schemes are limited to {{count}} repeats per tier.",
            "required": "Required",
            "zTimes": "Alarm",
            "zTimes1": "times",
            "zTimes2": "minutes apart",
            "buttons": {
                "create": "Add Tier",
                "save": "Update Tier",
                "addScheduledNotification": "Add Scheduled Notification",
                "editScheduledNotification": "Edit Scheduled Notification"
            },
            "maxRepeats": "Alarm Schemes are limited to {{count}} repeats per tier.",
            "nameLength": "The Tier name cannot be more than 50 characters",
            "nameRequired": "A Tier name is required",
            "nameUnique": "The Tier name must be unique",
            "steps": {
                "settings": "Settings",
                "notifications":"Notifications"
            },
            "useScheduledNotifications": "Use scheduled notifications",
            "noScheduledNotifications": "There are no scheduled notifications.",
            "noTiers": {
                "title": "No Tiers",
                "text": "There are no tiers configured for this alarm scheme"
            },
            "delete": {
                "title": "Delete Tier",
                "text": "You are about to delete {{name}} from this alarm scheme"
            }
        }
    },
    "sendReport": {
        "configuration": "Report Configuration",
        "selectConfiguration": "Specify the report to generate",
        "overrideDates": "Override Start/Stop Times",
        "reportDuration": "Report Duration",
        "reportOptions": "Report Options",
        "includeSubgroups": "Include sub-groups",
        "deliveryOptions": "Delivery Options",
        "documentType":"Document Type",
        "deliveryMessage": "Report will be sent to: {{user}}",
        "msExcel": "Microsoft Excel 97-2003 (.xls)",
        "msExcel1": "Microsoft 2007+ (.xlsx)",
        "pdf": "Adobe PDF",
        "txt": "Text (.csv)",
        "nodata": "There are no report configurations for the current group",
        "scheduledMessage": "Report has been scheduled. Allow 5 to 10 minutes for delivery to {{user}}"


    },
    "setpointAdmin": {
        "actions": {
            "edit": "Edit this Alarm Setpoint",
            "copy": "Copy this Alarm Setpoint",
            "delete": "Delete this Alarm Setpoint",
            "test": "Test Alarm Setpoint Notifications",
            "disable": "Temporarily disable Alarm Setpoint",
            "rename": "Rename Alarm Setpoint"
        },
        "alarmWhen": "Alarm when the value",
        "alarmWhenIs": "Alarm when the value is",
        "alarmWhenTimeIs": "Alarm when the timestamp is",
        "andMore": "And {{count}} more...",
        "buttons": {
            "create": "Create Alarm Setpoint",
            "save": "Update Alarm Setpoint"
        },
        "colors": {
            "title": "Alarm Setpoint Colors",
            "alarm": "Alarm Color",
            "acknowledge": "Acknowledge Color"
        },
        "copy": {
            "title": "Copy this Alarm Setpoint",
            "text": "This option will create a copy of this Alarm Setpoint.  However, you will have to select the tags you want to assign to this Alarm Setpoint.  Are you sure you want to create a copy of this Alarm Setpoint?"
        },
        "delete": {
            "confirmation": "Are you sure you want to delete this Alarm Setpoint?",
            "multiTagConfirmation": "There are {{count}} tags linked to this Alarm Setpoint. Are you sure you want to delete this entire Alarm Setpoint?",
            "oneTagConfirmation": "There is one tag linked to this Alarm Setpoint. Are you sure you want to delete it?",
            "success": "The Alarm Setpoint was successfully deleted.",
            "tagMultiGroupConfirmation": "This setpoint is linked to {{totalTagCount}} tags, {{linkedTagCount}} of which are within this group. Would you like to unlink these tags from the setpoint?",
            "unlinkTags": "Unlink Tags",
            "doNotUnlinkTags": "Do not Unlink Tags",
            "unlinkTag": "Unlink Tag",
            "doNotUnlinkTag": "Do not Unlink Tag"
        },
        "details": "Details",
        "display":"Display",
        "disableTest": "Disable or Test Alarm Setpoint",
        "editAlarmScheme": "Edit Alarm Scheme",
        "editRecipient": "Edit Recipient",
        "evaluationChanges": {
            "text": "There are {{tagCount}} tags linked to this Alarm Setpoint.  Changing the properties of the Alarm Setpoint will cause the Alarm Setpoint to be evaluated for each tag, which could potentially generate an alarm for each one.  Are you sure you want to modify this Alarm Setpoint?",
            "title": "Continue?"
        },

        "fieldAlarmOptions": "Field Alarm Options",
        "filterBy": "Filter by Name",
        "filterByObject": "Filter {{objectType}} Name",
        "groupingOptions": {
            "allAlarms": "All Alarm Setpoints in Use",
            "deviceAlarms": "Device Alarm Setpoints",
            "tankAlarms": "Tank Alarm Setpoints",
            "tankBatteryAlarms": "Tank Battery Alarm Setpoints",
            "wellAlarms": "Well Alarm Setpoints",
            "objectsWithoutAlarms": "Objects with no Alarm Setpoints",
            "setPointsWithoutObjects": "Alarm Setpoints Not In Use"
        },
        "linkedTagText": "Tags on \"{{name}}\" linked to this Alarm Setpoint:",
        "linkTagQuestion": "Are you sure you want to link the Tag to the selected Alarm Setpoints?",
        "linkedToTagsWarning": "This Alarm Setpoint is also linked to {{count}} tags on other objects that are not in the current group. If you need additional access, please contact your administrator.",
        "noTagsRemaining": "No Tags Remaining",
        "setpointDeleteConfirmation": "You have unlinked the last remaining Tag from this Alarm Setpoint. Would you like to delete it?",
        "setpointDeleted": "The Alarm Setpoint has been successfully deleted.",
        "tagAttachmentStatement": "Alert: This Alarm Setpoint is current linked to {{tagCount}} tag(s) across {{objectCount}} object(s). Please review carefully before making changes.",
        "hasIncompatibleTag": "Warning: This Alarm Setpoint is linked to one or more tags that have an incompatible unit of measure. Please contact eLynx Support for assistance.",
        "tagUomNotCompatible": "Warning: Incompatible unit of measure detected for this tag. Please contact eLynx Support for assistance.",
        "messaging": {
            "subject": "Email Subject",
            "body": "Email Message",
            "title": "Messaging",
            "default": "Use Default Messaging",
            "custom": "Use Custom Messaging",
            "exampleAlarm": "Example Alarm Message",
            "exampleClear": "Example Clear Message",
            "voice": "Voice Message",
            "reusableContent": "Insert reusable content...",
            "reusableHelp": "You can use the fields below to adjust the language of the Alarm Message. Use the default scripting options or write your own message text.",
            "sampleHeading": "Sample",
            "sampleTextSnipets": {
                "varianceTypeDecrease": "is less than",
                "varianceTypeEither": "varies from",
                "varianceTypeIncrease": "is greater than"
            },
            "sectionTitle": "Messaging and Visualization",
            "suppressAlarmAlarmLabel": "Suppress Alarm/Alarm Notifications",
            "suppressNormalNormalLabel": "Suppress Normal/Normal Notifications",
            "templateHeading": "Template",
            "templateRequired": "{{name}} cannot be blank",
            "templateTitle": "Insert reusable content such as the Alarm Setpoint name, device name, or tag name",
            "warning": {
                "title": "Default Messaging Warning",
                "message": "Selecting 'Default Messaging' will revert all current messaging changes to their default states.  Are you sure you want to change from Custom Messaging back to Default Messaging?"
            }


        },
        "nodata": {
            "title": "No Alarm Setpoints",
            "groupedText": "There are no {{objectType}} alarm setpoints in the current group.",
            "text": "There are no alarm setpoints in the current group",
            "noObjects": "There are no objects available for this alarm setpoint.",
            "noFilterMatch": "There are no {{name}} for the selected organization or that match the text entered in the filter."
            
        },
        "notifyOnAlarm": "Send Notification on Alarm",
        "notifyOnClear": "Send Notification on Clear",
        "alarmNotify": "Notify on Alarm",
        "clearNotify": "Notify on Clear",
        "notificationOptions": "Notification Options",
        "notificationType": "Notification Type",
        "objectsNoSetpoints": "{{objectType}} with no assigned Alarm Setpoints",
        "objectUsage": "{{objectType}} Tags [{{count}}]",
        "oneTime": "One-Time Notification",
        "recipientType": "Recipient Type",
        "scheduledNotifications": "Scheduled Notifications",
        "setpointNameRequired": "An Alarm Setpoint name is required",
        "steps": {
            "logic": {
                "title": "Logic"
            },
            "usage": {
                "title": "Usage"
            },
            "notifications": {
                "title": "Notifications"
            },
            "actions": {
                "title": "Actions"
            },
            "summary": {
                "title": "Summary"
            }
        },
        "successMessageAdded": "Alarm Setpoint '{{name}}' was successfully added.",
        "successMessageCopied": "The Alarm Setpoint was successfully copied.",
        "successMessageDeleted": "The Alarm Setpoint was successfully deleted.",
        "successMessageTest": "Test for '{{name}}' has been initiated.",
        "successMessageUpdated": "'{{name}}' was successfully updated.",
        "successLinked": "The Tag has been successfully linked from the Alarm Setpoints.",
        "successUnlinked": "The Tag has been successfully unlinked from the Alarm Setpoint.",
        "summary": {
            "alarmValueComparisonTriggerMessage": "The Alarm Setpoint will trigger when the value is {{operator}} {{value}} {{uom}}.",
            "alarmValueComparisonClearMessage": "The Alarm will clear when the value returns to {{value}} {{uom}}",
            "alarmValueComparisonEqualToClearMessage": "The Alarm will clear when the value is no longer equal to {{value}} {{uom}}.",


            "alarmVariationPercentTriggerMessage": "The Alarm Setpoint will trigger when the value is {{varianceType}} the average of the past {{varianceWindow}} by {{varianceOperator}} {{varianceValue}}%.",
            "alarmVariationPercentClearMessage": "The Alarm Setpoint will clear when the value is no longer {{varianceType}} the average of the past {{varianceWindow}} by {{varianceOperator}} {{varianceValue}}%.",


            "alarmVariationAmountTriggerMessage": "The Alarm Setpoint will trigger when the value {{varianceType}} the average of the past {{varianceWindow}} by {{varianceOperator}} {{varianceValue}} {{uom}}.",
            "alarmVariationAmountClearMessage": "The Alarm Setpoint will clear when the value is no longer {{varianceType}} the average of the past {{varianceWindow}} by {{varianceOperator}} {{varianceValue}} {{uom}}.",

            "alarmTimeComparisonTriggerMessage": "The Alarm Setpoint will trigger when the timestamp is {{operator}} {{value}} {{timespanType}}.",
            "alarmTimeComparisonClearMessage": "The Alarm Setpoint will clear when the timestamp is no longer {{operator}} {{value}} {{timespanType}}.",

            "textAlarmTrigger": "The Alarm Setpoint will trigger when the value {{operator}} {{value}}.",
            "textAlarmClear": "The Alarm Setpoint will clear when the value {{operator}} {{value}}.",
            "fieldAlarmTrigger": "The Alarm Setpoint will trigger when the value is 1.",
            "fieldAlarmClear": "The Alarm Setpoint will clear when the value is 0.",


            "orgreater": " or greater.",
            "orless": " or less.",
            "greater": "greater than",
            "less": "less than",
            "equal": "equal to",
            "notequal": "not equal to",

            "messagingSummaryText": "Recipients will receive the {{messageType}} for {{option}}.",
            "messagingNone": "Recipients will not receive notifications",

            "tagsInAlarm": "Tags in alarm will be displayed using the color ",
            "ackTags": "Acknowledged tags will be displayed using the color ",
            "usageSummaryTitle": "This Alarm Setpoint will be applied to the following:",
            "noUsageObjects": "This Alarm Setpoint will not be applied to any objects.",
            "notificationSummaryTitle": "Each time the Alarm Setpoint changes condition, notifications will be sent to the following:",
            "alarmSchemeSummaryTitle": "Each time the Alarm Setpoint changes condition, this alarm scheme will take place:",
            "noNotifications": "No notifications will be sent for this Alarm Setpoint."

        },
        "test": {
            "title": "Test Alarm Setpoint Notifications",
            "text": "You are about to send test alarm notifications to all recipients for this Alarm Setpoint.  Do you wish to proceed?",
            "success": "Test for '{{name}}' has been initiated."
        },
        "tiered": "Tiered Notification",
        "unlink": {
            "confirmation": "Are you sure you want to unlink this Tag from this Alarm Setpoint?",
            "title": "Unlink Alarm Setpoint"
        },
        "usage": "Usage [{{count}}]",
        "deviceTagUsageText": "{{name}}: {{tag}}",
        "setpointNameLength": "The Alarm Setpoint name cannot be more than 50 characters",
        "textValueLength": "The value cannot be more than 100 characters",
        "tagUsageText": "{{name}}",
        "tagValueUsageText": " (Last value: {{value}} on {{ts}}",
        "uomHint": "Note: The unit of measure selection in this step will filter the available list of Tags in the next step",
        "valueComparison": "Value Comparison",
        "valueRequired": "Value is required",
        "valueLessThanZero": "Value cannot be less than 0",
        "variancePct": "Variance (Percentage)",
        "varianceAmt": "Variance (Amount)",
        "varianceWindowLabel": "The average of the past",
        "varianceTimeframe": {
            "day": "day",
            "days": "days",
            "hour": "hour",
            "hours": "hours",
            "month": "month",
            "months": "months"
        },
        "varianceType": {
            "decrease": "less than",
            "either": "greater or less than",
            "increase": "greater than"
        },
        "viewSelected": "View Selected {{name}}",
        "timeComparison": "Time Comparison",
        "timeType": {
            "olderThan": "Older Than"
        },
        "timeComparisonTimeSpan": {
            "minute": "minute",
            "minutes": "minutes",
            "hour": "hour",
            "hours": "hours",
            "day": "day",
            "days": "days"
        }
    },
    "signOut": "Sign out",
    "sort": {
        "sort": "Sort",
        "ascending": "Ascending",
        "descending": "Descending",
        "sortBy": "Sort by",
        "sortOrder": "Sort order"
    },
    "stepMenu": {
        "addSection": "Add Section",
        "collapse": "Collapse",
        "collapseAll": "Collapse All",
        "details": "Details",
        "editSection": "Edit Section",
        "expand": "Expand",
        "expandAll": "Expand All"
    },
    "summaryListing": {
        "findDevice": "Find in Device List",
        "groupBy": "Group By",
        "hardwareType": "Hardware Type",
        "tabs": {
            "devices": "Devices",
            "wells": "Wells",
            "tankBatteries": "Tank Batteries",
            "alarmLynx": "AlarmLynx",
            "compressorLynx": "CompressorLynx"
        },
        "ungroupedTitle": "Objects without values for {{name}}",
        "viewList": {
            "placeholder": "Choose a View",
            "sharedViewsHeading": "Shared Views",
            "sharedReadOnlyViewsHeading": "Shared Read-Only Views",
            "privateViewsHeading": "Private Views",
            "currentlyUnavailable": "Currently Unavailable"
        },
        "nodata": "No {{objectType}} in the current group.",
        "nodataMultiSection": "There are {{count}} devices in the current group which are not displayed since they don't match any of the section definitions.",
        "nodataFilter": "No {{objectType}} from the current group match the filter text you have entered. Please edit or remove the filter.",
        "unavailableConfiguration": "Currently Unavailable",
        "unavailableConfigurationText": "System Balance Groups do not support configurations that are grouped by Device Type as the Input/Output/Other totals will no longer compute properly.",
        "configurationError": "Configuration Error",
        "configurationErrorText": "There is a problem with the {{name}} configuration.  Please contact eLynx Support for assistance."
    },
    "summaryListingConfiguration": {
        "1dSparklineTooltip": "1d Uses Raw Data",
        "3dSparklineTooltip": "3d Uses Raw Data",
        "7dSparklineTooltip": "7d Uses Hourly Avg. Data",
        "30dSparklineTooltip": "30d Uses Daily Avg. Data",
        "attributes": "Attributes",
        "cancel": "Cancel",
        "cancelConfirmationDialogTitle": "Are you sure you want to cancel?",
        "cancelConfirmationDialogText": "You are about to exit without saving any additional columns or display settings. Are you sure you want to continue and exit without saving?",
        "cancelConfirmationYesButtonText": "Yes, Cancel",
        "cancelConfirmationNoButtonText": "No, Go Back",
        "dataValues": "Data Values",
        "day": "day",
        "day_plural": "days",
        "deprecated": "DEPRECATED",
        "deviceTypeChangeConfirmation": {
            "title": "Are you sure you want to change the device type?",
            "confirmationText": "If you change the device type the list of selected tags will be updated to match the tags available for the device type.",
            "yesButtonText": "Yes, Change",
            "noButtonText": "No, Go Back"
        },
        "deviceTypeChangeRequired": {
            "title": "You must select a Hardware Device Type for the original section",
            "text": "When converting from an \"All Devices\" view to a Hardware Type based Summary Listing you must select a Hardware Device Type for the first view section before proceeding.",
            "yesButtonText": "Okay"
        },
        "deviceTypeNotInGroup": "There are no devices of type {{name}} in the current group, editing this section is disabled",
        "displayTotals": "Display Totals",
        "displayUom": "Display UoM",
        "exceptions": {
            "deleteDefault": {
                "message": "The view you are attempting to delete is set as the default for one or more users. A view cannot be deleted if it is set as default.",
                "title": "Default Views Cannot Be Deleted"
            },
            "deleteLastView": {
                "message": "You are attempting to delete the last view, which is not allowed.",
                "title": "Last View Cannot Be Deleted"
            },
            "nameInUse": {
                "message": "A view with the specified name already exists. Please choose a different name.",
                "title": "Duplicate Names Are Not Allowed"
            },
            "noModifyPermissions": {
                "message": "You do not have sufficient privileges to apply changes to this view.",
                "title": "Modify Privileges Are Required"
            }
        },
        "filterByAttributes": "Filter By Attributes",
        "filterByDataValues": "Filter By Data Values",
        "filterByHistoryValue": "Filter By History Values",
        "formatCurrentValue": "{{name}} - Current Value",
        "formatHistoricalAggregate": "{{name}} - {{aggregationPeriod}} Day Moving Average",
        "formatSingleDayAggregateDeprecated": "{{name}} - Average [{{aggregationPeriod}} $t(pageConfiguration.day, {\"count\": {{aggregationPeriod}}}) prior] - DEPRECATED",
        "formatCurrentDayAggregateDeprecated": "{{name}} - Average [current day] - DEPRECATED",
        "formatSparkline": "__name__ - __duration__ Day Sparkline",
        "formatTimestamp": "{{name}} - Timestamp",
        "formatVarianceAmount": "{{name}} - {{aggregationPeriod}} Day Absolute Variance",
        "formatVariancePercent": "{{name}} - {{aggregationPeriod}} Day Percent Variance",
        "formatVariancePercentDeprecated": "{{name}}- Variance [{{aggregationPeriod}}-day] - DEPRECATED",
        "noDataValues": "No data values have been selected.",
        "objectOrder": "Object Order",
        "objectOrderInfo": "Custom sort orders are set in Group Administration - Contents",
        "optionalDisplayName": "Optional Display Name",
        "organizeColumns": "Organize Columns",
        "pageConfiguration": "Page Configuration",
        "saveAsNew": "Save As New",
        "saveChanges": "Save Changes",
        "saveConfirmation": {
            "title": "Save as New",
            "instructions": "Enter a name for your new view below.",
            "buttonLabel": "Save as New"
        },
        "saveSuccessText": "View '__name__' has been saved.",
        "sections": "Sections",
        "selectColumns": "Select Columns",
        "selectedColumns": "Selected Columns",        
        "sparklineLimitTitle": "Sparkline Columns",
        "sparklineLimitInstructions": "Each View supports up to __count__ total Sparkline columns. This View already has __count__ Sparkline columns selected. Please remove one of the currently selected items before making another selection.",
        "sparklineLimitYesButtonText": "Okay, Continue.",
        "step1Title": "1: Select Columns",
        "step2Title": "2: Display Options",
        "step3Title": "3: Organize Columns",
        "step1Instructions": "Add columns to your Summary Listing",
        "step2Instructions": "Select advanced display options",
        "step3Instructions": "Drag and drop to organize columns",
        "viewSelectedColumns": "View Selected Columns",
        "infoTitle": "A Summary Listing may consist of a single section that will be applied to all Devices in the group, OR may consist of separate sections for each unique type of hardware in the group.  If a view is being edited and there are no devices of that type in the group then the section may not be edited.",
        "infoTitleSystemBalance": "A System Balance Configuration may only consist of a single section that will be applied to all Devices in the group. This is required so that the Input/Output/Other totals work as expected.",
        "displayOptions": {
            "dataValues":"Data Values",
            "currentValue":"Current Value",
            "timestamp":"Timestamp",
            "showTimestamp": "Show Timestamp",
            "movingAvg": "Moving Average",
            "absVariance": "Absolute Variance",
            "pctVariance": "Percent Variance",
            "mostRecentInTimeframe": "Most Recent Value Within Timeframe",
            "historyNotSelected": "No history columns match the filter or no columns have been selected"
        },
        "selectData": {
            "title": "Select Data",
            "tabs": {
                "dataValues": {
                    "title": "Data Values",
                    "filter": "Filter by Data Value Name",
                    "viewSelected": "View Selected Data Values"
                },
                "attributes": {
                    "title": "Attributes",
                    "filter": "Filter by Attribute Name",
                    "viewSelected": "View Selected Attributes"
                },
                "history": {
                    "title": "History",
                    "filter": "Filter by History Value",
                    "viewSelected": "View Selected Columns"
                }

            }
        },
        "deprecationConfirmationEdit": {
            "title": "NOTICE: This View Contains Columns That Are No Longer Supported",
            "text": "This View cannot be edited because it contains columns that are no longer supported. Would you like to duplicate this view with the columns that are still supported?"
        },
        "deprecationConfirmationDuplicate": {
            "title": "NOTICE: This View Contains Columns That Are No Longer Supported",
            "text": "The duplicated View will only contain columns that are still supported. Do you still want to duplicate this View?"
        },
        "viewSections": "View Sections",
        "useCustomOrdering": "Use Custom Order for Summary Listing"
    },
    "summaryListingFilter": {
        "filter": "Filter",
        "filterText": "Search Criteria"
    },
    "tag": {
        "label": "Tag",
        "cancelPropertiesConfirmationDialogText": "You are about to exit without saving tag property changes. Are you sure you want to continue and exit without saving?",
        "cancelEditText": "You are about to leave manual entry without saving the tag data values you entered. Are you sure you want to continue and exit without saving?",
        "enableWrite": "Please be certain you are enabling a tag for write down that is supported by the EFM/RTU/PLC as it could cause incorrect operation including physical damage. Do you want to continue?",
        "history": {
            "changeDatesForMoreData": "The selected timeframe returned more than {{count}} data values. Please adjust the timeframe again to view additional data values.  You can also use the Reporting tool to view and export larger amounts of data.",
            "exceededRows": "Tag History Row Limit Exceeded"
        },
        "offlineValuesStored": "The values have been stored and will be saved once the app is back online.",
        "ungrouped": "Ungrouped Tags",
        "rawValue": "Raw Value",
        "source": "Source",
        "tabs": {
            "alarmHistory": "Alarm History",
            "alarmSetpoints": "Alarm Setpoints",
            "controlHistory": "Control History",
            "history": "History",
            "memos": "Memos",
            "properties": "Properties",
            "values": "Values",
            "runtimeStatistics": "Runtime Statistics"
        },
        "value": "Data Value",
        "valuesSaved": "The values have been saved.",
        "propertiesSaved": "The properties for the tag were saved.",
        "register": {
            "editRegister": "Edit Register",
            "dataType": "Data Type",
            "roc": {
                "label1": "Type (T)",
                "label2": "Logical (L)",
                "label3": "Parameter (P)"
            },
            "totalFlow": {
                "label1": "App",
                "label2": "Array",
                "label3": "Index"
            },
            "saved": "Tag Registers updated successfully.",
            "alreadyInUseDialog": {
                "title": "Identifier already in use.",
                "text": "This register is in use elsewhere and cannot be assigned again remotely. Please contact support at 866-303-5969 or via e-mail support@elynxtech.com for assistance with changing this register assignment."
            },
            "multiLinkedDialog": {
                "title": "Identifier already in use.",
                "text": "The identifier for this tag is used elsewhere, please contact support at 866-303-5969 or via e-mail support@elynxtech.com for assistance with changing this register assignment."
            },
            "test": "Test",
            "testFailed": "Change register test failed.",
            "testSuccess": "Change register test completed successfully."
        },
        "uid": "UID",
        "readItem": "Read Item",
        "writeItem": "Write Item",
        "lookupList": "Lookup List",
        "formula": "Formula"
    },
    "tankRelationships": {
        "applyCriteria": "Apply Criteria to",
        "barrels": "(Barrels)",
        "bopd": "BOPD",
        "bwpd": "BWPD",
        "capacity": "Capacity (Barrels)",
        "capacityFilled": "Capacity Filled (%)",
        "collapseAll":"Collapse All",
        "dailyOilProduction": "Daily Oil Production (Barrels)",
        "dailyWaterProduction": "Daily Water Production (Barrels)",
        "deviceName": "Device Name",
        "displayName": "Display Name",
        "expandAll": "Expand All",
        "expandCollapse": "Expand/Collapse All",
        "filterTitle": "Filter",
        "filterText": "Filter by using any of the criteria below.",
        "groupByTankPad": "Group by Tank Pad",
        "groupByDevice": "Group by Device",
        "groupByTank": "Group by Tank",
        "nodata": {
            "title": "",
            "text": "There is no data that matches the filter."
        },
        "operator": "Operator",
        "pct": "(%)",
        "tankName": "Tank Name",
        "tankNumber": "Tank Number",
        "topLevel":"Top Level",
        "interfaceLevel":"Interface Level"

    },
    "tankStyles": {
        "add": "Add Tank Style",
        "edit": "Edit Tank Style",
        "capacity": "Capacity: {{capacity}}",
        "description": "Description",
        "filterBy": "Filter by Description",
        "units": "Unit of Measure: {{unit}}",
        "height": "Tank Height (inches):  {{height}}",
        "multiplier": "Inches Multiplier:  {{multiplier}}",
        "liquidProduction": "Liquid Production: {{value}}",
        "elevatedTank": "Elevated Tank: {{value}}",
        "tankBottom": "Tank Bottom (inches): {{value}}",
        "tankTop": "Tank Top (inches): {{value}}",
        "form": {
            "capacity": "Capacity",
            "description": "Description",
            "filterBy": "Filter by Description",
            "units": "Unit of Measure",
            "height": "Tank Height (inches)",
            "multiplier": "Inches Multiplier",
            "liquidProduction": "Liquid Production",
            "descriptionRequired": "Description is required",
            "valueUnique": "Description must be unique",
            "maxLength": "Description cannot be more than 128 characters",
            "valueRequired": "Value is required",
            "enterValues":  "Enter any two values to calculate the tank style parameters.",
            "saved": "Tank style has been saved",
            "elevatedTank": "Elevated Tank",
            "bottomLevel": "Bottom Level (inches)",
            "topLevel": "Top Level (inches)"
        },
        "nodata": "There are no Tank Styles matching the filter you have entered."
    },
    "trending": {
        "chartOptions": "Chart Options",
        "configuration": {
            "list": {
                "placeholder": "Choose a Configuration",
                "placeholderObj": "Choose {{objectType}} Configuration",
                "shared": "Shared Graphs",
                "sharedReadOnly": "Shared Read-Only Graphs",
                "private": "Private Graphs"
            },
            "aggregates": {
                "raw": "Raw",
                "avg": "Avg",
                "min": "Min",
                "max": "Max",
                "sum": "Sum",
                "lkv": "LKV",
                "lkhv": "LKHV"
            },
            "sections": "Sections",
            "steps": {
                "graphOptions": {
                    "axesOptions": "Axes Options",
                    "comparison": {
                        "beginning": "Beginning",
                        "earlier": "Earlier",
                        "showAdditionalGraph": "Show additional graph",
                        "startingOn": "Starting on",
                        "title": "Comparison Graph"
                    },
                    "graph": "Graph",
                    "options": {
                        "autoRefresh": "Automatically Refresh",
                        "combineAcrossDeviceAxes": "Combine <i>Across Devices</i> Sections on a common Axis",
                        "showAlarms": "Show Alarms for Tags in this Graph",
                        "showDataQuality": "Show Data Quality",
                        "showDiagnostics": "Show Diagnostics",
                        "showManualEvents": "Show Manual Events",
                        "showLegend": "Show Legend",
                        "showMemos": "Show Memos for all objects",
                        "showSectionsStacked": "Show Sections as stacked graphs",
                        "showTabularData": "Show Tabular Data",
                        "showSettingsChanges": "Show Remote Settings Changes for Tags in this Graph",
                        "title": "Options"
                    },
                    "title": "Graph Options",
                    "tooltips": {
                        "warnNotAvailWithOutAcrossDevices": "Not available unless at least one <i>Graph Section</i> has <i>Across Devices</i> selected.",
                        "warnNotAvailWithCompare": "Not available when <i>Show additional graph</i> is selected.",
                        "warnNotAvailWithSingleSection": "Not available when there is only one section.",
                        "warnNotAvailWithStacked": "Not available when <i>Show Sections as stacked graphs</i> is selected."
                    }
                },
                "graphSections": {
                    "title": "Graph Sections",
                    "typeOfPlot": {
                        "infoDialog": {
                            "description": "Plotting data <i>Per Device</i> will give you a data series per each Device/Data Value combination you define. Choosing <i>Across Devices</i> will allow you to create a single data series that sums or averages the data values across all Devices.",
                            "title": "Section Type"
                        },
                        "title": "Type of Plot",
                        "acrossDevices": "Across Devices",
                        "perDevice": "Per Device"
                    },
                    "yAxes": {
                        "title": "Y-Axes",
                        "plotSeriesInSectionOnOwnYAxis": "Plot each data series in this Section on its own Y-axis",
                        "plotSeriesInSectionOnSameYAxis": "Plot each data series in this Section on the same Y-axis"
                    },
                    "dataLayout": {
                        "title": "Data Layout",
                        "sample": "Sample",
                        "style1": {
                            "title": "List of data with one row for each {{singularObjectTypeName}}, timeframe, and data value",
                            "description": "A report consisting of a list of {{pluralObjectTypeName}} with a single row for each {{singularObjectTypeName}}, timeframe, and data value in the configured duration."
                        },
                        "style2": {
                            "title": "List of timeframes for each {{singularObjectTypeName}} with data values as columns",
                            "description": "A report consisting of a list of {{pluralObjectTypeName}} with a row for each timeframe in the configured duration. The columns in the list will consist of the attributes and data values selected for the report."
                        },
                        "style4": {
                            "title": "List of {{pluralObjectTypeName}} and data values with",
                            "asColumns": "as columns",
                            "timeframesAsColumns": "timeframes as columns",
                            "description": "A report consisting of a list of {{pluralObjectTypeName}} with a row for each selected {{singularObjectTypeName}} and data value. The columns in the list will consist of each timeframe in the configured duration for the report."
                        },
                        "style8": {
                            "title": "List of events with one row for each event",
                            "description": "A report consisting of a list of events with a row for each selected event. The columns in the list will consist of each timeframe in the configured duration for the report."
                        },
                        "viewSample": "View Sample",
                        "timeframes": {
                            "hours": "Hours",
                            "days": "Days",
                            "months": "Months"
                        }
                    },
                    "duration": "Duration",
                    "menu": {
                        "duplicate": "Duplicate",
                        "delete": "Delete",
                        "rename": "Rename"
                    },
                    "editContents": "Edit Contents",
                    "info": "A Graph can have multiple Sections of data. The following options are specific to each Graph Section that you build.",
                    "expandAll": "Expand All",
                    "collapseAll": "Collapse All",
                    "addSection": "Add Section",
                    "name": "Section Name"
                },
                "selectContents": {
                    "includeTanks": {
                        "includeTanksForDevices": "Include Tanks for the selected Devices?",
                        "oilTanks": "Oil Tanks",
                        "tanksIncludedInfo": "Tanks can be included for all the Devices displayed in the Graph",
                        "tanksSelectedInfo": "Individual Tanks can also be selected below",
                        "tankTypes": "Tank Types",
                        "waterTanks": "Water Tanks"
                    },
                    "title": "Select Contents",
                    "filter": "Filter by {{singularObjectTypeName}} Name",
                    "viewSelected": "View Selected {{pluralObjectTypeName}}"
                },
                "selectData": {
                    "title": "Select Data",
                    "tabs": {
                        "dataValues": {
                            "title": "Data Values",
                            "filter": "Filter by Data Value Name",
                            "viewSelected": "View Selected Data Values"
                        },
                        "tankDataValues": {
                            "title": "Tank Data Values",
                            "filter": "Filter by Tank Data Value Name",
                            "viewSelected": "View Selected Tank Data Values"
                        }
                    }
                },
                "dataOptions": {
                    "title": "Data Options",
                    "tabs": {
                        "dataSeries": {
                            "title": "Data Series",
                            "name": "Name",
                            "rawData": "Raw Data",
                            "hourlyData": "Hourly Data",
                            "dailyData": "Daily Data",
                            "monthlyData": "Monthly Data",
                            "filter": "Filter by Name"
                        }
                    }
                },
                "formatDataSeries": {
                    "chartProperties": {
                        "chartTypes": {
                            "area": "Area",
                            "arearange": "Area Range",
                            "areaspline": "Areas Spline",
                            "areasplinerange": "Area Spline Range",
                            "bar": "Bar",
                            "boxplot": "Boxplot",
                            "bubble": "Bubble",
                            "column": "Column",
                            "columnrange": "Column Range",
                            "funnel": "Funnel",
                            "gauge": "Gauge",
                            "heatmap": "Heatmap",
                            "line": "Line",
                            "pie": "Pie",
                            "scatter": "Scatter",
                            "solidgauge": "Solid Gauge",
                            "spline": "Spline",
                            "step": "Step",
                            "waterfall": "Waterfall"
                        },
                        "dashStyles": {
                            "dash": "Dash",
                            "dashDot": "Dash Dot",
                            "dot": "Dot",
                            "longDash": "Long Dash",
                            "longDashDot": "Long Dash Dot",
                            "longDashDotDot": "Long Dash Dot Dot",
                            "shortDash": "Short Dash",
                            "shortDashDot": "Short Dash Dot",
                            "shortDashDotDot": "Short Dash Dot Dot",
                            "shortDot": "Short Dot",
                            "solid": "Solid"
                        },
                        "symbols": {
                            "circle": "Circle",
                            "diamond": "Diamond",
                            "square": "Square",
                            "triangle": "Triangle",
                            "triangle_down": "Triangle Down"
                        }
                    },
                    "lineStyle": "Line Style",
                    "chartType": "Chart Type",
                    "marker": "Marker",
                    "title": "Format Data Series",
                    "dataSeries": "Data Series",
                    "optionalDisplayName": "Optional Display Name",
                    "decimal": "decimal",
                    "decimals": "decimals",
                    "default": "Default",
                    "new": "NEW!"
                }
            },
            "exceptions": {
                "nameInUse": {
                    "message": "A report with the specified name already exists. Please choose a different name.",
                    "title": "Duplicate Names Are Not Allowed"
                }
            },
            "dialogs": {
                "changeTypeOfPlotConfirmation": {
                    "title": "Change Type Of Plot?",
                    "acrossDeviceText": "NOTICE: Changing the <i>Type Of Plot</i> from <i>Per Device</i> to <i>Across Devices</i> will remove any <i>Device Values</i> or <i>Tank Values</i> selections. New values will need selected for this Section.<br/><br/>Do you still want to change the Type of Plot?",
                    "perDeviceText": "NOTICE: Changing the <i>Type Of Plot</i> from <i>Across Devices</i> to <i>Per Device</i> will remove any <i>Device Values</i> or <i>Tank Values</i> selections. New values will need selected for this Section.<br/><br/>Do you still want to change the Type of Plot?"
                },
                "changeyAxesOptionConfirmation": {
                    "title": "Change Combining of Y-axes?",
                    "ownYaxisText": "NOTICE: Changing the Combining of Y-axes from <i>Plot each data series in this Section on the same Y-axis</i> to <i>Plot each data series in this Section on its own Y-axis</i> will reset custom names for all Y-axes. If custom names were set up, they will need set again.<br/><br/>Do you still want to change the Combining of Y-axes?",
                    "sameYaxisText": "NOTICE: Changing the Combining of Y-axes from <i>Plot each data series in this Section on its own Y-axis</i> to <i>Plot each data series in this Section on the same Y-axis</i> will reset custom names for all Y-axes. If custom names were set up, they will need set again.<br/><br/>Do you still want to change the Combining of Y-axes?"
                },
                "preview": {
                    "title": "Preview of {{name}}"
                }
            },
            "duration": {
                "ago": "ago",
                "beginning": "Beginning",
                "current": "Current",
                "duration": "Duration",
                "earlier": "earlier",
                "previous": "Previous"
            }
        
        },
        "comparisonGraph": {
            "beginning": "Beginning",
            "earlier": "Earlier",
            "startingOn": "Starting on",
            "title": "Comparison Graph"
        },
        "created": "Created",
        "forceMinMax": "Force Min/Max",
        "hideAxes": "Hide Axes",
        "labels": {
            "graphing": "Graphing"
        },
        "messages": {
            "maxCompareDuration": "Duration cannot be greater than 4 digits.",
            "maxCompareDurationNEW": "Duration cannot be greater than 90.",
            "selectConfig": "Please select a saved Graph from the Options menu.",
            "selectOrCreateConfig": "Please select a saved Graph from the Options menu, or create a New Graph."
        },
        "nodata": "No {{objectType}} in the current group.",
        "options": {
            "saveGraphImage": "Save Graph Image",
            "title": "Graph Options"
        },
        "overrideOptions": {
            "optionSelections": {
                "showAlarms": {
                    "name": "Show Alarms",
                    "tooltip": "Show Alarms"
                },
                "showAnomalies": {
                    "name": "Show Anomalies",
                    "tooltip": "Show Anomalies"
                },
                "showComparison": {
                    "name": "Show additional graph",
                    "tooltip": "Show additional graph"
                },
                "showDataQuality": {
                    "name": "Show Data Quality",
                    "tooltip": "Show Data Quality"
                },
                "showDiagnostics": {
                    "name": "Show Diagnostics",
                    "tooltip": "Show Diagnostics"
                },
                "showManualEvents": {
                    "name": "Show Manual Events",
                    "tooltip": "Show Manual Events"
                },
                "showLegend": {
                    "name": "Show Legend",
                    "tooltip": "Show Legend"
                },
                "showMemos": {
                    "name": "Show Memos",
                    "tooltip": "Show Memos"
                },
                "showSectionsStacked": {
                    "name": "Show Sections as stacked graphs",
                    "tooltip": "Show Sections as stacked graphs"
                },
                "showTabularData": {
                    "name": "Show Tabular Data",
                    "tooltip": "Show Tabular Data"
                },
                "showSettingsChanges": {
                    "name": "Show Settings Changes",
                    "tooltip": "Show Settings Changes"
                }
            },
            "title": "Override Options"
        },
        "primaryGraph": {
            "title": "Primary Graph"
        },
        "quickGraph": {
            "buttons": {
                "plotGraph": "Plot Graph",
                "openDialog": "Quick Graph"
            },
            "filter": {
                "dataSeries": {
                    "label": "Filter By Data Series",
                    "viewSelected": "View Selected Data Series"
                },
                "filterOptions": "Filter Options",
                "object": {
                    "label": "Filter By Devices",
                    "viewSelected": "View Selected Devices"
                }
            },
            "selectDevices": "Select Devices",
            "selectDataSeries": "Select Data Series",
            "title": "Quick Graph Options"
        },
        "showAxes": "Show Axes",
        "tooltips": {
            "maximizeView": "Maximize View",
            "saveGraphImage": "Save Graph Image"
        },
        "yAxesOptions": {
            "customLabel": "Custom Label (optional)",
            "fixedMin": "Fixed Minimum Value",
            "fixedMax": "Fixed Maximum Value",
            "interlaced": "Interlaced",
            "logrithmic": "Logarithmic",
            "showGridlines": "Show Grid Lines",
            "yAxisMaxRangeZeroOrLessWarning": "When the y-Axis is set to 'Logarithmic', 'Fixed Maximum Value' cannot be 0 or less.",
            "yAxisMaxRangeWarningTitle": "Invalid 'Fixed Maximum Value'",
            "yAxisMinRangeZeroOrLessWarning": "When the y-Axis is set to 'Logarithmic', 'Fixed Minimum Value' cannot be 0 or less.",
            "yAxisMinRangeWarningTitle": "Invalid 'Fixed Minimum Value'",
            "yAxisMaxRangeValueWarning": "'Fixed Maximum Value' cannot be less than or equal to 'Fixed Minimum Value'.",
            "yAxisMinRangeValueWarning": "'Fixed Minimum Value' cannot be greater than or equal to 'Fixed Maximum Value'."

        }

    },
    "trendingConfig": {
        "newConfigName":  "New Graph"
    },
    "uom": {
        "units": "Units",
        "maxLength": "Unit of Measure name cannot be more than 64 characters",
        "nameUnique": "Unit of Measure name must be unique",
        "nameRequired": "Unit of Measure name is required",
        "saved": "Unit of Measure '{{name}}' has been saved",
        "update": "Unit of measure has been updated"
    },
    "update": "Update",
    "updateAvailableMessage": "A new version is available! Click Update to install.",
    "updatedAppMessage": "You have been updated to the latest version of eLynx.",
    "saveSuccessMessage": "The {{itemName}} has been successfully saved.",
    "views": {
        "accounting": "Accounting",
        "addRemoveDevices": "Add/Remove Devices",
        "administration": "Administration",
        "adminLayout": "Admin Layout",
        "alarmDashboard": "Alarm Dashboard",
        "alarmDashboardDetail": "Alarm Dashboard Detail",
        "alarmNotificationReport": "Alarm Notifications Report",
        "alarmSchemeAdministration": "Alarm Scheme Administration",
        "alarmScheduleAdministration": "Alarm Schedule Administration",
        "alarmSetpoints": "Alarm Setpoints",
        "alarmsAndNotifications": "Alarms & Notifications",
        "attributeManagement": "Attribute Management",
        "badCommsReport": "Bad Comms Report",
        "setpointAdministration": "Alarm Setpoint Administration",
        "notificationListAdministration": "Notification List Administration",
        "attachments": "Attachments",
        "auditReporting": "Audit Reporting",
        "changePassword": "Change Password",
        "contentLayout": "Content Layout",
        "communicationsManagement": "Communications Management",
        "configurationCleanup": "Configuration Cleanup",
        "customForms": "Forms",
        "dataFileImport": "Data File Import",
        "dashboard": "Dashboard",
        "deviceDetails": "Device Details",
        "deviceDetailsTagValues": "Device Details - Tag Values",
        "deviceDetailsProperties": "Device Details - Properties",
        "deviceDetailsDefaults": "Device Details - Defaults",
        "deviceDetailsAlarmSetpoints": "Device Details - Alarm Setpoints",
        "deviceDetailsAttachments": "Device Details - Attachments",
        "deviceDetailsHistory": "Device Details - History",
        "deviceDetailsRunTickets": "Device Details - Run Tickets",
        "deviceDetailsRelationships": "Device Details - Relationships",
        "deviceDetailsUrlViewer": "Device Details - Url Viewer",

        "deviceGraph": "Device Graph",
        "deviceMarketingReport": "Device Marketing Report",
        "deviceTagValues": "Device Tag Values",
        "deviceDefaults": "Device Defaults",
        "disabledRecipientsReport": "Disabled Recipients Report",
        "dynacards": "Dynacards",
        "dynamicGroupConfiguration":"Dynamic Group Configuration",
        "gaugesheet": "Gauge Sheet",
        "gaugeSheetExport": "Gauge Sheet Export",
        "groupGraph": "Group Graph",
        "groupMarketingReport": "Group Marketing Report",
        "groupManualEntry": "Manual Entry",
        "graphReport": "Graph Report",
        "groupAdministration": "Group Administration",
        "cloneGroupMembership": "Clone Group Membership",
        "groupContents": "Contents",
        "groupManualEntryConfiguration": "Manual Entry Configuration",
        "groupProperties": "Properties and Child Groups",
        "groupSystemBalanceConfiguration": "System Balance Configuration",
        "history": "History",
        "historicalData": "Historical Data",
        "imageView": "Image View",
        "liquidProductionAdmin": "Liquid Production Administration",
        "login": "Login",
        "lookupListAdministration": "Lookup List",
        "manageObjects": "Manage Objects",
        "manualEntry": "Manual Entry",
        "map": "Map View",
        "memoAutoText": "Memo Auto-Text",
        "monthlyInvoice": "Monthly Invoice Details",
        "objectAdministration": "Object Administration",
        "miscellaneous": "Miscellaneous",
        "pageVisibilityAdministration": "Page Visibility Settings",
        "playground": "Playground",
        "plungerAnalysis": "Plunger Analysis",
        "pollingFrequencyAdmin": "Bulk Frequency Administration",
        "productionDashboard": "Production Dashboard",
        "productionForecast": "Production Forecasting",
        "properties": "Properties",
        "relationships": "Relationships",
        "reporting": "Custom Reports",
        "rolePermissionsReport": "Role Permissions Report",
        "rulesEngineAdministration": "Rules Engine Administration",
        "runTickets": "Run Tickets",
        "scheduledReports": "Scheduled Reports",
        "searchResults": "Search Results",
        "securityPermissions": "Security Permissions Administration",
        "sendReport": "Send Report",
        "setpointReport": "Alarm Setpoint List Report",
        "summaryListing": "Summary Listing",
        "summaryListingDevices": "Summary Listing - Devices",
        "summaryListingWells": "Summary Listing - Wells",
        "summaryListingTankBatteries": "Summary Listing - Tank Batteries",
        "summaryListingAlarmLynx": "Summary Listing - AlarmLynx",
        "summaryListingCompressorLynx": "Summary Listing - CompressorLynx",
        "tagDetails": "Tag Details",
        "tagDetailsValues": "Tag Details - Values",
        "tagDetailsProperties": "Tag Details - Properties",
        "tagDetailsAlarmSetpoints": "Tag Details - Alarm Setpoints",
        "tagDetailsHistory": "Tag Details - History",
        "tagDetailsRuntimeStatistics": "Tag Details - Runtime Statistics",
        "tagHistory": "Tag History",
        "tagValues": "Tag Values",
        
        "tankBatteryDetails": "Tank Battery Details",
        "tankBatteryDetailsTagValues": "Tank Battery Details - Tag Values",
        "tankBatteryDetailsProperties": "Tank Battery Details - Properties",
        "tankBatteryDetailsAlarmSetpoints": "Tank Battery Details - Alarm Setpoints",
        "tankBatteryDetailsAttachments": "Tank Battery Details - Attachments",
        "tankBatteryDetailsHistory": "Tank Battery Details - History",
        "tankBatteryDetailsRunTickets": "Tank Battery Details - Run Tickets",
        "tankBatteryDetailsRelationships": "Tank Battery Details - Relationships",
        "tankBatteryDetailsUrlViewer": "Tank Battery Details - Url Viewer",

        "tankDetails": "Tank Details",
        "tankDetailsTagValues": "Tank Details - Tag Values",
        "tankDetailsProperties": "Tank Details - Properties",
        "tankDetailsAlarmSetpoints": "Tank Details - Alarm Setpoints",
        "tankDetailsAttachments": "Tank Details - Attachments",
        "tankDetailsHistory": "Tank Details - History",
        "tankDetailsRunTickets": "Tank Details - Run Tickets",
        "tankDetailsRelationships": "Tank Details - Relationships",
        "tankDetailsUrlViewer": "Tank Details - Url Viewer",

        "tankRelationships": "Tank Relationships Report",
        "tankStyleAdmin": "Tank Styles",
        "templateAdministration": "Template Administration",
        "urlViewer": "URL Viewer",
        "userListReport": "User List Report",
        "userPermissionsReport": "User Permissions Report",
        "userRoleAdministration": "User and Role Administration",
        "usersAndSecurity": "Users & Security",
        "values": "Values",
        
        "wellDetails": "Well Details",
        "wellDetailsTagValues": "Well Details - Tag Values",
        "wellDetailsProperties": "Well Details - Properties",
        "wellDetailsAlarmSetpoints": "Well Details - Alarm Setpoints",
        "wellDetailsAttachments": "Well Details - Attachments",
        "wellDetailsHistory": "Well Details - History",
        "wellDetailsRelationships": "Well Details - Relationships",
        "wellDetailsUrlViewer": "Well Details - Url Viewer",

        "wellGraph": "Well Graph"
    },
    "wellName": "Well Name",
    "wellReview": {
        "current": "Current",
        "last24Hours": "24 Hours",
        "last7Days": "7 Days",
        "targetProduction": "Target",
        "variance": "Variance",
        "plannedDown": "Planned Down Wells",
        "unplannedDown": "Unplanned Down Wells",
        "downWells": "Down Wells",
        "producingWells": "Producing Wells",
        "atRiskDown": "Ongoing Events",
        "unknownWells": "Unknown Wells",
        "downWellsDescription": "Wells are considered to be down (not flowing) when their Flow Rate has been at zero for a given period of time. Typically this threshold is a defined in number of hours.",
        "producingWellsDescription": "Based on the most recent data we have, the well is currently producing as normal.",
        "atRiskDownDescription": "Wells are considered to have ongoing events if one or more event conditions have been detected and are not yet cleared.",
        "unknownDescription": "Based on the most recent data we have, these wells have not communicated with our system for a given period of time. Typically this threshold is a defined in number of hours.",
        "allOther": "All Other Wells",
        "noFilterMatch": "There are no wells that match the text entered in the filter.",
        "filterHint": "Filter by well name",
        "viewHistory": "View Well History",
        "takeAction": "Take Action on Well",
        "hideHistory": "Hide Well History",
        "wellHistory": "Well History",
        "setValueOn": "Set the value on",
        "changedValueOn": "Changed the value on",
        "settingPrefix": "The value on",
        "setTo": "was set to",
        "changedFrom": "was changed from",
        "noevents": "There are no items that match the selected types.",
        "memo": "Memo",
        "remoteSettings": "Remote Settings",
        "addMemo": "Add Memo",
        "addDiagnosticEvent": "Add Diagnostic Event",
        "editValues": "Edit Data Values",
        "editSetpoints": "Edit Alarm Setpoints",
        "disableEnableAnalytics": "Disable/Re-enable Analytics",
        "wellDetails": "Go to Well Details",
        "showMemos": "Show Memos",
        "hideMemos": "Hide Memos",
        "showControl": "Show Remote Settings",
        "hideControl": "Hide Remote Settings",
        "showDiagnosticEvents": "Show Diagnostic Events",
        "hideDiagnosticEvents": "Hide Diagnostic Events",
        "showDataQualityEvents": "Show Data Quality Events",
        "hideDataQualityEvents": "Hide Data Quality Events",
        "viewDashboard": "View Dashboard",
        "30dayProdSummary": "30 Day Production Summary",
        "currentProdStatus": "Current Production Status",
        "yesterdayProd": "Yesterday's Production",
        "30dayAverageProd": "30 Day Average Daily Production",
        "lastRefreshed": "Last Refreshed",
        "oil": "Oil",
        "gas": "Gas",
        "water": "Water",
        "contactElynx": "Contact eLynx",
        "additionalInfo": "Additional insights from eLynx Analytics coming soon! Contact us for more information.",
        "noProductionTargets": "No Production Targets to display",
        "groupTargetDailyProduction": "Group Target Daily Production",
        "reEnableDateTime": "Anomaly Detection Disabled - Set to re-enable on {0} at {1}",
        "wellAbnormalSynopsis": "The well is behaving abnormally.",
        "wellNormalSynopsis": "The well has returned to normal behavior.",
        "wellDiagnosis": "The latest diagnosis is ",
        "target": "Target",
        "calcCannotRun": "Calculation cannot run, critical data is missing.",
        "unknown": "Unknown",
        "producing": "Producing",
        "atRisk": "Ongoing Events",
        "down": "Down",
        "wellGraph": "Well Graph",
        "wellList": "Well List",
        "maximizeGraph": "Maximize Graph",
        "restoreGraph": "Restore Graph"
    },
    "fileStoreUploadDialog": {
        "title": "Upload Files",
        "description": "Description",
        "uploadSuccessMessage": "File \"{{fileName}}\" has been uploaded.",
        "externalTags": "External Tags",
        "internalTags": "Internal Tags",
        "tags": "Tags"
    },
    "fileStoreEditDialog": {
        "title": "Edit Files",
        "description": "Description",
        "saveSuccessMessage": "Changes to your files have been saved.",
        "externalTags": "External Tags",
        "internalTags": "Internal Tags",
        "tags": "Tags"
    },
    "fileStoreManagerDialog": {
        "title": "Manage Files",
        "deleteSuccessMessage": "The selected files have been deleted.",
        "deleteConfirmation": "Are you sure you want to delete the selected files?",
        "restoreSuccessMessage": "The selected files have been restored.",
        "filterByDescription": "Filter by Description",
        "filterByExternalTags": "Filter by External Tags",
        "filterByInternalTags": "Filter by Internal Tags",
        "filterByTags": "Filter by Tags",
        "showDeletedFiles": "Show Deleted Files",
        "tooltips": {
            "usageCount":{
                "hmiImages": "This image is used {{usageCount}} time(s) in one or more views",
                "default": "This file is used {{usageCount}} time(s)"
            },
            "locked":{
                "hmiImages": "This image is in use in one or more views and cannot be deleted",
                "default": "This file is in use and cannot be deleted"
            },
            "deleted":{
                "hmiImages": "This image has been deleted",
                "default": "This file has been deleted"
            },
            "preview": {
                "hmiImages": "Preview Image",
                "default": "Preview File"
            },
            "manageLibrary": {
                "hmiImages": "Manage Image Library",
                "default": "Manage File Library"
            },
            "edit": {
                "hmiImages": "Edit Image Properties",
                "default": "Edit File Properties"
            },
            "download": {
                "hmiImages": "Download Images",
                "default": "Download Files"
            },
            "delete": {
                "hmiImages": "Delete Images",
                "default": "Delete Files"
            },
            "restore": {
                "hmiImages": "Restore Images",
                "default": "Restore Files"
            },
            "deleteForever": {
                "hmiImages": "Delete Images Permanently",
                "default": "Delete Files Permanently"
            },
            "add": {
                "hmiImages": "Add Images",
                "default": "Add Files"
            },
            "showAsGrid": "Show as Grid",
            "showAsList": "Show as List"
        }
    },
    "user": "User",
    "waterLossEventEditDialog": {
        "addEvent": "New Water Loss Event",
        "editEvent": "Edit Water Loss Event",
        "estimatedLoss": "Etimated Gallons Lost",
        "selectCause": "Select Cause",
        "cause": "Cause",
        "notes": "Notes"
    },
    "userRoleAdministration": {
        "tabs": {
            "users": {
                "title": "Users",
                "noData": {
                    "title": "There are no users defined for the selected organization",
                    "text1": "You can add users to this organization using the",
                    "text2": "button in the toolbar"
                },
                "noFilteredData": {
                    "title": "There are no users for the selected organization that match the filter criteria"
                },
                "filterBy": "Filter by Name or Login",
                "noMembers": {
                    "title": "No roles have been associated with this user",
                    "text": "Select Edit in the menu to assign roles"
                },
                "noPermissions": {
                     "title": "No permissions have been granted to this user",
                     "text": "Select Edit in the menu to assign roles"
                },
                "deleteUserConfirmation": {
                    "title": "Warning: This action cannot be undone!",
                    "explanation1": "You are about to delete a user and revoke all access to the eLynx Application",
                    "explanation2": "By checking the box below, you acknowledge that {{firstName}} {{lastName}} ({{login}}) will no longer be able to access the eLynx Application",
                    "confirmationText": "Delete this user and revoke all access"
                },
                "deleteUserAcknowledge": "User {{deletedFirstName}} {{deletedLastName}} ({{deletedLogin}}) has been deleted",
                "disableUserAcknowledge": "User {{disabledFirstName}} {{disabledLastName}} ({{disabledLogin}}) has been disabled",
                "notificationsDisabled": "Notifications are disabled until {{timestamp}}",
                "notificationsForwarded": "Notifications will be forwarded to {{recipient}} until {{timestamp}}"
            },
            "roles": {
                "title": "Roles",
                "noData": {
                    "title": "There are no roles defined for the selected organization",
                    "text1": "You can add roles to this organization using the",
                    "text2": "button in the toolbar"
                },
                "noFilteredData": {
                    "title": "There are no roles for the selected organization that match the filter criteria"
                },
                "filterBy": "Filter by Name or Description",
                "noMembers": {
                    "title": "No users have been associated with this role",
                    "text": "Select Edit in the menu to assign users"
                },
                "noPermissions": {
                    "title": "No permissions have been granted to this role",
                    "text": "You can grant permissions to this role through the Security Permissions view"
               },
               "deleteRoleConfirmation": {
                   "title": "Warning: This action cannot be undone!",
                   "explanation1": "You are about to delete a role and its associated permissions",
                   "explanation2": "By checking the box below, you acknowledge that {{name}} will be deleted",
                   "confirmationText": "Delete this role"
               },
               "deleteRoleAcknowledge": "Role {{deletedName}} has been deleted"
            }
        },
        "sortBy": "Sort by",
        "sortOptionsText": {
            "descriptionAsc": "Description (A to Z)",
            "descriptionDesc": "Description (Z to A)",
            "firstNameAsc": "First Name (A to Z)",
            "firstNameDesc": "First Name (Z to A)",
            "lastActivityAsc": "Last Activity (Oldest to Newest)",
            "lastActivityDesc": "Last Activity (Newest to Oldest)",
            "lastNameAsc": "Last Name (A to Z)",
            "lastNameDesc": "Last Name (Z to A)",
            "nameAsc": "Name (A to Z)",
            "nameDesc": "Name (Z to A)",
            "userEmailAsc": "User Email (A to Z)",
            "userEmailDesc": "User Email (Z to A)",
            "mobileAccessAsc": "Mobile Access (Disabled to Enabled)",
            "mobileAccessDesc": "Mobile Access (Enabled to Disabled)",
            "userEnabledAsc": "User Enabled (Disabled to Enabled)",
            "userEnabledDesc": "User Enabled (Enabled to Disabled)"
        },
        "membership": "Membership",
        "security": "Security",
        "userEnabled": "This user is enabled",
        "userDisabled": "This user is disabled",
        "isElynxAdmin": "This user has eLynx Admin permissions",
        "mobileEnabled": "Mobile access is enabled for this user",
        "mobileDisabled": "Mobile access is disabled for this user"
    },
    "userEditor": {
        "steps": {
            "general": {
                "createEmailRecipient": "Create Email Recipient",
                "createSmsRecipient": "Create Text Recipient",
                "createVoiceRecipient": "Create Voice Recipient",
                "title": "General",
                "userInformation": "User Information",
                "accountInformation": "Account Information",
                "ssoNameLabel": "Single Sign-on Name",
                "firstName": "First Name",
                "lastName": "Last Name",
                "companyName": "Company Name",
                "jobTitle": "Job Title",
                "jobFunction": "Job Function",
                "phoneNumber": "Phone Number",
                "timeZone": "Time Zone",
                "login": "Login & Contact Email",
                "emailWelcomeMessage":"Email new user welcome message",
                "lastLoginDateTime": "Last Login Date/Time",
                "enableMobileAccess": "Enable Mobile Access",
                "requirePasswordChange": "Require Password Change",
                "disableUser": "Disable User",
                "firstNameRequired":"First Name is required",
                "lastNameRequired":"Last Name is required",
                "emailRequired": "A valid email is required",
                "phoneRequired": "Phone Number is required",
                "mfaSource": "MFA Source",
                "resetMfa": "Reset to Email",
                "mfaResetSuccess": "The authentication source for user '{{name}}' was successfully set back to Email.",
                "multiCustomer": "The login cannot be changed here because this user has access to muliple customers. To change the login, please contact Customer Support.",
                "updateRecipients": {
                    "title": "Update Recipients?",
                    "confirmationText1": "The existing phone number for this user is used by the following recipients:",
                    "confirmationText2": "Would you like to update these recipients to match the new phone number?",
                    "yesButtonText": "Yes, Update",
                    "noButtonText": "No, Do Not Update"
                }
            },
            "alarmNotifications": {
                "title": "Alarm Notifications",
                "email": "email",
                "emailNotifications": "Email Notifications",
                "sms": "text",
                "smsNotifications": "SMS Notifications",
                "voice": "voice",
                "voiceNotifications": "Voice Notifications",
                "usage":"Usage [{{count}}]",
                "disabledOn": "Disabled on {{timestamp}}",
                "notificationLists": "Notification Lists",
                "alarmSetpoints":"Alarm Setpoints",
                "addRecipient": "Add Recipient",
                "disableConfirmation": {
                    "title": "Warning: Critical Changes Requested!",
                    "explanation1": "You are about to disable all alarm notifications via {{recipientType}} for {{recipientTo}}. This action will be logged to the eLynx Applcation.",
                    "explanation2": "By checking the box below, you acknowledge that {{recipientTo}} will no longer receive any alarms via {{recipientType}}.",
                    "confirmationText": "Disable this recipient and stop all {{recipientType}} messages"
                },
                "recipients": "Recipients",
                "noRecipients": {
                     "title": "There are no recipients assigned to this user",
                     "text": "You can add recipients to this user using the Add Recipient button"
                }
            },
            "membership": {
                "title": "Membership",
                "filter": "Filter by Name or Description",
                "viewSelected": "View Selected Roles"
            },
            "security": {
                "title": "Security",
                "noPermissions": {
                     "title": "No permissions have been granted to this user",
                     "text": "Please select one or more roles in the Membership step"
                }
            },
            "pageVisibility": {
                "title": "Page Visibility",
                "customizationMode": {
                    "allViews": {
                        "title": "All Views",
                        "disabledTooltip": "All Views cannot be applied because this user has custom visibility configured.",
                        "description": "Page Visibility controls what items appear in the user’s menu. This does not change permissions or access rights — it only hides or shows pages for convenience. All Views visibility includes every available view in the eLynx Application. This is the default visibility for all users who haven't been assigned a preset or custom visibility."
                    },
                    "preset": {
                        "title": "Preset",
                        "disabledTooltip": "Preset cannot be applied because this user has custom visibility configured.",
                        "description": "Page Visibility controls what items appear in the user’s menu. This does not change permissions or access rights — it only hides or shows pages for convenience. Preset visibility assigns a user a set list, but users can update their own visibility settings at any time."
                    },
                    "custom": {
                        "title": "Custom"
                    }
                }
            }
        },
        "saveSuccessMessage": "User {{firstName}} {{lastName}} ({{login}}) has been saved"
    },
    "uiCustomizationSettings": {
        "infoText": "Page Visibility controls what items appear in the user’s left-side menu. This does not change permissions or access rights — it only hides or shows pages for convenience. Custom Visibility allows Users to update their own visibility settings at any time.",
        "showHeaderName":"Show Header Name",
        "tabs": {
            "groups": {
                "title": "Group Pages"
            },
            "devices": {
                "title": "Device Pages"
            },
            "wells": {
                "title": "Well Pages"
            },
            "tankBatteries": {
                "title": "Tank Battery Pages"
            },
            "tanks": {
                "title": "Tank Pages"
            },
            "tags": {
                "title": "Tag Pages"
            }
        }
    },
    "uiCustomizationSettingsDialog": {
        "title": "Menu Settings",
        "saveSuccessMessage": "Your menu settings have been successfully saved",
        "openOnHover": "Open Drawer on Hover"

    },
    "roleEditor": {
        "steps": {
            "general": {
                "title": "General",
                "roleDescription": "Role Description",
                "roleName": "Role Name",
                "nameRequired":"Name is required",
                "descriptionRequired":"Description is required",
                "roleInformation": "Role Information"
            },
            "membership": {
                "title": "Membership",
                "filter": "Filter by Name or Login",
                "viewSelected": "View Selected Users"
            },
            "security": {
                "title": "Security",
                "noPermissions": {
                     "title": "No permissions have been granted to this role",
                     "text": "You can grant permissions to this role through the Security Permissions view"
                }
            }
        },
        "saveSuccessMessage": "Role {{name}} has been saved"
    },


    "permissionsList": {
        "eLynxAdminUserPermissions": {
            "title": "eLynx Admin",
            "text": "This user has access to all objects through the eLynx Admin role"
        },
        "eLynxAdminRolePermissions": {
            "title": "Internal System Role",
            "text": "eLynx Admin has access to all objects"
        },
        "defaultRolePermissions": {
            "title": "Internal System Role",
            "text": "Default is a special internal system role used to grant users access to devices, tags, and configurations in the system"
        },
        "everyoneRolePermissions": {
            "title": "Internal System Role",
            "text": "Everyone is a special internal system role used to grant users access to devices, tags, and configurations in the system"
        }
    },

    "userUsageHistoryDialog": {
        "userUsageHistory": "User Usage History",
        "accessType":"Access Type",
        "date":"Date"
    },

    "userFavorites": {
        "title": "Favorites",
        "removeConfirmation": {
            "invalidTitle": "Invalid User Favorite",
            "unavailableTitle": "View Not Yet Available",
            "unavailableExplanation": "The view referenced by this favorite is not yet available in this version of the eLynx Application.",
            "confirmationText": "Would you like to remove this favorite from your favorites list?"
        },
        "removedAcknowledgement": "Favorite has been removed",
        "savedAcknowledgement": "Favorite has been saved",
        "nameUnique": "The favorite name must be unique name."
    },
    "userFavoritesManagerDialog": {
        "title": "Manage Favorites",
        "removeConfirmation": {
            "title": "Remove Favorite?",
            "confirmationText": "Are you sure you want to remove this favorite from your favorites list?",
            "yesButtonText": "Yes, Remove",
            "noButtonText": "No, Go Back"
        },
        "saveSuccessMessage": "Changes to your favorites have been saved"
    },
    "securityPermissions": {
        "tabs": {
            "groups": {
                "title": "Group Permissions",
                "description": "The following users and roles have been granted access to the selected group",
                "noData": {
                    "title": "No users or roles have been granted permissions to the selected group"
                },
                "noFilteredData": {
                    "title": "There are no users for the selected organization that match the filter criteria"
                },


                "deleteUserConfirmation": {
                    "title": "Warning: This action cannot be undone!",
                    "explanation1": "You are about to delete a user and revoke all access to the eLynx Application",
                    "explanation2": "By checking the box below, you acknowledge that {{firstName}} {{lastName}} ({{login}}) will no longer be able to access the eLynx Application",
                    "confirmationText": "Delete this user and revoke all access"
                },
                "deleteUserAcknowledge": "User {{deletedFirstName}} {{deletedLastName}} ({{deletedLogin}}) has been deleted"
            },
            "devices": {
                "title": "Device Permissions",
                "description": "The following users and roles have been granted access to specific devices in the selected group",
                "noData": {
                    "title": "No users or roles have been granted permissions to any devices in the selected group"
                },
                "noFilteredData": {
                    "title": "There are no devices, users, or roles for the selected group that match the filter criteria"
                },


                "deleteRoleConfirmation": {
                   "title": "Warning: This action cannot be undone!",
                   "explanation1": "You are about to delete a role and its associated permissions",
                   "explanation2": "By checking the box below, you acknowledge that {{name}} will be deleted",
                   "confirmationText": "Delete this role"
               },
               "deleteRoleAcknowledge": "Role {{deletedName}} has been deleted"
            },
            "wells": {
                "title": "Well Permissions",
                "description": "The following users and roles have been granted access to specific wells in the selected group",
                "noData": {
                    "title": "No users or roles have been granted permissions to any wells in the selected group"
                },
                "noFilteredData": {
                    "title": "There are no wells, users, or roles for the selected group that match the filter criteria"
                },


                "deleteRoleConfirmation": {
                   "title": "Warning: This action cannot be undone!",
                   "explanation1": "You are about to delete a role and its associated permissions",
                   "explanation2": "By checking the box below, you acknowledge that {{name}} will be deleted",
                   "confirmationText": "Delete this role"
               },
               "deleteRoleAcknowledge": "Role {{deletedName}} has been deleted"
            },
            "tagTypes": {
                "title": "Tag Type Permissions",
                "description": "The following users and roles have been granted access to specific tags in the selected group",
                "noData": {
                    "title": "No users or roles have been granted permissions to any tags in the selected group"
                },
                "noFilteredData": {
                    "title": "There are no tags, users, or roles for the selected group that match the filter criteria"
                },


               "deleteRoleConfirmation": {
                   "title": "Warning: This action cannot be undone!",
                   "explanation1": "You are about to delete a role and its associated permissions",
                   "explanation2": "By checking the box below, you acknowledge that {{name}} will be deleted",
                   "confirmationText": "Delete this role"
               },
               "deleteRoleAcknowledge": "Role {{deletedName}} has been deleted"
            }
        },
        "filterBy": "Filter by Name",
        "dialogs": {
            "revokePermissionsConfirmation": {
                "title": "Revoke Access",
                "confirmationText": "You have chosen to revoke access to \"{{objectName}}\" from one or more users or roles. Are you sure you want to revoke access?",
                "yesButtonText": "Yes, Continue",
                "noButtonText": "No, Go Back"
            }
        },
        "revokePermissionsAcknowledge":"Permissions have been successfully revoked"
    },
    "permissionsSummary": {
        "admin": "Administrator",
        "readOnly": "Read-Only",
        "custom": "Custom"
    },
    "securityPermissionsEditor": {
        "steps": {
            "selectRolesUsers": {
                "title": "Select Roles/Users",
                "tabs": {
                    "roles": {
                        "title": "Roles"
                    },
                    "users": {
                        "title": "Users"
                    }
                }
            },
            "selectObjects": {
                "title": "Select {{objectTypeName}}"
            },
            "selectPermissions": {
                "title": "Select Permissions",
                "applyToWellDevices": "Set applicable permissions on all devices linked to this well",
                "groupModifyWarning": "Granting Group Modify permissions will allow the selected users or roles to see and choose from ALL devices in the current organization when using Group Administration."
            }
        },
        "savePermissionsAcknowledge":"Permissions have been successfully granted/revoked"
    },
    "usageWithCount": "Usage [{{count}}]",
    "groupManualEntry": {
        "legend": {
            "title": "Legend",
            "manuallyEntered": "Manually Entered Value",
            "calculated": "Calculated Value"
        }
    },
    "objectWithCount": "{{name}} [{{count}}]",
    "permissionReport": {
        "firstName": "First Name",
        "lastName": "Last Name",
        "userID": "User ID",
        "accountActive": "Account Active",
        "lastLoginTime": "Last Login Time",
        "roleList": "Role List",
        "roleName": "Role Name",
        "group": "Group",
        "permissionType": "Permission Type",
        "read": "Read",
        "write": "Write",
        "execute": "Execute",
        "manualEdit": "Manual Edit",
        "liveData": "Live Data",
        "control": "Control",
        "disable": "Disable",
        "nodata": {
            "title": "No data",
            "text": "There is no permission data for the current organization"
        }
    },
    "userListReport": {
        "nodata": {
            "title": "No data",
            "text": "There is no user data for the current organization"
        }
    },
    "scheduledReports": {
        "active": "Active",
        "edit": "Edit",
        "copy": "Copy",
        "delete": "Delete",
        "descriptionLength": "The report description cannot be more than 512 characters",
        "exportOptions": {
            "excel": "Excel",
            "pdf": "PDF",
            "csv": "CSV",
            "other": "Other"
        },
        "exportFormat": "Export Format",
        "filterBy": "Filter by name",
        "frequency": {
            "label": "Frequency",
            "hourly": "Hourly",
            "daily": "Daily",
            "weekly": "Weekly",
            "monthly": "Monthly",
            "custom": "Custom",
            "hour": "Hour(s)",
            "day": "Day(s)",
            "week": "Week(s)",
            "month": "Month(s)",
            "year": "Year(s)"
        },
        
        "reportCreatedBy": "Report created by: {{name}}",
        "repeatInterval": "Repeat Interval",
        "reportType": "Report Type",
        "taskCreatedBy": "Task created by: {{name}}",
        "group": "Group: {{group}}",
        "notifications": "Notifications [{{count}}]",
        "reservedEmail": "The email you entered is a reserved address that is automatically managed by the system",
        "schedules": "Schedules [{{count}}]",
        "schedulesLabel": "Schedules",
        "newSchedule": "New Schedule {{num}}",
        "lastRun": "Last Run: {{ts}}",
        "nodata": {
            "title": "",
            "instruction": "You can add Scheduled Reports using the 'Add Scheduled Report' button in the toolbar.",
            "text": "There are no {{reportType}} reports for the '{{org}}' organization or that match the text in the filter.",
            "textall": "There are no reports for the '{{org}}' organization or that match the text in the filter.",
            "myreports": "You have no scheduled reports"

        },
        "notificationListOnlyConfirmation": {
            "title": "Permission Denied",
            "confirmationText": "You do not have the required permissions to edit this task. Please contact your administrator for assistance."
        },
        "deleteRecipientsConfirmation": {
            "title": "Report Recipients",
            "confirmationText": "Choose the email addresses you want this scheduled report delivered to.",
            "success": "Delivery notifications have been updated."
        },
        "deleteRecipientsWarning": {
            "title": "Warning: Removal from Scheduled Report",
            "confirmationHtml": "<p>If you remove your email addresses from the Scheduled Report, you will no longer have access to the Scheduld Report task. You will have to contact your Administrator to be added back to the scheduled delivery.</p><p>Do you wish to remove your email address from the Scheduled Report?</p>"
        },
        "report": "Report",
        "reportDescription":"Report Description",
        "reportTypeOptions": {
            "custom": "Custom Report",
            "groupMarketing": "Group Marketing Report",
            "user": "User Report"
        },
        "reportTypes": {
            "all": "All Scheduled Reports",
            "custom": "Custom Reports",
            "groupMarketing": "Group Marketing Reports",
            "user": "User Reports"

        },
        "selectReport": "Select Report",
        "steps": {
            "details": {
                "addSchedule": "Add Schedule",
                "at": "at",
                "collapseAll": "Collapse All",
                "custom": "The report should run every",
                "day": "day",
                "dayOfMonth": "Day of Month",
                "dayOfWeek": "Day of Week",
                "expandAll": "Expand All",
                "exportFormat": "Export Format",
                "frequency": "Frequency",
                "hour": "hour",
                "minute": "minute",
                "minutes": "minutes",
                "minutesPastTheHour": "minutes past the hour",
                "pastTheHour": "past the hour",
                "month": "month",
                "newSchedule": "New Schedule",
                "ofEach": "of each",
                "recipientRequired": "At least one recipient is required.",
                "report": "Report",
                "reportDescription": "Report Description",
                "reportTag": "Report Tag",
                "reportType": "Report Type",
                "runReportEvery": "The report should run every ",
                "runReportOnDay": "The report should run on ",
                "schedule": "Schedule",
                "selectDayOfMonth": "Select Day of Month",
                "selectDayOfWeek": "Select Day of Week",
                "selectGroupMarketingTat": "Select Report Tag",
                "selectHour": "Select Hour",
                "selectMinute": "Select Minute",
                "selectReport": "Select Report",
                "selectReportType": "Select Report Type",
                "selectTimezone": "Select Timezone",
                "timezone": "Time Zone",
                "title": "Details",
                "week": "week",
                "year": "year",
                "on": "on",
                "of": "of",
                "ofThe": "of the"
            },
            "notifications": {
                "allOrganizations": "All Organizations",
                "notificationLists": "Notification Lists",
                "recipients": "Recipients",
                "tabs": {
                    "notificationLists": {
                        "filter": "Filter by Name",
                        "viewSelected": "View Selected Lists"
                    },
                    "recipients": {
                        "filter": "Filter by Email",
                        "viewSelected": "View Selected Recipients"
                    }
                },
                "title": "Notifications"
            },
            "summary": {
                "active": "Active",
                "deleted": "Deleted",
                "disabled": "Disabled",
                "noActiveSchedules": "No active schedules selected",
                "noDisabledSchedules": "No disabled schedules selected",
                "noNotificationLists": "No notification lists selected",
                "noRecipients": "No recipients selected",
                "reportDetails": "Report Details",
                "title": "Summary"


            }
        },
        "deleteSuccessText": "Report Task '{{name}}' has been deleted.",
        "saveSuccessText": "Report Task '{{name}}' has been saved.",
        "uniqueNameText": "The Report Task name is already in use. Please specify a unique name."
    },
    "viewSelected": "View Selected {{name}}",
    "productionForecasting": {
        "auto": "auto",
        "chart": {
            "heading": "Production Forecast",
            "dragZoom": "Click and drag in the plot area to zoom in",
            "pinchZoom": "Pinch the chart to zoom in",
            "labels": {
                "averageDailyRate": "Average Daily Rate",
                "cumulativeProduction": "Cumulative Production",
                "declineType": "Decline Type",
                "forecastProduction": "Forecast Production",
                "historicalProduction": "Historical Production",
                "forecastYears": "Forecast Length (Years)",
                "initialRate": "Initial Rate",
                "declineRate": "Decline Rate"
            }
        },
        "configurationTitle": "Production Forecast Configuration",
        "declineRate": "Decline Rate",
        "deleteConfirmation": "Are you sure you want to remove the production forecasting configuration from this device?",
        "deletedMessage": "The production forecasting configuration has been removed from this device.",
        "durationToAnalyze": "Duration to Analyze (years)",
        "editConfiguration": "Edit Forecast Configuration",
        "exponentialDeclineModel": "Exponential Decline Model",
        "forecastLength": "Forecast Length (years)",
        "forecastParameters": "Forecast Parameters",
        "historicalProductionTag": "Historical Production Tag",
        "hyperbolicBetaFactor": "Hyperbolic (&beta;) Factor",
        "hyperbolicDeclineModel": "Hyperbolic Decline Model",
        "initialRate": "Initial Rate",
        "initialRateDetermination": "Initial Rate Determination",
        "instructions": "The initial rate (above) is determined by analyzing historical production values for the well. Please specify the production tag and duration to be analyzed.",
        "note": "Note that if insufficient historical data exists, or if the data is inconsistent, it may not be possible to determine the initial rate automatically. In this case, you may manually enter or override the initial rate value.",
        "saveChangesConfirmation": "You have made changes to your configuration, but have not saved them.  Whould you like to save your changes?",
        "saveChangesDialogTitle": "Save Changes",
        "savedMessage": "The production forecasting configuration has been saved for this device.",
        "nodata": "Create a production forecasting configuration for this device to view the production forecast chart.",
        "minValue": "{{name}} must be greater than or equal to {{value}}",
        "maxValue": "{{name}} must be less than or equal to {{value}}",
        "monthly": "Monthly",
        "daily": "Daily"
    },

    "templateAdministration": {
        "create": "Create Template",
        "dialogs": {
            "rename": {
                "title": "Rename Template",
                "newName": "New Name",
                "okButtonText": "Save",
                "nameInUseText": "* Unable to save - template name already in use."
            },
            "delete": {
                "title": "Confirm Delete",
                "confirmationText": "Delete template '{0}'. Are you sure?",
                "okButtonText": "Confirm"
            },
            "cancelConfirmation": {
                "title": "Are you sure you want to cancel?",
                "text": "You are about to exit without saving any changes. Are you sure you want to continue and exit without saving?",
                "yesButtonText": "Yes, Cancel",
                "noButtonText": "No, Go Back"
            }
        },
        "filter": "Filter by Name or Description",
        "noData": {
            "title": "There are no templates defined for the selected organization",
            "text1": "You can add templates to this organization using the",
            "text2": "button in the toolbar"
        },
        "noFilteredData": {
            "title": "There are no templates for the selected organization that match the filter criteria"
        },


        "internal": "Internal",
        "messages": {
            "created": "Template created.",
            "deleted": "Template deleted.",
            "renamed": "The template has been renamed.",
            "saved": "Template saved."
        },
        "newTemplate": "New Template",


        "noTagsDetectedInAdvanced":  "There are currently no tags defined within the new template. Add at least one tag to the template to proceed.",
        "required": "*Required",
        "save": "Save Template",
        "showInternal": "Show Internal Templates"
    },

    "templateEditor": {
        "steps": {
            "properties": {
                "title": "Properties",
                "nameInUse": "Template Name is already in use",
                "standardProperties": "Standard Properties",
                "templateName": "Template Name",
                "templateDescription": "Template Description",
                "nameIsRequired": "Template Name is required",
                "internal": "Internal"
            },
            "selectDevice": {
                "title": "Select Device",
                "instructions": "Please select the device that will be used to create the template.",
                "filterHint": "Filter by Device Name",
                "noDevices": {
                    "message": "Please select a different organization and try again.",
                    "title": "There are no Devices defined in the current Organization"
                },
                "noFilteredDevices": {
                    "message": "",
                    "title": "There are no Devices that match the selected filter criteria"
                }
            },
            "selectTags": {
                "title": "Select Tags",
                "deviceTags": "Device Tags",
                "filterHint": "Filter by Tag Name",
                "instructions": "Please select the tags that will be included in the template.",
                "viewSelected": "View Selected Tags",
                "noTags": {
                    "message": "",
                    "title": "There are no Tags available for the current Device"
                },
                "noFilteredTags": {
                    "message": "",
                    "title": "There are no Tags that match the selected filter criteria"
                }
            },
            "summary": {
                "title": "Summary",
                "tagsDescription": "These are the tags that will be added to the template:",
                "unableToSave": "Unable to save"
            }
        }

    },

    "manageObjects": {
        "tabs": {
            "devices":{
                "filterBy": "Filter by Device Name",
                "noData": {
                    "title": "There are no devices defined for the selected organization",
                    "text1": "You can add devices to this organization using the",
                    "text2": "button in the toolbar"
                },
                "noFilteredData": {
                    "title": "There are no devices for the selected organization that match the filter criteria"
                },
                "noTemplates": {
                    "title": "No Templates",
                    "text": "There are currently no templates configured for this organization. Please contact eLynx customer support to get templates set up.",
                    "yesButtonText": "Close"
                }
            },
            "wells":{
                "filterBy": "Filter by Well Name",
                "noData": {
                    "title": "There are no wells defined for the selected organization",
                    "text1": "You can add wells to this organization using the",
                    "text2": "button in the toolbar"
                },
                "noFilteredData": {
                    "title": "There are no wells for the selected organization that match the filter criteria"
                }
            }
        }
    },
    "tagAssociationTypePickerDialog": {
        "inUseInfo": "Tags already in use on the current {{objectType}} are disabled.",
        "noData": {
            "title": "No Tag Types",
            "text": "There are no tag types that match the selected filter criteria."
        },
        "usage":"Usage count {{count}}",
        "tagTypeName": "Tag Type Name",
        "title": "Select Tag Type",
        "filter": {
            "current": "Currently in use",
            "common": "Common Tags",
            "hourly": "Hourly Tags",
            "daily": "Daily Tags",
            "label": "Show"
        }
    },
    "tagEditorDialog": {
        "savedMessage": "The Tag has been saved",
        "usedContractHours": "Used Contract Hours",
        "unusedContractHours": "Unused Contract Hours",
        "filterBy": "Filter by Tag Name",
        "noData": {
            "title": "There are no manual entry tags defined for the selected object",
            "text1": "You can add manual entry tags to this object using the",
            "text2": "button in the toolbar"
        },
        "noFilteredData": {
            "title": "There are no manual entry tags for the selected objects that match the filter criteria"
        }
    },
    "manageTagsDialog": {
        "title": "Manage Tags",
        "information": "Manage Tags only supports Manual Entry tags at this time"
    },
    "applyTemplateDialog": {
        "title": "Apply Template",
        "template": {
            "label": "Template",
            "required": "Template is required"
        },
        "contractHour": {
            "label": "Contract Hour",
            "required": "Contract Hour is required"
        },
        "identifierOrPath": {
            "label": "Identifier or Path",
            "required": "Identifier or Path is required",
            "tooltip": "For Web Hosted Devices"
        },
        "cancelConfirmation": "You're about to exit without applying a Template. Are you sure you want to continue and cancel?",
        "tagInTemplateCount": "The selected template contains 1 tag.",
        "tagsInTemplateCount": "The selected template contains {{count}} tags.",
        "tagToAddCount": "1 tag will be applied to {{deviceName}}.",
        "tagsToAddCount": "{{count}} tags will be applied to {{deviceName}}.",
        "tagToExcludeCount": "1 tag will NOT be applied since it already exists on the Device.",
        "tagsToExcludeCount": "{{count}} tags will NOT be applied since they already exist on the Device.",
        "tagToBeAdded": "The following tag will be added to the device:",
        "tagsToBeAdded": "The following tags will be added to the device:",
        "tagAdded": "Template has been applied and 1 tag added successfully",
        "tagsAdded": "Template has been applied and {{count}} tags added successfully",
        "instructions": "Please select a template to apply to the device and set a contract hour for the newly applied tags. To add additional templates, please contact Customer Support."
    },
    "templatePickerDialog": {
        "title": "Select Template",
        "noData": {
            "title": "No Templates",
            "text": "There are no templates defined for the selected organization"
        },
        "noFilteredData": {
            "title": "No Templates",
            "text": "There are no templates that match the filter criteria"

        }
    },
    "disableObjectsDialog": {
        "title": "Disable Objects",
        "filterByDeviceName": "Filter by Device Name",
        "filterByWellName": "Filter by Well Name",
        "filterByDeviceState": "Filter by Device State",
        "filterByWellState": "Filter by Well State",
        "stateFilter": {
            "all": "All",
            "visible": "Visible",
            "hidden": "Hidden",
            "enabled": "Enabled",
            "disabled": "Disabled"
        },
        "saveSuccessMessage": "Your changes have been saved"
    },
    "bulkDeviceSetup": {
        "title": "Bulk Device Setup",
        "deviceNameLength": "Device name exceeds 50 characters",
        "identifierLength": "SCADA identifier exceeds 50 characters",
        "invalidDeviceName": "Device name cannot be blank",
        "invalidContractHour": "Invalid contract hour",
        "parseError": "Error Parsing File",
        "emptyFile": "The file is empty. Please select another one.",

        "importLimit": "The bulk creation tool can only create {{maxRowCount}} devices at a time. Only the first {{maxRowCount}} lines from your file will be loaded.",
        "importLimitWarning": "Import Device Limit Exceeded",
        "logEntryTypeEnum": {
            "failed": "Failed Devices = {{count}}",
            "success": "Devices Successfully Created = {{count}}"
        }
    },
    "bulkDeviceImportDialog": {
        "title": "File Import",
        "instructions": "Using the dropdowns, map each column to the associated field to be imported for the creation of the new devices.",
        "import": "Import",
        "fileHasHeader": "File Has Header Row",
        "cancelConfirmation": "You are about to exit without selecting devices or columns to import."
    },
    "wellEditor": {
        "steps": {
            "properties": {
                "title": "Well Properties",
                "standardProperties": "Standard Properties",
                "wellName": "Well Name",
                "wellAPI": "Well API/UWI",
                "primaryProductType": "Primary Product Type",
                "liftType": "Lift Type",
                "liftController": "Lift Controller",
                "basin": "Basin",
                "field": "Field",
                "pad": "Pad",
                "location": "Location",
                "latitude": "Latitude",
                "longitude": "Longitude",
                "selectPrimaryProduct": "Select Primary Product",
                "selectLiftType": "Select Lift Type",
                "selectController": "Select Controller",
                "selectBasin": "Select Basin",
                "selectField": "Select Field",
                "selectPad": "Select Pad",
                "required": "Required",
                "nameMustBeUnique": "Name must be unique"
            },
            "selectDevices": {
                "title": "Select Devices",
                "instructions": "Please select the devices that will be included in the well object",
                "noDevices": {
                    "title": "There are no devices available that can be included in the well object."
                },
                "noFilteredDevices": {
                    "title": "There are no devices available that match the selected filter criteria."
                },
                "filterHint": "Filter by Device Name"
            },
            "selectTags": {
                "title": "Select Tags",
                "requiredTagsInstructions": "The following tags are required based on the specified Primary Product Type and Lift Type. Please select the device and associated tag that will be sourcing the data for each required tag.",
                "optionalTagsInstructions": "The following tags are optional based on the specified Primary Product Type and Lift Type. Please select the device and associated tag that will be sourcing the data for any optional tags you wish to include in the well.",
                "selectDevice": "Select Device",
                "selectAssociatedTag": "Select Associated Tag",
                "unassigned": "Unassigned"
            },
            "summary": {
                "title": "Summary",
                "wellConfiguration": "Well Configuration",
                "wellTagDetails": "Well Tag Details",
                "wellTagDescription": "These are required Tags that will be added directly to the Well",
                "deviceTagDetails": "Device Tag Details",
                "deviceTagDescription": "These are Device Tags that will be associated with Well",
                "tag": "Tag",
                "parentDevice": "Parent Device",
                "associatedTag": "Associated Tag",
                "instructions": "Please review and verify the above information is correct. Click Save Changes and you will be returned to the previous view."
            }
        },
        "exceptions": {
            "nameInUse": {
                "message": "A well with the specified name already exists. Please choose a different name.",
                "title": "Duplicate Names Are Not Allowed"
            }
        },
        "newWell": "New Well",
        "saveAsNew": "Save As New",
        "saveChanges": "Save Changes",
        "createWell": "Create Well",
        "saveConfirmation": "Well {{name}} has been saved"
    },
    "uiCustomizationPresetAdministration": {
        "tabs": {
            "presets": {
                "title": "Page Visibility Presets",
                "noData": {
                    "title": "There are no presets defined for the selected organization",
                    "text1": "You can add presets to this organization using the",
                    "text2": "button in the toolbar"
                },
                "noFilteredData": {
                    "title": "There are no presets for the selected organization that match the filter criteria"
                },
                "filterBy": "Filter by Name or Description",
                "deletePresetConfirmation": {
                    "title": "Warning: This action cannot be undone!",
                    "confirmationText": "Are you sure you want to delete this preset?",
                    "confirmationTextWithUsers": "This preset is currently assigned to {{userCount}} user(s). If deleted, all users to which this preset is assigned will revert to seeing all available views in their navigation menus."
                },
                "deletePresetAcknowledge": "Preset \"{{presetName}}\" has been deleted",
                "noMembers": {
                    "title": "No users have been assigned to this preset",
                    "text": "Select Edit in the menu to assign users"
                }
            }
        },
        "sortBy": "Sort by",
        "sortOptionsText": {
            "descriptionAsc": "Description (A to Z)",
            "descriptionDesc": "Description (Z to A)",
            "nameAsc": "Name (A to Z)",
            "nameDesc": "Name (Z to A)"
        }
    },
    "uiCustomizationPresetEditor": {
        "steps": {
            "general": {
                "title": "General",
                "name": "Preset Name",
                "nameRequired":"Name is required",
                "description": "Preset Description",
                "descriptionRequired": "Description is required",
                "presetInformation": "Preset Information"
            },
            "pageVisibility": {
                "title": "Page Visibility"
            },
            "membership": {
                "title": "Membership",
                "filter": "Filter by Name or Login",
                "filterByRoles": "Filter by Roles",
                "allRolesOption": "All Roles",
                "viewSelected": "View Selected Users",
                "noFilteredData": "There are no users that match the filter criteria"
            }
        },
        "saveSuccessMessage": "Preset \"{{name}}\" has been saved"
    }
}